<template>
  <div id="content">
    <div class="page-body">
      <!-- 集采结算管理 · 集采订单（墨刀布局） -->
      <template v-if="!supplierMode">
        <el-form :model="queryForm" size="small" label-width="100px" label-position="right" class="cp-settlement-form cp-settlement-filter-form demo-form-inline form-inline-list" @keyup.enter.native="onSearchQuery">
          <div class="cp-settlement-filter-row">
            <el-form-item label-width="0" label="" class="cp-settlement-item-no-label">
              <div class="cp-settlement-inline">
                <el-select v-model="queryForm.purchaseOrderKind" placeholder="类型" class="cp-settlement-kind-select">
                  <el-option label="采购订单" value="purchaseNo"/>
                  <el-option label="销售订单" value="salesOrderNo"/>
                  <el-option label="BMS业务单号" value="bmsBizOrderNo"/>
                </el-select>
                <el-input v-model="queryForm.purchaseKeywords" clearable :placeholder="purchaseKeywordsPlaceholder" class="cp-settlement-keyword-input"/>
              </div>
            </el-form-item>
            <el-form-item label="付款状态">
              <el-select v-model="queryForm.paymentStatuses" multiple filterable clearable collapse-tags placeholder="全部">
                  <el-option v-for="o in paymentStatusOptions" :key="'p'+o.value" :label="o.label" :value="o.value"/>
                </el-select>
            </el-form-item>
            <el-form-item label="供应商">
              <el-select v-model="queryForm.supplierCodes" multiple filterable clearable collapse-tags placeholder="请选择">
                  <el-option v-for="opt in settlementSupplierOptions" :key="'sf-' + opt.code" :label="formatCpFilterOptionLabel(opt)" :value="opt.code"/>
                </el-select>
            </el-form-item>
            <el-form-item label="付款主体">
              <el-select v-model="queryForm.paymentPayerCode" filterable clearable placeholder="请选择">
                  <el-option
                    v-for="(item, idx) in enterpriseInfoList"
                    :key="item.companyCode + '-' + idx"
                    :value="item.companyCode"
                    :label="formatEnterpriseLabel(item)"
                  />
                </el-select>
            </el-form-item>
            <el-form-item label="进项状态">
              <el-select v-model="queryForm.invoiceStatus" clearable placeholder="全部">
                  <el-option v-for="o in invoiceStatusFilterOptions" :key="'i'+o.value" :label="o.label" :value="o.value"/>
                </el-select>
            </el-form-item>
            <el-form-item label="客户名称">
              <el-select v-model="queryForm.customerCodes" multiple filterable clearable collapse-tags placeholder="请选择">
                  <el-option v-for="opt in settlementCustomerOptions" :key="'cf-' + opt.code" :label="formatCpFilterOptionLabel(opt)" :value="opt.code"/>
                </el-select>
            </el-form-item>
            <el-form-item label="一级销售组织">
              <el-select v-model="queryForm.salesOrgLevel1Code" filterable clearable placeholder="请选择">
                  <el-option
                    v-for="(item, idx) in enterpriseInfoList"
                    :key="'l1-' + item.companyCode + '-' + idx"
                    :value="item.companyCode"
                    :label="formatEnterpriseLabel(item)"
                  />
                </el-select>
            </el-form-item>
            <el-form-item label="二级销售组织">
              <el-select v-model="queryForm.salesOrgLevel2Code" filterable clearable placeholder="请选择">
                  <el-option
                    v-for="(item, idx) in enterpriseInfoList"
                    :key="'l2-' + item.companyCode + '-' + idx"
                    :value="item.companyCode"
                    :label="formatEnterpriseLabel(item)"
                  />
                </el-select>
            </el-form-item>
            <el-form-item label-width="0" label="" class="cp-settlement-item-no-label">
              <div class="cp-settlement-inline">
                <el-select v-model="dateFieldType" class="cp-settlement-date-type-select">
                  <el-option v-for="d in dateTypeOptions" :key="'st-' + d.value" :label="d.label" :value="d.value"/>
                </el-select>
                <el-date-picker
                  v-model="dateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                />
              </div>
            </el-form-item>
            <el-form-item label="采购金额">
              <div class="cp-settlement-inline cp-settlement-amount-range">
                <el-input v-model="queryForm.purAmountMin" clearable type="number" placeholder="最小"/>
                <span class="cp-settlement-amount-sep">-</span>
                <el-input v-model="queryForm.purAmountMax" clearable type="number" placeholder="最大"/>
              </div>
            </el-form-item>
            <el-form-item label="销项状态">
              <el-select v-model="queryForm.salesInvoiceStatus" clearable placeholder="全部">
                  <el-option v-for="o in salesInvoiceStatusFilterOptions" :key="'so'+o.value" :label="o.label" :value="o.value"/>
                </el-select>
            </el-form-item>
            <el-form-item label="回款状态">
              <el-select v-model="queryForm.returnMoneyStatus" clearable placeholder="全部">
                <el-option v-for="o in returnMoneyStatusFilterOptions" :key="'rm'+o.value" :label="o.label" :value="o.value"/>
              </el-select>
            </el-form-item>
            <!-- 调用业务模式多选：提交 businessModes IN 条件 -->
            <el-form-item label="业务模式">
              <el-select v-model="queryForm.businessModes" multiple filterable clearable collapse-tags placeholder="全部">
                <el-option v-for="o in businessModeOptions" :key="'bm-' + o.value" :label="o.label" :value="o.value"/>
              </el-select>
            </el-form-item>
            <!-- 调用创建人多选：选项来自 loadSettlementFilterOptions，提交 auditUserIds -->
            <el-form-item label="创建人">
              <el-select v-model="queryForm.auditUserIds" multiple filterable clearable collapse-tags placeholder="请选择">
                <el-option
                  v-for="opt in settlementAuditUserOptions"
                  :key="'au-' + opt.code"
                  :label="formatCpFilterOptionName(opt)"
                  :value="opt.code"
                />
              </el-select>
            </el-form-item>
          </div>
        </el-form>
        <div class="cp-settlement-actions">
          <el-button type="primary" size="small" :loading="loading" @click="onSearchQuery">查询</el-button>
          <el-button size="small" @click="resetQuery">重置</el-button>
          <!-- 调用处：结算端导出按钮权限 isShowSettlementExport -->
          <el-button v-if="isShowSettlementExport" size="small" @click="handleExport">导出{{ exportHint }}</el-button>
          <!-- 调用处：结算端批量创建销售按钮权限 isShowSettlementBatchCreateSales -->
          <el-button v-if="isShowSettlementBatchCreateSales" type="success" size="small" @click="openImportDialog">批量创建销售</el-button>
          <!-- 调用处：结算端客户回款按钮权限 isShowSettlementCustomerPayment（23130103） -->
          <el-button v-if="isShowSettlementCustomerPayment" type="warning" size="small" :disabled="!selectedRows.length" @click="openCustomerPaymentDialog">客户回款</el-button>
          <!-- 调用处：结算端销售合同上传按钮权限 isShowSettlementUploadSalesContract（23130104） -->
          <el-button v-if="isShowSettlementUploadSalesContract" type="primary" size="small" plain :disabled="!selectedRows.length" @click="openSalesContractUploadDialog">销售合同上传</el-button>
          <!-- 调用处：结算端客户签收单上传按钮权限 isShowSettlementUploadCustomerSign（23130105） -->
          <el-button v-if="isShowSettlementUploadCustomerSign" type="primary" size="small" plain :disabled="!selectedRows.length" @click="openCustomerSignUploadDialog">客户签收单上传</el-button>
        </div>
        <!-- 调用结算端生效状态页签切换：按 valid_flag 筛选（全部/已生效/OMS处理中） -->
        <el-tabs v-model="settlementValidFlagTab" class="cp-audit-tabs" @tab-click="onSettlementValidFlagTabChange">
          <el-tab-pane label="全部" name="all"/>
          <el-tab-pane label="已生效" name="effective"/>
          <el-tab-pane label="OMS处理中" name="oms"/>
        </el-tabs>
        <el-table :data="tableData" stripe border class="table-list" v-loading="loading" height="420" :header-cell-style="{ textAlign: 'center' }" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="48" align="center" fixed="left"/>
          <el-table-column label="序号" width="60" align="center" fixed="left">
            <template slot-scope="scope">
              <span class="cp-row-idx">{{ (pageNo - 1) * pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="88" align="center" fixed="left">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="openDetail(scope.row)">详情</el-button>
            </template>
          </el-table-column>
          <el-table-column label="采购单" min-width="280">
            <template slot-scope="{ row }">
              <div class="cp-po-cell">
                <!-- 上行：前缀蓝色、单号正文色（对齐墨刀） -->
                <div class="cp-po-tags-line">
                  <span v-if="row.salesOrderNo" class="cp-po-id-block">
                    <span class="cp-po-id-prefix">销</span><span class="cp-po-id-num">{{ row.salesOrderNo }}</span>
                  </span>
                  <span class="cp-po-id-block">
                    <span class="cp-po-id-prefix">采:</span><span class="cp-po-id-num">{{ row.purchaseNo || '—' }}</span>
                  </span>
                </div>
                <div class="cp-po-pills">
                  <span :class="pillClass(row, 'salesOut')">销项</span>
                  <span :class="pillClass(row, 'return')">回款</span>
                  <span :class="pillClass(row, 'input')">进项</span>
                  <span :class="pillClass(row, 'payReq')">付款</span>
                  <span :class="pillClass(row, 'sign')">签</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="采购订单日期" width="120" align="center">
            <template slot-scope="{ row }">
              <!-- 调用 formatDetailDate：采购订单日期仅展示 yyyy-MM-dd（仅 SAP 同步回写后才有值） -->
              {{ formatDetailDate(row.purchaseOrderDate) }}
            </template>
          </el-table-column>
          <el-table-column prop="purAmountWithTax" label="采购含税金额" width="120" align="right" :formatter="fmtAmount"/>
          <el-table-column label="进项金额" width="100" align="right">
            <template>—</template>
          </el-table-column>
          <el-table-column label="付款主体" class-name="cp-col-name" min-width="260" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ displaySettleCompany(row) }}</template>
          </el-table-column>
          <el-table-column label="供应商" class-name="cp-col-name" min-width="260" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ displaySupplier(row) }}</template>
          </el-table-column>
          <el-table-column label="采购合同" min-width="160" show-overflow-tooltip>
            <template slot-scope="{ row }">
              <!-- 调用 openPurchaseContractFile：有附件时显示合同编号可点击查看 -->
              <el-button
                v-if="row.contractFileUrl && displayPurchaseContractNo(row)"
                type="text"
                size="small"
                @click="openPurchaseContractFile(row)"
              >{{ displayPurchaseContractNo(row) }}</el-button>
              <span v-else>{{ displayPurchaseContractNo(row) || '—' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="签收单" width="88" align="center">
            <template slot-scope="{ row }">
              <el-button
                v-if="row.signFileUrl"
                type="text"
                size="small"
                @click="openFilePreview(row.signFileUrl)"
              >查看</el-button>
              <span v-else class="cp-muted">—</span>
            </template>
          </el-table-column>
          <el-table-column label="客户合同" min-width="160" show-overflow-tooltip>
            <template slot-scope="{ row }">
              <!-- 调用 openFilePreview：有销售合同附件时合同编码可点击查看 -->
              <el-button
                v-if="row.salesContractFileUrl && row.salesContractNo"
                type="text"
                size="small"
                @click="openFilePreview(row.salesContractFileUrl)"
              >{{ row.salesContractNo }}</el-button>
              <span v-else>{{ row.salesContractNo || '—' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="客户签收单" width="100" align="center">
            <template slot-scope="{ row }">
              <!-- 调用 openFilePreview：查看客户签收单附件 -->
              <el-button
                v-if="row.customerSignFileUrl"
                type="text"
                size="small"
                @click="openFilePreview(row.customerSignFileUrl)"
              >查看</el-button>
              <span v-else class="cp-muted">—</span>
            </template>
          </el-table-column>
          <el-table-column label="一级销售组织" class-name="cp-col-name" min-width="250" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ displaySalesOrgPrimary(row) }}</template>
          </el-table-column>
          <el-table-column label="二级销售组织" class-name="cp-col-name" min-width="250" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ displaySalesOrgSecondary(row) }}</template>
          </el-table-column>
          <el-table-column label="客户名称" class-name="cp-col-name" min-width="260" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ displayCustomer(row) }}</template>
          </el-table-column>
          <el-table-column prop="salesAmountWithTax" label="销售含税金额" width="120" align="right" :formatter="fmtAmount"/>
          <el-table-column prop="bmsBizOrderNo" label="BMS业务单号" min-width="190" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ row.bmsBizOrderNo || '—' }}</template>
          </el-table-column>
          <!-- 调用 displayBusinessMode：列表展示主表 business_mode -->
          <el-table-column label="业务模式" min-width="200" align="center" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ displayBusinessMode(row) }}</template>
          </el-table-column>
          <el-table-column label="创建人" min-width="100" align="center" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ row.createByName || '—' }}</template>
          </el-table-column>
          <el-table-column label="创建时间" width="170" align="center">
            <template slot-scope="{ row }">{{ formatDateTimeDisplay(row.createTime) }}</template>
          </el-table-column>
        </el-table>
      </template>

      <!-- 供应商门户 · 简化列表 -->
      <template v-else>
        <el-form :model="queryForm" size="small" label-width="120px" class="cp-settlement-form demo-form-inline form-inline-list" @keyup.enter.native="onSearchQuery">
          <div class="cp-settlement-row">
            <el-form-item label="采购单号">
              <el-input v-model="queryForm.purchaseKeywords" clearable placeholder="请输入，多个用空格或逗号隔开" class="cp-field-fill"/>
            </el-form-item>
            <el-form-item label="付款状态">
              <el-select v-model="queryForm.paymentStatuses" multiple filterable clearable collapse-tags placeholder="全部" class="cp-field-fill">
                <el-option v-for="o in paymentStatusOptions" :key="'sp-p'+o.value" :label="o.label" :value="o.value"/>
              </el-select>
            </el-form-item>
            <el-form-item label="付款主体">
              <el-select v-model="queryForm.paymentPayerCode" filterable clearable placeholder="请选择" class="cp-field-fill">
                <el-option
                  v-for="(item, idx) in enterpriseInfoList"
                  :key="'sp-src-' + item.companyCode + '-' + idx"
                  :value="item.companyCode"
                  :label="formatEnterpriseLabel(item)"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="发票状态">
              <el-select v-model="queryForm.invoiceStatus" clearable placeholder="全部" class="cp-field-fill">
                <el-option v-for="o in invoiceStatusFilterOptions" :key="'sp-i'+o.value" :label="o.label" :value="o.value"/>
              </el-select>
            </el-form-item>
            <el-form-item label="合同编号">
              <el-input v-model="queryForm.salesOrderNo" clearable placeholder="请输入，多个用空格或逗号隔开" class="cp-field-fill"/>
            </el-form-item>
          </div>
          <div class="cp-settlement-row">
            <el-form-item label="客户名称">
              <el-select v-model="queryForm.customerCodes" multiple filterable clearable collapse-tags placeholder="请选择" class="cp-field-fill">
                <!-- 调用 formatCpFilterOptionName：供应商门户下拉仅展示名称 -->
                <el-option v-for="opt in settlementCustomerOptions" :key="'sp-cf-' + opt.code" :label="formatCpFilterOptionName(opt)" :value="opt.code"/>
              </el-select>
            </el-form-item>
            <!-- 调用 supplierPortalSellerOptions：销售方即供应商，提交 supplierCodes -->
            <el-form-item label="销售方">
              <el-select v-model="queryForm.supplierCodes" multiple filterable clearable collapse-tags placeholder="请选择" class="cp-field-fill">
                <el-option v-for="opt in supplierPortalSellerOptions" :key="'sp-sf-' + opt.code" :label="formatCpFilterOptionLabel(opt)" :value="opt.code"/>
              </el-select>
            </el-form-item>
            <el-form-item label="合同状态">
              <el-select v-model="queryForm.contractStatus" clearable placeholder="全部" class="cp-field-fill">
                <el-option label="待发起" :value="0"/>
                <el-option label="签署中" :value="1"/>
                <el-option label="已签署" :value="2"/>
              </el-select>
            </el-form-item>
          </div>
          <div class="cp-settlement-row">
            <!-- 调用处：日期维度 + 区间；label 固定为「日期」，类型在框内切换 -->
            <el-form-item label="日期" class="cp-form-item--date-combo">
              <div class="cp-inline">
                <el-select v-model="dateFieldType" style="width: 100px">
                  <el-option v-for="d in dateTypeOptions" :key="'sp-' + d.value" :label="d.label" :value="d.value"/>
                </el-select>
                <el-date-picker
                  v-model="dateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  class="cp-flex-1"
                />
              </div>
            </el-form-item>
            <el-form-item label="BMS业务单号">
              <el-input v-model="queryForm.bmsBizOrderNo" clearable placeholder="请输入" class="cp-field-fill"/>
            </el-form-item>
          </div>
        </el-form>
        <div class="cp-settlement-actions">
          <el-button type="primary" size="small" :loading="loading" @click="onSearchQuery">查询</el-button>
          <!-- 调用处：供应商门户导出按钮权限 isShowSupplierExport -->
          <el-button v-if="isShowSupplierExport" size="small" @click="handleExport">导出{{ exportHint }}</el-button>
          <!-- 调用处：供应商门户生成合同模版按钮权限 isShowSupplierGenerateContract（260518） -->
          <el-button v-if="isShowSupplierGenerateContract" size="small" @click="openGenerateContractDialog">生成合同模版</el-button>
          <!-- 调用处：供应商门户批量上传合同按钮权限 isShowSupplierBatchUploadContract（260519） -->
          <el-button v-if="isShowSupplierBatchUploadContract" size="small" @click="openBatchUploadContractDialog">批量上传合同</el-button>
          <!-- 调用处：供应商门户确认签收按钮权限 isShowSupplierConfirmSign（260520） -->
          <el-button v-if="isShowSupplierConfirmSign" size="small" @click="openSignDialog">确认签收</el-button>
          <!-- 调用处：供应商门户登记发票按钮权限 isShowSupplierRegisterInvoice（260521）；无勾选时禁用 -->
          <el-button v-if="isShowSupplierRegisterInvoice" size="small" :disabled="!selectedRows.length" @click="openInvoiceDialog">登记发票</el-button>
        </div>
        <!-- 调用供应商页签切换方法：按发票状态筛选全部/待开票/已开票 -->
        <el-tabs v-model="supplierInvoiceTab" class="cp-audit-tabs" @tab-click="onSupplierInvoiceTabChange">
          <el-tab-pane label="全部" name="all"/>
          <el-tab-pane label="待开票" name="pending"/>
          <el-tab-pane label="已开票" name="invoiced"/>
        </el-tabs>
        <el-table :data="tableData" stripe border class="table-list" v-loading="loading" height="420" :header-cell-style="{ textAlign: 'center' }" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="48" align="center" fixed="left"/>
          <el-table-column label="序号" width="60" align="center" fixed="left">
            <template slot-scope="scope">
              <span class="cp-row-idx">{{ (pageNo - 1) * pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="purchaseNo" label="集采订单" min-width="130" show-overflow-tooltip/>
          <el-table-column label="采购订单日期" width="120" align="center">
            <template slot-scope="{ row }">
              <!-- 调用 formatDetailDate：采购订单日期仅展示 yyyy-MM-dd（仅 SAP 同步回写后才有值） -->
              {{ formatDetailDate(row.purchaseOrderDate) }}
            </template>
          </el-table-column>
          <el-table-column prop="purAmountWithTax" label="订单含税金额" width="120" align="right" :formatter="fmtAmount"/>
          <el-table-column label="合同状态" width="90" align="center">
            <template slot-scope="{ row }">{{ contractStatusText(row.contractStatus) }}</template>
          </el-table-column>
          <el-table-column prop="contractSignDate" label="合同签订日期" width="120" align="center">
            <template slot-scope="{ row }">{{ formatDetailDate(row.contractSignDate) }}</template>
          </el-table-column>
          <el-table-column label="合同编号" min-width="160" show-overflow-tooltip>
            <template slot-scope="{ row }">
              <!-- 调用 openPurchaseContractFile：有附件时合同编号可点击查看 -->
              <el-button
                v-if="row.contractFileUrl && displayPurchaseContractNo(row)"
                type="text"
                size="small"
                @click="openPurchaseContractFile(row)"
              >{{ displayPurchaseContractNo(row) }}</el-button>
              <span v-else>{{ displayPurchaseContractNo(row) || '—' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="发票状态" width="90" align="center">
            <template slot-scope="{ row }">{{ invoiceStatusText(row.invoiceStatus) }}</template>
          </el-table-column>
          <el-table-column label="发票金额" width="90" align="right">
            <template>—</template>
          </el-table-column>
          <!-- 供应商门户：采购方/销售方加宽并完整展示 code-name -->
          <el-table-column label="采购方" class-name="cp-col-party-full" min-width="280" align="left">
            <template slot-scope="{ row }">{{ displaySettleCompany(row) }}</template>
          </el-table-column>
          <el-table-column label="销售方" class-name="cp-col-party-full" min-width="280" align="left">
            <template slot-scope="{ row }">{{ displaySupplier(row) }}</template>
          </el-table-column>
          <el-table-column label="签收单" width="88" align="center">
            <template slot-scope="{ row }">
              <el-button
                v-if="row.signFileUrl"
                type="text"
                size="small"
                @click="openFilePreview(row.signFileUrl)"
              >查看</el-button>
              <span v-else class="cp-muted">—</span>
            </template>
          </el-table-column>
          <el-table-column prop="bmsBizOrderNo" label="BMS业务单号" min-width="190" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ row.bmsBizOrderNo || '—' }}</template>
          </el-table-column>
        </el-table>
      </template>

      <div class="clear pagination-wrapper">
        <div class="fl total-price-list">
          <!-- 调用 formatAmount：供应商门户只展示当前筛选合计金额 -->
          <p v-if="supplierMode">
            <span>合计金额：{{ formatAmount(listTotalAmount) }}</span>
          </p>
          <!-- 调用 selectedSalesAmount / selectedPurAmount：结算端勾选合计 + 筛选合计 -->
          <template v-else>
            <p>
              <span>勾选销货合计：{{ formatAmount(selectedSalesAmount) }}</span>
              <span>勾选采购合计：{{ formatAmount(selectedPurAmount) }}</span>
            </p>
            <p>
              <span>销货合计：{{ formatAmount(listTotalAmount2) }}</span>
              <span>采购合计：{{ formatAmount(listTotalAmount) }}</span>
            </p>
          </template>
        </div>
        <div class="fr">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next"
            :page-sizes="[20, 50, 100, 500, 1000]"
            :current-page="pageNo"
            :page-size="pageSize"
            :total="totalCount"
            @size-change="onSizeChange"
            @current-change="onPageChange"
          />
        </div>
      </div>
      <!-- 导入数据弹窗：两步式（下载模板 + 上传数据） -->
      <el-dialog
        :visible.sync="importDialogVisible"
        width="540px"
        append-to-body
        custom-class="cp-import-dialog"
        :close-on-click-modal="false"
        :show-close="true"
        @close="closeImportDialog"
      >
        <div slot="title" class="cp-import-title">
          <i class="el-icon-upload2 cp-import-title-icon"/>
          <div class="cp-import-title-text">
            <div class="cp-import-title-main">导入数据</div>
            <div class="cp-import-title-sub">支持 Excel 格式文件</div>
          </div>
        </div>
        <div class="cp-import-body">
          <!-- 第一步：下载导入模板 -->
          <div class="cp-import-step">
            <div class="cp-import-step-title">第一步：下载导入模板</div>
            <div class="cp-import-template-row">
              <div class="cp-import-template-info">
                <i class="el-icon-document cp-import-template-icon"/>
                <span class="cp-import-template-name">集采订单导入模板.xlsx</span>
              </div>
              <el-button type="primary" size="small" :loading="cpImportTemplateLoading" @click="downloadCpImportTemplate">
                <i class="el-icon-download"/>&nbsp;下载模板
              </el-button>
            </div>
          </div>
          <!-- 第二步：上传数据文件 -->
          <div class="cp-import-step">
            <div class="cp-import-step-title">第二步：上传数据文件</div>
            <!-- 调用拖放/点击选择文件方法：通过隐藏 input 触发文件选择 -->
            <div
              v-if="!importFile"
              class="cp-import-drop"
              :class="{ 'is-drag': importDragOver }"
              role="button"
              tabindex="0"
              @click="onImportDropClick"
              @keyup.enter="onImportDropClick"
              @dragover.prevent="onImportDragOver"
              @dragleave.prevent="onImportDragLeave"
              @drop.prevent="onImportDrop"
            >
              <i class="el-icon-upload cp-import-drop-icon"/>
              <div class="cp-import-drop-main">点击或拖拽文件到此处上传</div>
              <div class="cp-import-drop-sub">支持 .xlsx, .xls 格式，文件大小不超过 10MB</div>
            </div>
            <div v-else class="cp-import-file">
              <i class="el-icon-document cp-import-file-icon"/>
              <span class="cp-import-file-name">{{ importFile.name }}</span>
              <span class="cp-import-file-size">{{ formatImportFileSize(importFile.size) }}</span>
              <i class="el-icon-close cp-import-file-remove" @click="removeImportFile"/>
            </div>
            <input
              ref="cpImportInput"
              type="file"
              accept=".xlsx,.xls"
              class="cp-import-input-hidden"
              @change="onImportFileSelect"
            />
          </div>
          <!-- 导入说明 -->
          <div class="cp-import-tips">
            <div class="cp-import-tips-title"><i class="el-icon-info"/>&nbsp;导入说明：</div>
            <ul class="cp-import-tips-list">
              <li>请确保数据格式与模板一致</li>
              <li>单次最多 5000 条数据</li>
              <li>重复数据将自动跳过</li>
            </ul>
          </div>
        </div>
        <span slot="footer" class="cp-import-footer">
          <el-button size="small" @click="closeImportDialog">取消</el-button>
          <el-button type="primary" size="small" :loading="cpImportLoading" :disabled="!importFile" @click="confirmImport">
            <i class="el-icon-upload2"/>&nbsp;开始导入
          </el-button>
        </span>
      </el-dialog>
      <el-dialog title="导出数据" :visible.sync="exportDialogVisible" width="520px" append-to-body custom-class="cp-order-export-dialog">
        <div class="cp-export-options">
          <div
            class="cp-export-card"
            :class="{ 'is-active': exportLedgerScope === 'main' }"
            role="button"
            tabindex="0"
            @click="exportLedgerScope = 'main'"
            @keyup.enter="exportLedgerScope = 'main'"
          >
            <span class="cp-export-radio" :class="{ 'is-checked': exportLedgerScope === 'main' }"/>
            <div class="cp-export-card-body">
              <div class="cp-export-title">仅采购单</div>
              <div class="cp-export-desc">仅包含采购单主表信息</div>
            </div>
          </div>
          <div
            class="cp-export-card"
            :class="{ 'is-active': exportLedgerScope === 'mainAndItems' }"
            role="button"
            tabindex="0"
            @click="exportLedgerScope = 'mainAndItems'"
            @keyup.enter="exportLedgerScope = 'mainAndItems'"
          >
            <span class="cp-export-radio" :class="{ 'is-checked': exportLedgerScope === 'mainAndItems' }"/>
            <div class="cp-export-card-body">
              <div class="cp-export-title">采购单 + 物料明细</div>
              <div class="cp-export-desc">包含采购单及物料明细信息</div>
            </div>
          </div>
        </div>
        <div slot="footer" class="cp-export-footer">
          <el-button @click="exportDialogVisible = false">取消</el-button>
          <!-- 弹窗内确认：提交异步导出（含 includeOrderItemSheet） -->
          <el-button type="primary" class="cp-export-confirm" :loading="exportLoading" @click="confirmOrderLedgerExport">确认导出</el-button>
        </div>
      </el-dialog>
      <el-drawer
        :visible.sync="detailVisible"
        direction="rtl"
        size="90%"
        append-to-body
        :destroy-on-close="true"
        :wrapper-closable="true"
        custom-class="cp-order-detail-drawer"
        @close="onDetailDialogClose"
      >
        <template slot="title">
          <div class="cp-detail-dialog-title">
            <span class="cp-detail-dialog-title-text">详情</span>
            <div class="cp-detail-dialog-title-actions">
              <!-- 调用详情上一条方法：切换至列表中的前一条 -->
              <el-button size="mini" :disabled="detailRowIndex <= 0" @click.stop="detailPrev">上一条</el-button>
              <!-- 调用详情下一条方法：切换至列表中的后一条 -->
              <el-button
                type="primary"
                size="mini"
                :disabled="detailRowIndex < 0 || detailRowIndex >= tableData.length - 1"
                @click.stop="detailNext"
              >下一条</el-button>
            </div>
          </div>
        </template>
        <div v-if="detail && detail.mainOrder" class="cp-detail-body">
          <div class="cp-detail-head">
            <div class="cp-detail-order-no">{{ detail.mainOrder.purchaseNo || '—' }}</div>
            <div class="cp-detail-pills">
              <span :class="pillClass(detailPillRow, 'salesOut')">销项</span>
              <span :class="pillClass(detailPillRow, 'return')">回款</span>
              <span :class="pillClass(detailPillRow, 'input')">进项</span>
              <span :class="pillClass(detailPillRow, 'payReq')">付款</span>
              <span :class="pillClass(detailPillRow, 'sign')">签</span>
            </div>
            <div class="cp-detail-meta-line">
              <span>BMS业务单号: {{ formatDetailDisplay(detail.mainOrder.bmsBizOrderNo) }}</span>
              <span>销售单号: {{ formatDetailDisplay(detail.mainOrder.salesOrderNo) }}</span>
              <span>采购订单日期: {{ formatDetailDate(detail.mainOrder.purchaseOrderDate) }}</span>
              <span>原采购单: {{ formatDetailDisplay(detail.mainOrder.companyTransferOrderNo) }}</span>
              <span>创建人: {{ formatDetailDisplay(detail.mainOrder.createByName) }}</span>
              <span>创建时间: {{ formatDateTimeDisplay(detail.mainOrder.createTime) }}</span>
            </div>
            <div class="cp-detail-metrics">
              <div class="cp-detail-metric">
                <div class="cp-detail-metric-num">{{ formatDetailMoneyNum(detail.mainOrder.purAmountWithTax) }}</div>
                <div class="cp-detail-metric-label">采购单金额</div>
              </div>
              <div class="cp-detail-metric">
                <div class="cp-detail-metric-num">{{ formatDetailMoneyNum(detailSummaryPendingPay) }}</div>
                <div class="cp-detail-metric-label">待支付金额（元）</div>
              </div>
              <div class="cp-detail-metric">
                <div class="cp-detail-metric-num">{{ formatDetailMoneyNum(detailSummaryPaidAmount) }}</div>
                <div class="cp-detail-metric-label">已支付金额（元）</div>
              </div>
              <div class="cp-detail-metric">
                <div class="cp-detail-metric-num">{{ formatDetailMoneyNum(detail.mainOrder.salesAmountWithTax) }}</div>
                <div class="cp-detail-metric-label">销售单金额（元）</div>
              </div>
              <div class="cp-detail-metric">
                <div class="cp-detail-metric-num">{{ formatDetailMoneyNum(detailExtSafe.customerPaymentAmount) }}</div>
                <div class="cp-detail-metric-label">客户回款金额（元）</div>
              </div>
            </div>
          </div>
          <el-tabs v-model="detailActiveTab" type="card" class="cp-detail-tabs content-tabs cp-ledger-content-tabs" @tab-click="onDetailTabClick">
            <el-tab-pane label="基础信息" name="basic">
              <div class="bill-table-head">采购信息</div>
              <table class="cp-detail-grid" border="0" cellspacing="0" cellpadding="0">
                <tbody>
                  <tr>
                    <td class="cp-dg-label">付款主体编码</td>
                    <td class="cp-dg-val">{{ formatDetailDisplay(detail.mainOrder.paymentPayerCode) }}</td>
                    <td class="cp-dg-label">付款主体名称</td>
                    <td class="cp-dg-val">{{ formatDetailDisplay(detail.mainOrder.paymentPayerName) }}</td>
                    <td class="cp-dg-label">供应商编码</td>
                    <td class="cp-dg-val">{{ formatDetailDisplay(detail.mainOrder.supplierCode) }}</td>
                    <td class="cp-dg-label">供应商</td>
                    <td class="cp-dg-val">{{ formatDetailDisplay(detail.mainOrder.supplierName) }}</td>
                  </tr>
                  <tr>
                    <td class="cp-dg-label">采购合同签订日期</td>
                    <td class="cp-dg-val">{{ formatDetailDate(detailPurchaseContractSafe.contractSignDate) }}</td>
                    <td class="cp-dg-label">采购合同编码</td>
                    <td class="cp-dg-val">
                      <!-- 调用 openPurchaseContractFile：合同编号可点击查看采购合同附件 -->
                      <el-button
                        v-if="detailPurchaseContractSafe.contractFileUrl && displayPurchaseContractNo(detailPurchaseContractSafe, detailExtSafe)"
                        type="text"
                        size="small"
                        @click="openFilePreview(detailPurchaseContractSafe.contractFileUrl)"
                      >{{ displayPurchaseContractNo(detailPurchaseContractSafe, detailExtSafe) }}</el-button>
                      <span v-else>{{ displayPurchaseContractNo(detailPurchaseContractSafe, detailExtSafe) || '—' }}</span>
                    </td>
                    <td class="cp-dg-label">采购合同金额</td>
                    <td class="cp-dg-val">{{ formatDetailDisplay(detail.mainOrder.salesContractAmountWithTax) }}</td>
                    <td class="cp-dg-label">采购合同附件</td>
                    <td class="cp-dg-val">—</td>
                  </tr>
                  <tr>
                    <td class="cp-dg-label">签收日期</td>
                    <td class="cp-dg-val">{{ formatDetailDate(detailExtSafe.signDate) }}</td>
                    <td class="cp-dg-label">签收附件</td>
                    <td class="cp-dg-val">
                      <el-button v-if="detailExtSafe.signFileUrl" type="text" size="small" @click="openFilePreview(detailExtSafe.signFileUrl)">查看</el-button>
                      <span v-else>—</span>
                    </td>
                    <td class="cp-dg-label">进项状态</td>
                    <td class="cp-dg-val">{{ invoiceStatusText(detailExtSafe.invoiceStatus) }}</td>
                    <td class="cp-dg-label">进项发票号码</td>
                    <td class="cp-dg-val">—</td>
                  </tr>
                  <tr>
                    <td class="cp-dg-label">发票会计凭证</td>
                    <td class="cp-dg-val">—</td>
                    <td class="cp-dg-label">付款状态</td>
                    <td class="cp-dg-val">{{ paymentStatusDetailText(detailExtSafe.paymentStatus) }}</td>
                    <td class="cp-dg-label"/>
                    <td class="cp-dg-val"/>
                    <td class="cp-dg-label"/>
                    <td class="cp-dg-val"/>
                  </tr>
                </tbody>
              </table>
              <div class="bill-table-head cp-ledger-bill-head-spaced">销售信息</div>
              <table class="cp-detail-grid" border="0" cellspacing="0" cellpadding="0">
                <tbody>
                  <tr>
                    <td class="cp-dg-label">一级销售组织代码</td>
                    <td class="cp-dg-val">{{ formatDetailDisplay(detail.mainOrder.salesOrgCode) }}</td>
                    <td class="cp-dg-label">一级销售组织名称</td>
                    <td class="cp-dg-val">{{ formatDetailDisplay(detail.mainOrder.salesOrgName) }}</td>
                    <td class="cp-dg-label">二级销售组织代码</td>
                    <td class="cp-dg-val">{{ formatDetailDisplay(detail.mainOrder.secondSalesOrgCode) }}</td>
                    <td class="cp-dg-label">二级销售组织名称</td>
                    <td class="cp-dg-val">{{ formatDetailDisplay(detail.mainOrder.secondSalesOrgName) }}</td>
                  </tr>
                  <tr>
                    <td class="cp-dg-label">销售合同编码</td>
                    <td class="cp-dg-val">
                      <!-- 调用 openFilePreview：有销售合同附件时编码加超链接 -->
                      <el-button
                        v-if="detail.mainOrder.salesContractFileUrl && detail.mainOrder.salesContractNo"
                        type="text"
                        size="small"
                        @click="openFilePreview(detail.mainOrder.salesContractFileUrl)"
                      >{{ detail.mainOrder.salesContractNo }}</el-button>
                      <span v-else>{{ formatDetailDisplay(detail.mainOrder.salesContractNo) }}</span>
                    </td>
                    <td class="cp-dg-label">销售合同日期</td>
                    <td class="cp-dg-val">{{ formatDetailDate(detail.mainOrder.salesContractSignDate) }}</td>
                    <td class="cp-dg-label">客户收货地址</td>
                    <td class="cp-dg-val" colspan="3">{{ formatDetailDisplay(detail.mainOrder.customerDeliveryAddress) }}</td>
                  </tr>
                  <tr>
                    <td class="cp-dg-label">客户编码</td>
                    <td class="cp-dg-val">{{ formatDetailDisplay(detail.mainOrder.customerCode) }}</td>
                    <td class="cp-dg-label">客户名称</td>
                    <td class="cp-dg-val">{{ formatDetailDisplay(detail.mainOrder.customerName) }}</td>
                    <td class="cp-dg-label">销项票状态</td>
                    <td class="cp-dg-val">{{ invoiceStatusText(detailExtSafe.salesInvoiceStatus) }}</td>
                    <td class="cp-dg-label">销项发票号码</td>
                    <td class="cp-dg-val">{{ formatDetailDisplay(detailExtSafe.salesInvoiceNo) }}</td>
                  </tr>
                  <tr>
                    <td class="cp-dg-label">回款单号</td>
                    <td class="cp-dg-val">{{ formatDetailDisplay(detailExtSafe.returnOrderNo) }}</td>
                    <td class="cp-dg-label">回款日期</td>
                    <td class="cp-dg-val">{{ formatDetailDate(detailExtSafe.returnDate) }}</td>
                    <td class="cp-dg-label">客户回款状态</td>
                    <td class="cp-dg-val">{{ returnMoneyStatusDetailText(detailExtSafe.returnMoneyStatus) }}</td>
                    <td class="cp-dg-label">客户回款金额</td>
                    <td class="cp-dg-val">{{ formatDetailDisplay(detailExtSafe.customerPaymentAmount) }}</td>
                  </tr>
                  <tr>
                    <td class="cp-dg-label">回款方式</td>
                    <td class="cp-dg-val">{{ formatDetailDisplay(detailExtSafe.customerPaymentType) }}</td>
                    <td class="cp-dg-label">回款凭证</td>
                    <td class="cp-dg-val">{{ formatDetailDisplay(detailExtSafe.returnVoucherNo) }}</td>
                    <td class="cp-dg-label">客户签收单</td>
                    <td class="cp-dg-val">
                      <!-- 调用 openFilePreview：详情查看客户签收单附件 -->
                      <el-button
                        v-if="detail.mainOrder.customerSignFileUrl"
                        type="text"
                        size="small"
                        @click="openFilePreview(detail.mainOrder.customerSignFileUrl)"
                      >查看</el-button>
                      <span v-else>—</span>
                    </td>
                    <td class="cp-dg-label"/>
                    <td class="cp-dg-val"/>
                  </tr>
                </tbody>
              </table>
            </el-tab-pane>
            <el-tab-pane label="订单明细" name="items">
              <div class="bill-table-head">订单明细<span v-if="detailItemListCount">（共 {{ detailItemListCount }} 行）</span></div>
              <!-- 调用 detailItemTableMaxHeight：按 itemList 行数自适应高度，避免固定 360px 只露出约 8 行 -->
              <el-table
                ref="detailItemTable"
                :data="detail.itemList || []"
                size="small"
                stripe
                border
                :max-height="detailItemTableMaxHeight"
                class="table-list cp-detail-list-table"
              >
                <el-table-column prop="itemNo" label="行号" width="70"/>
                <el-table-column prop="materialCode" label="物料编码" min-width="110"/>
                <el-table-column prop="materialName" label="物料名称" min-width="120" show-overflow-tooltip/>
                <el-table-column prop="quantity" label="数量" width="80" align="right"/>
                <el-table-column prop="purUnitPriceWithTax" label="采购含税单价" width="110" align="right"/>
                <el-table-column prop="purAmountWithTax" label="采购含税金额" width="110" align="right"/>
                <el-table-column prop="salesUnitPriceWithTax" label="销售含税单价" width="110" align="right"/>
                <el-table-column prop="salesAmountWithTax" label="销售含税金额" width="110" align="right"/>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="支付记录" name="payment">
              <div v-loading="detailPaymentRecordsLoading" class="cp-detail-payment-panel">
                <div class="bill-table-head">汇总付款单</div>
                <div class="cp-detail-payment-summary-line">
                  采购单支付金额：{{ formatDetailMoneyNum(detailPaymentRecords.paymentPayAmountTotal) }}
                </div>
                <el-table
                  :data="detailPaymentRecords.paymentSummaryRows || []"
                  size="small"
                  stripe
                  border
                  class="table-list cp-detail-payment-table"
                  max-height="260"
                  empty-text="暂无汇总付款单"
                >
                  <el-table-column prop="paymentNo" label="付款单" min-width="140" show-overflow-tooltip/>
                  <el-table-column label="付款单金额" width="120" align="right">
                    <template slot-scope="{ row }">{{ formatDetailMoneyNum(row.paymentAmount) }}</template>
                  </el-table-column>
                  <el-table-column label="采购单本次支付金额" width="160" align="right">
                    <template slot-scope="{ row }">{{ formatDetailMoneyNum(row.currentPayAmount) }}</template>
                  </el-table-column>
                  <el-table-column label="状态" width="110" align="center">
                    <template slot-scope="{ row }">{{ formatPaymentOrderStatus(row.status, row.statusName) }}</template>
                  </el-table-column>
                  <el-table-column prop="creatorName" label="创建人" min-width="100" show-overflow-tooltip>
                    <template slot-scope="{ row }">{{ row.creatorName || '—' }}</template>
                  </el-table-column>
                  <el-table-column label="创建时间" width="170" align="center">
                    <template slot-scope="{ row }">{{ formatDateTimeDisplay(row.createTime) }}</template>
                  </el-table-column>
                </el-table>

                <div class="bill-table-head cp-ledger-bill-head-spaced">预付单</div>
                <div class="cp-detail-payment-summary-line">
                  采购单核销金额：{{ formatDetailMoneyNum(detailPaymentRecords.prepayVerifyAmountTotal) }}
                </div>
                <el-table
                  :data="detailPaymentRecords.prepayVerifyRows || []"
                  size="small"
                  stripe
                  border
                  class="table-list cp-detail-payment-table"
                  max-height="260"
                  empty-text="暂无预付单"
                >
                  <el-table-column prop="prepayNo" label="预付单" min-width="140" show-overflow-tooltip/>
                  <el-table-column label="预付金额" width="120" align="right">
                    <template slot-scope="{ row }">{{ formatDetailMoneyNum(row.prepayAmount) }}</template>
                  </el-table-column>
                  <el-table-column label="采购单本次核销金额" width="160" align="right">
                    <template slot-scope="{ row }">{{ formatDetailMoneyNum(row.verifyAmount) }}</template>
                  </el-table-column>
                  <el-table-column prop="verifierName" label="核销人" min-width="100" show-overflow-tooltip>
                    <template slot-scope="{ row }">{{ row.verifierName || '—' }}</template>
                  </el-table-column>
                  <el-table-column label="核销时间" width="170" align="center">
                    <template slot-scope="{ row }">{{ formatDateTimeDisplay(row.verifyTime) }}</template>
                  </el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
            <el-tab-pane label="操作日志" name="log">
              <div class="bill-table-head">操作日志</div>
              <el-table
                :data="detailOperateLogs"
                size="small"
                stripe
                border
                max-height="360"
                class="table-list cp-detail-list-table"
                v-loading="detailOperateLogsLoading"
                empty-text="暂无操作日志"
              >
                <el-table-column label="操作时间" width="170" align="center">
                  <template slot-scope="{ row }">{{ formatDateTimeDisplay(row.operaterTime || row.createTime) }}</template>
                </el-table-column>
                <el-table-column prop="operater" label="操作人" min-width="120" show-overflow-tooltip>
                  <template slot-scope="{ row }">{{ row.operater || '—' }}</template>
                </el-table-column>
                <el-table-column label="操作类型" min-width="160" show-overflow-tooltip>
                  <template slot-scope="{ row }">{{ operateLogTypeText(row) }}</template>
                </el-table-column>
                <el-table-column prop="subOperateDesc" label="操作描述" min-width="260" show-overflow-tooltip>
                  <template slot-scope="{ row }">{{ row.subOperateDesc || row.operateResult || '—' }}</template>
                </el-table-column>
              </el-table>
              <el-pagination
                style="margin-top: 10px; text-align: right"
                background
                layout="total, sizes, prev, pager, next"
                :page-sizes="[10, 20, 50]"
                :current-page="detailOperateLogPageNo"
                :page-size="detailOperateLogPageSize"
                :total="detailOperateLogTotal"
                @size-change="onDetailOperateLogSizeChange"
                @current-change="onDetailOperateLogPageChange"
              />
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-drawer>
      <el-dialog title="生成合同模版" :visible.sync="generateContractVisible" width="420px" append-to-body>
        <el-form :model="generateContractForm" size="small" label-width="88px">
          <el-form-item label="签署日期">
            <el-date-picker
              v-model="generateContractForm.contractSignDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择签署日期"
              style="width: 100%"
            />
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button size="small" @click="generateContractVisible = false">取消</el-button>
          <el-button type="primary" size="small" :loading="generateContractLoading" @click="submitGenerateContractTemplate">确定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="批量上传合同" :visible.sync="batchUploadContractVisible" width="1120px" append-to-body custom-class="cp-batch-upload-contract-dialog" @closed="resetBatchUploadContractDialog">
        <el-upload
          ref="batchUploadContractUpload"
          :key="batchUploadContractUploadKey"
          drag
          multiple
          action=""
          :auto-upload="false"
          :show-file-list="false"
          :on-change="onBatchContractFileChange"
        >
          <i class="el-icon-upload"/>
          <div class="el-upload__text">拖拽文件到此处，或<em>点击选择多个文件</em></div>
          <div slot="tip" class="el-upload__tip">
            已勾选 {{ selectedRows.length }} 个订单，需上传 {{ selectedRows.length }} 份合同（一对一，不多不少）
          </div>
          <div slot="tip" class="el-upload__tip" v-if="selectedRows && selectedRows.length > 1">文件名格式：采购单号-合同编号.xxx，例如 9210000389-LSG-QX20260608001.pdf</div>
          <div slot="tip" class="el-upload__tip" v-else>文件名格式：合同编号.xxx，例如 LSG-QX20260608001.pdf</div>
        </el-upload>
        <el-table :data="batchUploadContractRows" border size="mini" class="cp-batch-upload-contract-table" style="margin-top: 12px" max-height="280">
          <el-table-column prop="fileName" label="文件名" min-width="260" show-overflow-tooltip/>
          <el-table-column prop="purchaseNo" label="采购单号" min-width="130" show-overflow-tooltip/>
          <el-table-column label="合同编号" min-width="220">
            <template slot-scope="{ row }">
              <!-- 调用 onBatchContractNoInput：合同编号可编辑，变更时联动签署日期 -->
              <el-input
                v-model="row.contractNo"
                size="mini"
                clearable
                placeholder="必填"
                @input="onBatchContractNoInput(row)"
              />
            </template>
          </el-table-column>
          <el-table-column label="签署日期" min-width="168">
            <template slot-scope="{ row }">
              <el-date-picker
                v-model="row.contractSignDate"
                type="date"
                size="mini"
                value-format="yyyy-MM-dd"
                placeholder="必选"
                style="width: 100%"
              />
            </template>
          </el-table-column>
          <el-table-column label="结果" min-width="140" show-overflow-tooltip>
            <template slot-scope="{ row }">
              <span :class="row.valid ? 'cp-upload-ok' : 'cp-upload-error'">{{ row.message }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="removeBatchContractRow(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer">
          <el-button size="small" @click="batchUploadContractVisible = false">取消</el-button>
          <el-button type="primary" size="small" :loading="batchUploadContractLoading" @click="submitBatchUploadContract">提交</el-button>
        </span>
      </el-dialog>
      <!-- 结算端回款维护弹框 cpSettlementSalePurchaseOrder：只填回款金额，回款状态提交时按金额与销售金额推导 -->
      <el-dialog title="回款维护" :visible.sync="customerPaymentVisible" width="560px" append-to-body custom-class="cp-customer-payment-dialog">
        <div class="cp-customer-payment-head">
          <div class="cp-customer-payment-field">
            <span class="cp-customer-payment-label">销售单</span>
            <span class="cp-customer-payment-value">{{ customerPaymentForm.salesOrderNo || '—' }}</span>
          </div>
          <div class="cp-customer-payment-field">
            <span class="cp-customer-payment-label">销售金额</span>
            <span class="cp-customer-payment-value cp-customer-payment-money">{{ formatPaymentMoney(customerPaymentForm.salesAmountWithTax) }}</span>
          </div>
          <div class="cp-customer-payment-field">
            <span class="cp-customer-payment-label">客户名称</span>
            <span class="cp-customer-payment-value">{{ customerPaymentForm.customerName || '—' }}</span>
          </div>
        </div>
        <div class="cp-customer-payment-amount-wrap">
          <!-- 回款金额：调用 onCustomerPaymentAmountFieldInput 限制两位小数；前置币种仅展示样式 -->
          <div class="cp-customer-payment-amount-title">回款金额<span class="cp-customer-payment-required-star">*</span></div>
          <el-input
            v-model="customerPaymentAmountInput"
            class="cp-customer-payment-amount-input"
            size="small"
            clearable
            placeholder="请输入回款金额"
            @input="onCustomerPaymentAmountFieldInput"
          >
            <template slot="prepend"><span class="cp-customer-payment-currency">¥</span></template>
          </el-input>
          <div class="cp-customer-payment-amount-hint">请输入本次实际回款金额，不可超过销售金额</div>
        </div>
        <span slot="footer">
          <el-button size="small" @click="customerPaymentVisible = false">取消</el-button>
          <!-- 提交回款维护：调用 submitCustomerPayment，回款状态由 inferReturnMoneyStatusFromPaymentAmount 推导 -->
          <el-button type="primary" size="small" :loading="customerPaymentLoading" @click="submitCustomerPayment">确认保存</el-button>
        </span>
      </el-dialog>
      <!-- 结算端：多采购单统一上传一份销售合同 -->
      <el-dialog
        :visible.sync="salesContractUploadVisible"
        width="560px"
        append-to-body
        custom-class="cp-unified-upload-dialog"
        @close="resetSalesContractUploadDialog"
      >
        <div slot="title" class="cp-unified-upload-title-wrap">
          <div class="cp-unified-upload-title">客户合同上传</div>
          <div class="cp-unified-upload-sub">为已选订单统一上传一份合同</div>
        </div>
        <div class="cp-unified-upload-section">
          <div class="cp-unified-upload-section-label">关联订单</div>
          <div class="cp-unified-upload-section-hint">已选 {{ salesContractUploadForm.purchaseNoList.length }} 个订单</div>
          <div class="cp-unified-upload-tags">
            <el-tag
              v-for="po in salesContractUploadForm.purchaseNoList"
              :key="'sc-' + po"
              size="small"
              type="info"
              class="cp-unified-upload-tag"
            >{{ po }}</el-tag>
          </div>
        </div>
        <div class="cp-unified-upload-section">
          <div class="cp-unified-upload-section-label">合同文件上传</div>
          <!-- 未选文件：展示拖拽上传区；已选：展示文件卡片，调用 clearSalesContractUploadFile 可删除后重传 -->
          <el-upload
            v-if="!salesContractUploadForm.salesContractFileUrl"
            :key="'sales-contract-upload-' + salesContractUploadKey"
            drag
            action=""
            :auto-upload="false"
            :show-file-list="false"
            :limit="1"
            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
            :on-change="onSalesContractFileChange"
            :on-exceed="onSalesContractUploadExceed"
          >
            <i class="el-icon-upload"/>
            <div class="el-upload__text">点击上传或拖拽文件至此处</div>
            <div slot="tip" class="el-upload__tip">支持 PDF、Word、JPG、PNG，单个文件不超过 20MB；文件名含合同编码与日期更佳</div>
          </el-upload>
          <div v-else class="cp-unified-upload-file-card">
            <i class="el-icon-document cp-unified-upload-file-icon"/>
            <div class="cp-unified-upload-file-info">
              <div class="cp-unified-upload-file-name">{{ salesContractUploadForm.fileName }}</div>
              <div class="cp-unified-upload-file-meta">
                合同编码：{{ salesContractUploadForm.salesContractNo || '—' }}
              </div>
              <div class="cp-unified-upload-date-row">
                <span class="cp-unified-upload-date-label">签订日期</span>
                <!-- 日期可手改：文件名未解析出日期时必填 -->
                <el-date-picker
                  v-model="salesContractUploadForm.salesContractSignDate"
                  type="date"
                  size="mini"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择签订日期"
                  style="width: 160px"
                />
              </div>
            </div>
            <!-- 调用 clearSalesContractUploadFile：删除附件后可重新上传 -->
            <i class="el-icon-close cp-unified-upload-file-remove" title="删除" @click="clearSalesContractUploadFile"/>
          </div>
        </div>
        <span slot="footer">
          <el-button size="small" @click="salesContractUploadVisible = false">取消</el-button>
          <!-- 调用 submitSalesContractUpload：确认上传销售合同 -->
          <el-button
            type="primary"
            size="small"
            :loading="salesContractUploadLoading"
            :disabled="!salesContractUploadForm.salesContractFileUrl"
            @click="submitSalesContractUpload"
          >确认上传</el-button>
        </span>
      </el-dialog>
      <!-- 结算端：多采购单统一上传一份客户签收单 -->
      <el-dialog
        :visible.sync="customerSignUploadVisible"
        width="560px"
        append-to-body
        custom-class="cp-unified-upload-dialog"
        @close="resetCustomerSignUploadDialog"
      >
        <div slot="title" class="cp-unified-upload-title-wrap">
          <div class="cp-unified-upload-title">客户签收单上传</div>
          <div class="cp-unified-upload-sub">为已选订单统一上传一份签收单</div>
        </div>
        <div class="cp-unified-upload-section">
          <div class="cp-unified-upload-section-label">关联订单</div>
          <div class="cp-unified-upload-section-hint">已选 {{ customerSignUploadForm.purchaseNoList.length }} 个订单</div>
          <div class="cp-unified-upload-tags">
            <el-tag
              v-for="po in customerSignUploadForm.purchaseNoList"
              :key="'cs-' + po"
              size="small"
              type="info"
              class="cp-unified-upload-tag"
            >{{ po }}</el-tag>
          </div>
        </div>
        <div class="cp-unified-upload-section">
          <div class="cp-unified-upload-section-label">签收单文件上传</div>
          <!-- 未选文件：展示拖拽上传区；已选：展示文件卡片，调用 clearCustomerSignUploadFile 可移除后重传 -->
          <el-upload
            v-if="!customerSignUploadForm.customerSignFileUrl"
            :key="'customer-sign-upload-' + customerSignUploadKey"
            drag
            action=""
            :auto-upload="false"
            :show-file-list="false"
            :limit="1"
            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
            :on-change="onCustomerSignFileChange"
          >
            <i class="el-icon-upload"/>
            <div class="el-upload__text">点击上传或拖拽文件至此处</div>
            <div slot="tip" class="el-upload__tip">支持 PDF、Word、JPG、PNG，单个文件不超过 20MB</div>
          </el-upload>
          <div v-else class="cp-unified-upload-file-card">
            <i class="el-icon-document cp-unified-upload-file-icon"/>
            <div class="cp-unified-upload-file-info">
              <div class="cp-unified-upload-file-name">{{ customerSignUploadForm.fileName }}</div>
            </div>
            <!-- 调用 clearCustomerSignUploadFile：移除附件后可重新上传 -->
            <i class="el-icon-close cp-unified-upload-file-remove" title="移除" @click="clearCustomerSignUploadFile"/>
          </div>
        </div>
        <span slot="footer">
          <el-button size="small" @click="customerSignUploadVisible = false">取消</el-button>
          <!-- 调用 submitCustomerSignUpload：确认上传客户签收单 -->
          <el-button
            type="primary"
            size="small"
            :loading="customerSignUploadLoading"
            :disabled="!customerSignUploadForm.customerSignFileUrl"
            @click="submitCustomerSignUpload"
          >确认上传</el-button>
        </span>
      </el-dialog>
      <el-dialog title="登记合同" :visible.sync="contractVisible" width="420px" append-to-body>
        <el-form :model="contractForm" size="small" label-width="110px">
          <el-form-item label="业务单号">
            <el-input v-model="contractForm.bmsBizOrderNo" disabled/>
          </el-form-item>
          <el-form-item label="合同编号">
            <el-input v-model="contractForm.contractNo" placeholder="请输入合同编号"/>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button size="small" @click="contractVisible = false">取消</el-button>
          <el-button type="primary" size="small" :loading="contractLoading" @click="submitContract">保存</el-button>
        </span>
      </el-dialog>
      <el-dialog title="确认签收" :visible.sync="signVisible" width="700px" append-to-body custom-class="cp-sign-dialog">
        <div class="cp-sign-summary">
          <div class="cp-sign-summary-main">共勾选 {{ signForm.purchaseNoList.length }} 条采购单</div>
          <div class="cp-sign-summary-sub" v-if="signForm.purchaseNoList.length > 1">请上传每条采购单对应签收单文件（文件名=采购单号）</div>
          <div class="cp-sign-summary-sub" v-else>请上传当前采购单对应签收单文件</div>
        </div>
        <el-upload
          drag
          multiple
          action=""
          :auto-upload="false"
          :show-file-list="false"
          :on-change="onSignFileChange"
          style="margin-top: 12px"
        >
          <i class="el-icon-upload"/>
          <div class="el-upload__text">点击或拖拽文件到此处上传</div>
          <div slot="tip" class="el-upload__tip" v-if="signForm.purchaseNoList.length > 1">支持 PDF/JPG/PNG，示例：30000001.pdf</div>
          <div slot="tip" class="el-upload__tip" v-else>支持 PDF/JPG/PNG</div>
        </el-upload>
        <!-- 签收文件列表：调用 removeSignFileRow 删除错传/待重传的文件行 -->
        <el-table :data="signForm.signFileList" border size="mini" style="margin-top: 12px" max-height="280">
          <el-table-column prop="signFileName" label="文件名" min-width="220" show-overflow-tooltip/>
          <el-table-column prop="purchaseNo" label="匹配采购单" min-width="120" show-overflow-tooltip/>
          <el-table-column label="状态" min-width="120">
            <template slot-scope="{ row }">
              <span :class="row.valid ? 'cp-upload-ok' : 'cp-upload-error'">{{ row.message }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="72" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="removeSignFileRow(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer">
          <el-button size="small" @click="signVisible = false">取消</el-button>
          <el-button type="primary" size="small" :loading="signLoading" @click="submitSign">确认签收</el-button>
        </span>
      </el-dialog>
      <el-drawer
        :visible.sync="invoiceVisible"
        direction="rtl"
        :size="invoiceRegisterDrawerWidth"
        append-to-body
        custom-class="cp-register-invoice-drawer"
        :destroy-on-close="false"
        :wrapper-closable="true"
      >
        <template slot="title">
          <div class="cp-register-invoice-dialog-title-wrap">
            <div class="cp-register-invoice-dialog-title">发票登记</div>
            <div class="cp-register-invoice-dialog-sub">{{ invoiceDialogSubtitle }}</div>
          </div>
        </template>
        <!-- 调用 onDrawerBodyMouseDown：与 PaymentDetailDrawer 同源，避免拖选表格误触遮罩关闭 -->
        <div v-loading="invoiceLoading" class="cp-register-invoice-drawer-body" @mousedown="onDrawerBodyMouseDown">
          <div class="cp-register-invoice-drawer-scroll">
        <el-alert
          class="cp-register-invoice-tip"
          type="warning"
          :closable="false"
          :show-icon="false"
          title="提示：支持部分开票，可手工调整「本次开票数量」与票面金额；确认登记时系统将校验发票含税/税额与本次开票汇总一致。"
        />
        <div class="cp-register-invoice-stack">
          <div class="cp-register-invoice-section">
            <div class="cp-register-invoice-section-title">采购订单明细</div>
            <!-- 购/销方税号：openInvoiceDialog 内 refreshInvoiceRegisterPartyTaxNos 拉取（facilitator / platform） -->
            <div class="cp-register-invoice-head cp-register-invoice-head--party-line">
              <span class="cp-register-invoice-head-seg">购买方：{{ formatPartyHead(invoiceForm.paymentPayerCode, invoiceForm.buyerName) }}</span>
              <span class="cp-register-invoice-head-seg">税号：{{ formatDetailDisplay(invoiceRegisterPartyTaxBuyer) }}</span>
              <span class="cp-register-invoice-head-seg">销售方：{{ formatPartyHead(invoiceForm.supplierCode, invoiceForm.sellerName) }}</span>
              <span class="cp-register-invoice-head-seg">税号：{{ formatDetailDisplay(invoiceRegisterPartyTaxSeller) }}</span>
            </div>
            <el-table
              :data="invoiceForm.itemList"
              border
              stripe
              class="table-list cp-register-invoice-items-table"
              max-height="380"
            >
              <el-table-column prop="purchaseNo" label="采购单号" width="118" align="center" show-overflow-tooltip/>
              <el-table-column prop="itemNo" label="行号" width="84" align="center" show-overflow-tooltip/>
              <el-table-column prop="materialName" label="物料名称" min-width="160" show-overflow-tooltip/>
              <el-table-column label="单价(含税)" width="88" align="right">
                <template slot-scope="{ row }">{{ formatAmount(row.unitPriceWithTax) }}</template>
              </el-table-column>
              <el-table-column label="采购数量" width="82" align="right">
                <template slot-scope="{ row }">{{ formatQuantity(row.totalQuantity) }}</template>
              </el-table-column>
              <el-table-column label="已开票数量" width="88" align="right">
                <template slot-scope="{ row }">{{ formatQuantity(row.openedQuantity) }}</template>
              </el-table-column>
              <el-table-column label="待开票数量" width="88" align="right">
                <template slot-scope="{ row }">{{ formatQuantity(row.pendingQuantity) }}</template>
              </el-table-column>
              <el-table-column label="本次开票数量" width="150" align="center">
                <template slot-scope="{ row }">
                  <el-input-number
                    v-model="row.registerQuantity"
                    :min="0"
                    :max="truncateCpQuantity(row.pendingQuantity)"
                    :precision="3"
                    :step="0.001"
                    size="small"
                    style="width: 100%"
                    @change="onInvoiceRegisterQuantityChange(row)"
                    @blur="onInvoiceRegisterQuantityChange(row)"
                  />
                </template>
              </el-table-column>
              <el-table-column label="税率(%)" width="72" align="center">
                <template slot-scope="{ row }">{{ formatTaxRateDisplay(row.taxRate) }}</template>
              </el-table-column>
              <el-table-column label="不含税金额" width="100" align="right">
                <template slot-scope="{ row }">{{ formatAmount(invoiceLineAmountParts(row).amountWithoutTax) }}</template>
              </el-table-column>
              <el-table-column label="税额" width="76" align="right">
                <template slot-scope="{ row }">{{ formatAmount(invoiceLineAmountParts(row).taxAmount) }}</template>
              </el-table-column>
              <el-table-column label="含税金额" width="100" align="right">
                <template slot-scope="{ row }">{{ formatAmount(invoiceLineAmountParts(row).amountWithTax) }}</template>
              </el-table-column>
            </el-table>
            <div class="cp-register-invoice-subtotal-row">
              <span>共 <b>{{ (invoiceForm.itemList || []).length }}</b> 行</span>
              <span>明细小计（不含税）<b>{{ formatAmount(invoiceSummary.grossAmountWithoutTax) }}</b></span>
              <span>税额 <b>{{ formatAmount(invoiceSummary.grossTaxAmount) }}</b></span>
              <span>含税 <b>{{ formatAmount(invoiceSummary.grossAmountWithTax) }}</b></span>
            </div>
          </div>
          <div class="cp-register-invoice-section cp-register-invoice-section--bill">
            <div class="cp-register-invoice-right-head">
              <span class="cp-register-invoice-section-title">发票信息</span>
              <!-- 手动添加发票行：调用 addManualInvoiceRow -->
              <el-button type="text" size="small" class="cp-register-invoice-add-manual" @click="addManualInvoiceRow">+ 手动添加</el-button>
            </div>
            <!-- 票面文件上传：调用 onInvoiceFileChange -->
            <el-upload
              class="cp-register-invoice-upload-strip"
              drag
              multiple
              action=""
              :auto-upload="false"
              :show-file-list="false"
              :on-change="onInvoiceFileChange"
            >
              <div class="cp-register-invoice-upload-strip-inner">
                <div class="cp-register-invoice-upload-strip-row">
                  <i class="el-icon-upload"/>
                  <span class="cp-register-invoice-upload-strip-text">点击或拖拽上传发票文件（票面识别）</span>
                </div>
                <div class="cp-register-invoice-upload-strip-sub">支持 JPG / PNG / PDF；可多次上传识别多张开票</div>
              </div>
            </el-upload>
            <!-- 发票信息表：列宽对齐 platformInvoiceRegister 登记发票 billDetailList 表 -->
            <el-table
              :data="invoiceForm.invoiceList"
              border
              stripe
              class="table-list cp-register-invoice-bills-table"
              max-height="320"
            >
              <el-table-column label="操作" width="100" align="center" fixed="left">
                <template slot-scope="scope">
                  <el-button type="text" size="small" class="cp-register-invoice-del" @click="removeInvoiceRow(scope.$index)">删</el-button>
                </template>
              </el-table-column>
              <el-table-column label="发票号码" width="140" show-overflow-tooltip>
                <template slot-scope="{ row }">
                  <el-input v-model="row.invoiceNo" size="small" placeholder="必填" @input="onInvoiceFieldManualChange(row)"/>
                </template>
              </el-table-column>
              <el-table-column label="发票代码" width="140" show-overflow-tooltip>
                <template slot-scope="{ row }">
                  <el-input v-model="row.invoiceCode" size="small" placeholder="必填" @input="onInvoiceFieldManualChange(row)"/>
                </template>
              </el-table-column>
              <el-table-column label="开票日期" width="180" align="center">
                <template slot-scope="{ row }">
                  <el-date-picker
                    v-model="row.invoiceDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    size="small"
                    style="width:100%"
                    placeholder="日期"
                    @change="onInvoiceFieldManualChange(row)"
                  />
                </template>
              </el-table-column>
              <el-table-column label="销售方" min-width="164" show-overflow-tooltip>
                <template slot-scope="{ row }">
                  <el-input v-model="row.sellerName" size="small" placeholder="名称" @input="onInvoiceFieldManualChange(row)"/>
                </template>
              </el-table-column>
              <el-table-column label="销售方纳税人识别号" min-width="164" show-overflow-tooltip>
                <template slot-scope="{ row }">
                  <el-input v-model="row.sellerTaxNo" size="small" @input="onInvoiceFieldManualChange(row)"/>
                </template>
              </el-table-column>
              <el-table-column label="购买方名称" min-width="164" show-overflow-tooltip>
                <template slot-scope="{ row }">
                  <el-input v-model="row.buyerName" size="small" @input="onInvoiceFieldManualChange(row)"/>
                </template>
              </el-table-column>
              <el-table-column label="购买方纳税人识别号" min-width="164" show-overflow-tooltip>
                <template slot-scope="{ row }">
                  <el-input v-model="row.buyerTaxNo" size="small" @input="onInvoiceFieldManualChange(row)"/>
                </template>
              </el-table-column>
              <el-table-column label="不含税金额" min-width="164" align="right">
                <template slot-scope="{ row }">
                  <!-- 金额变更：调用 onInvoiceAmountChange；:controls="false" 与登记发票未税/价税 el-input 一致无步进按钮 -->
                  <el-input-number
                    v-model="row.amountWithoutTax"
                    :min="0"
                    :precision="2"
                    :step="0.01"
                    :controls="false"
                    size="small"
                    style="width: 100%"
                    @change="onInvoiceAmountChange(row)"
                  />
                </template>
              </el-table-column>
              <el-table-column label="税额" min-width="164" align="right">
                <template slot-scope="{ row }">{{ formatAmount(computeInvoiceBillRowTaxAmount(row)) }}</template>
              </el-table-column>
              <el-table-column label="含税金额" min-width="164" align="right">
                <template slot-scope="{ row }">
                  <el-input-number
                    v-model="row.amountWithTax"
                    :min="0"
                    :precision="2"
                    :step="0.01"
                    :controls="false"
                    size="small"
                    style="width: 100%"
                    @change="onInvoiceAmountChange(row)"
                  />
                </template>
              </el-table-column>
              <el-table-column prop="message" label="状态" min-width="120" show-overflow-tooltip>
                <template slot-scope="{ row }">
                  <span :class="row.valid === false ? 'cp-upload-error' : 'cp-upload-ok'">{{ row.message }}</span>
                </template>
              </el-table-column>
            </el-table>
            <div class="cp-register-invoice-subtotal-row">
              <span>共 <b>{{ (invoiceForm.invoiceList || []).length }}</b> 张发票</span>
              <span>发票合计（不含税）<b>{{ formatAmount(invoiceBillSummary.amountWithoutTax) }}</b></span>
              <span>税额 <b>{{ formatAmount(invoiceBillSummary.taxAmount) }}</b></span>
              <span>含税 <b>{{ formatAmount(invoiceBillSummary.amountWithTax) }}</b></span>
            </div>
          </div>
        </div>
          </div>
          <div class="cp-register-invoice-drawer-footer">
            <el-button size="small" @click="invoiceVisible = false">取消</el-button>
            <el-button type="primary" size="small" :loading="invoiceLoading" @click="submitInvoice">确认登记</el-button>
          </div>
        </div>
      </el-drawer>
      <!-- 调用 openFilePreview：逗号分隔多附件轮播预览（仅文件内容） -->
      <previewImage :previewSrcList="filePreviewList" :full-height="true"/>
    </div>
  </div>
</template>

<script>
import util from '../../common/util';
import {
  calcCpInvoiceLineAmountPartsFromTaxUnit,
  cpAmountEquals,
  cpQuantityEquals,
  cpQuantityGt,
  cpQuantityPositive,
  formatCpAmount,
  formatCpQuantity,
  normalizeCpTaxRateDecimal,
  subtractCpAmount,
  sumCpAmounts,
  toCpAmountNumber,
  truncateCpQuantity
} from '../../common/cpDecimal';
import previewImage from '../../components/common/previewImage.vue';
import drawerDragCloseGuard from './components/mixins/drawerDragCloseGuard';
import {
  applyCpKeepAliveRouteName,
  clearCpFilterCache,
  loadCpFilterCache,
  saveCpFilterCache
} from './cpFilterCache';

/** 与集采汇总付款台账详情（PaymentDetailDrawer）抽屉宽度一致 */
const CP_PAY_LEDGER_DRAWER_WIDTH = 'calc(100vw - 210px)';

/** 汇总付款单状态文案（与 cp_payment_order.status 对齐） */
const CP_PAYMENT_ORDER_STATUS_TEXT = {
  0: '待确认',
  1: '待提交OA',
  2: 'OA审核中',
  3: '待支付',
  4: '已支付'
};

/** 详情支付记录空结构 */
function createEmptyDetailPaymentRecords() {
  return {
    paymentSummaryRows: [],
    paymentPayAmountTotal: null,
    prepayVerifyRows: [],
    prepayVerifyAmountTotal: null
  };
}

/**
 * 付款状态下拉（与 cp_sale_purchase_order_ext.payment_status 对齐）。
 * 0待付款 1待支付(已关联付款单) 2部分付款(已付&lt;采购含税) 3已支付。
 */
const PAYMENT_STATUS_OPTIONS = [
  { label: '待付款', value: 0 },
  { label: '待支付', value: 1 },
  { label: '部分付款', value: 2 },
  { label: '已支付', value: 3 }
];

/** 进项状态筛选（与扩展表 invoice_status 对齐，可按主数据再调；墨刀「已开」对应非未开票场景） */
const INVOICE_STATUS_FILTER_OPTIONS = [
  { label: '未开票', value: 0 },
  { label: '部分开票', value: 1 },
  { label: '完全开票', value: 2 }
];

/** 销项状态筛选（与扩展表 sales_invoice_status 对齐） */
const SALES_INVOICE_STATUS_FILTER_OPTIONS = [
  { label: '未开票', value: 0 },
  { label: '部分开票', value: 1 },
  { label: '完全开票', value: 2 }
];

/** 回款状态筛选（与扩展表 return_money_status 对齐） */
const RETURN_MONEY_STATUS_FILTER_OPTIONS = [
  { label: '未回款', value: 0 },
  { label: '部分回款', value: 1 },
  { label: '已回款', value: 2 }
];

/** 集采订单列表日期维度：订单日期 / 创建日期 */
const CP_ORDER_DATE_TYPE_OPTIONS = [
  { label: '订单日期', value: 'purchaseOrderDate' },
  { label: '创建日期', value: 'createTime' }
];

/**
 * 合同编号口径：n 位连续字母-QXyyyyMMdd + 可选（-）n 位纯数字流水。
 * 示例：SUP-QX20260608001、LASGE-QX20251013-02
 */
const CP_CONTRACT_NO_CORE_REG = /[A-Za-z]+-QX\d{8}(?:-?\d+)?/i;
const CP_CONTRACT_NO_NORMALIZE_REG = /^([A-Za-z]+)-QX(\d{8})(?:-(\d+)|(\d+))?$/i;

/** 业务模式筛选（与主表 business_mode、导入模板 J001/J002/J003 一致） */
const BUSINESS_MODE_OPTIONS = [
  { label: 'J001-客户-集团-供应商', value: 'J001' },
  { label: 'J002-客户-集团-供应链-供应商', value: 'J002' },
  { label: 'J003-客户-珠海-集团-供应商', value: 'J003' }
];

/**
 * 列表展示统一工具：把 (code, name) 拼成 `code-name` 形式；任一为空则退化为单值；都空返回占位符。
 * 调用方：displaySettleCompany / displaySupplier / displayCustomer / displaySalesOrgPrimary / displaySalesOrgSecondary
 */
function formatCodeName(code, name) {
  const c = code == null ? '' : String(code).trim();
  const n = name == null ? '' : String(name).trim();
  if (!c && !n) return '—';
  if (c && n) return `${c}-${n}`;
  return c || n;
}

function createEmptyQueryForm() {
  return {
    bmsBizOrderNo: '',
    purchaseNo: '',
    salesOrderNo: '',
    customerName: '',
    customerCode: '',
    /** 结算端供应商 / 供应商门户销售方：编码多选（传给后端 supplierCodes） */
    supplierCodes: [],
    /** 结算端：客户编码多选（传给后端 customerCodes） */
    customerCodes: [],
    /** 结算端：创建人 userId 多选（传给后端 auditUserIds，对应主表 create_by_id） */
    auditUserIds: [],

    /** 付款主体编码（传给后端 paymentPayerCode） */
    paymentPayerCode: '',
    /** 一/二级销售组织：选公司主数据编码，提交时转名称参与 LIKE */
    salesOrgLevel1Code: '',
    salesOrgLevel2Code: '',
    /** 付款状态多选（扩展表 payment_status IN） */
    paymentStatuses: [],
    invoiceStatus: null,
    /** 销项状态（扩展表 sales_invoice_status） */
    salesInvoiceStatus: null,
    /** 回款状态（扩展表 return_money_status） */
    returnMoneyStatus: null,
    /** 结算端：业务模式多选（传给后端 businessModes） */
    businessModes: [],
    /** 采购含税金额区间（主表 pur_amount_with_tax） */
    purAmountMin: '',
    purAmountMax: '',
    contractStatus: null,
    purchaseKeywords: '',
    purchaseOrderKind: 'purchaseNo',
    /** 供应商门户筛选项占位（当前未传后端） */
    auditorFilter: ''
  };
}

export default {
  /** 初始 name；created 中按路由改为 cpSettlementSalePurchaseOrder / cpSupplierSalePurchaseOrder，配合 Home keep-alive */
  name: 'SalePurchaseOrderDisplay',
  components: {
    previewImage
  },
  mixins: [drawerDragCloseGuard],
  data() {
    return {
      /** 附件预览轮播列表（逗号分隔 URL 解析后传入 previewImage） */
      filePreviewList: [],
      loading: false,
      exportLoading: false,
      cpImportLoading: false,
      cpImportTemplateLoading: false,
      itemExportLoading: false,
      /** 导入弹窗：可见态 + 已选文件 + 拖拽悬浮态；最大 10MB */
      importDialogVisible: false,
      importFile: null,
      importDragOver: false,
      importMaxSize: 10 * 1024 * 1024,
      paymentStatusOptions: PAYMENT_STATUS_OPTIONS,
      invoiceStatusFilterOptions: INVOICE_STATUS_FILTER_OPTIONS,
      salesInvoiceStatusFilterOptions: SALES_INVOICE_STATUS_FILTER_OPTIONS,
      returnMoneyStatusFilterOptions: RETURN_MONEY_STATUS_FILTER_OPTIONS,
      businessModeOptions: BUSINESS_MODE_OPTIONS,
      /** 日期维度：当前仅订单日期接后端（SAP 回写后才有值），预留签收等类型 */
      dateFieldType: 'purchaseOrderDate',
      /** 日期维度下拉：订单日期 / 创建日期 */
      dateTypeOptions: CP_ORDER_DATE_TYPE_OPTIONS,
      queryForm: createEmptyQueryForm(),
      dateRange: [],
      pageNo: 1,
      pageSize: 20,
      totalCount: 0,
      tableData: [],
      detailVisible: false,
      detail: null,
      /** 当前详情在列表中的索引，用于上一条/下一条 */
      detailRowIndex: -1,
      /** 详情弹窗 Tab：基础信息 / 订单明细 / 支付记录 / 操作日志 */
      detailActiveTab: 'basic',
      /** 详情操作日志列表（按 BMS 业务单号查询，公用 operate_log 表） */
      detailOperateLogs: [],
      /** 详情操作日志加载态 */
      detailOperateLogsLoading: false,
      /** 详情操作日志分页：当前业务单号（翻页请求携带） */
      detailOperateLogBizNo: '',
      /** 详情操作日志分页：页码 */
      detailOperateLogPageNo: 1,
      /** 详情操作日志分页：每页条数 */
      detailOperateLogPageSize: 10,
      /** 详情操作日志分页：总条数 */
      detailOperateLogTotal: 0,
      /** 详情支付记录 */
      detailPaymentRecords: createEmptyDetailPaymentRecords(),
      /** 详情支付记录加载态 */
      detailPaymentRecordsLoading: false,
      /** 详情支付记录查询采购单号 */
      detailPaymentPurchaseNo: '',
      selectedRows: [],
      /** 当前筛选条件下采购含税合计（pager.totalAmount） */
      listTotalAmount: 0,
      /** 当前筛选条件下销售含税合计（pager.totalAmount2） */
      listTotalAmount2: 0,
      /** 订单台账导出弹窗 */
      exportDialogVisible: false,
      /** main=仅主表 Sheet；mainAndItems=主表+物料双 Sheet（默认与历史行为一致） */
      exportLedgerScope: 'mainAndItems',
      /** 与公司发票等页同源：sessionStorage ALLENTERPRISEINFOLIST */
      enterpriseInfoList: [],
      /**
       * 全局全选：为 true 时导出/意图为「当前查询条件下全部数据」，不依赖本页 selectedRows。
       */

      /** 供应商页签：全部/待开票/已开票 */
      supplierInvoiceTab: 'all',
      /** 结算端页签：全部/已生效(valid_flag=1)/OMS处理中(valid_flag=0) */
      settlementValidFlagTab: 'all',
      generateContractVisible: false,
      generateContractLoading: false,
      generateContractForm: {
        contractSignDate: ''
      },
      batchUploadContractVisible: false,
      batchUploadContractLoading: false,
      batchUploadContractRows: [],
      /** 批量上传合同：每次打开弹框递增，强制重建 el-upload 避免内部文件列表残留 */
      batchUploadContractUploadKey: 0,
      customerPaymentVisible: false,
      customerPaymentLoading: false,
      /** 客户回款弹框金额输入（字符串，避免 InputNumber 强行默认 0） */
      customerPaymentAmountInput: '',
      customerPaymentForm: {
        salesOrderNo: '',
        customerName: '',
        salesAmountWithTax: 0,
        /** 0 未回款 / 1 部分 / 2 已回款；提交前由 inferReturnMoneyStatusFromPaymentAmount 赋值 */
        returnMoneyStatus: null
      },
      /** 结算端销售合同上传弹框 */
      salesContractUploadVisible: false,
      salesContractUploadLoading: false,
      salesContractUploadKey: 0,
      salesContractUploadForm: {
        purchaseNoList: [],
        fileName: '',
        salesContractNo: '',
        salesContractSignDate: '',
        salesContractFileUrl: ''
      },
      /** 结算端客户签收单上传弹框 */
      customerSignUploadVisible: false,
      customerSignUploadLoading: false,
      customerSignUploadKey: 0,
      customerSignUploadForm: {
        purchaseNoList: [],
        fileName: '',
        customerSignFileUrl: ''
      },
      contractVisible: false,
      contractLoading: false,
      contractForm: { bmsBizOrderNo: '', contractNo: '' },
      signVisible: false,
      signLoading: false,
      signForm: { qxSignStatus: 1, purchaseNoList: [], signFileList: [] },
      invoiceVisible: false,
      /** 发票登记-采购明细头：付款主体纳税人识别号（facilitator，与 paymentPayerCode 对应） */
      invoiceRegisterPartyTaxBuyer: '',
      /** 发票登记-采购明细头：供应商纳税人识别号（platform，与 supplierCode 对应） */
      invoiceRegisterPartyTaxSeller: '',
      /** 发票登记抽屉宽度：与 cpSettlementPaymentSummaryLedger 详情抽屉同源 */
      invoiceRegisterDrawerWidth: CP_PAY_LEDGER_DRAWER_WIDTH,
      invoiceLoading: false,
      invoiceForm: {
        purchaseNoList: [],
        paymentPayerCode: '',
        buyerName: '',
        supplierCode: '',
        sellerName: '',
        deductAmount: 0,
        itemList: [],
        invoiceList: []
      },
      /** 结算端筛选项：供应商 / 客户 / 审核人（后端 code-name） */
      settlementSupplierOptions: [],
      settlementCustomerOptions: [],
      settlementAuditUserOptions: [],
      // 按钮权限控制（与 bms_base_center.privileges 配置一致，参考汇总付款台账）
      /** 集采结算管理-集采订单-导出 */
      isShowSettlementExport: util.rolePrivileges('menus', '23130101'),
      /** 集采结算管理-集采订单-批量创建销售 */
      isShowSettlementBatchCreateSales: util.rolePrivileges('menus', '23130102'),
      /** 集采结算管理-集采订单-客户回款 */
      isShowSettlementCustomerPayment: util.rolePrivileges('menus', '23130103'),
      /** 集采结算管理-集采订单-销售合同上传 */
      isShowSettlementUploadSalesContract: util.rolePrivileges('menus', '23130104'),
      /** 集采结算管理-集采订单-客户签收单上传 */
      isShowSettlementUploadCustomerSign: util.rolePrivileges('menus', '23130105'),
      /** 供应商门户-集采订单-导出 */
      isShowSupplierExport: util.rolePrivileges('menus', '260516'),
      /** 供应商门户-集采订单-生成合同模版 */
      isShowSupplierGenerateContract: util.rolePrivileges('menus', '260518'),
      /** 供应商门户-集采订单-批量上传合同 */
      isShowSupplierBatchUploadContract: util.rolePrivileges('menus', '260519'),
      /** 供应商门户-集采订单-确认签收 */
      isShowSupplierConfirmSign: util.rolePrivileges('menus', '260520'),
      /** 供应商门户-集采订单-登记发票 */
      isShowSupplierRegisterInvoice: util.rolePrivileges('menus', '260521')
      // 按钮权限控制 end
    };
  },
  computed: {
    /** 根据路由区分结算端与供应商门户 */
    supplierMode() {
      const p = this.$route.path || '';
      return p.indexOf('Supplier') >= 0;
    },
    /** 批量上传合同：允许上传份数 = 勾选订单数 */
    batchUploadContractLimit() {
      return (this.selectedRows && this.selectedRows.length) || 0;
    },
    /** 调用方：模板第一行类型+关键词输入框，根据 purchaseOrderKind 切换 placeholder 文案 */
    purchaseKeywordsPlaceholder() {
      return '请输入，多个用空格或逗号隔开';
    },
    /**
     * 结算端勾选采购含税合计。
     * 调用方：底栏「勾选采购合计」
     */
    selectedPurAmount() {
      return (this.selectedRows || []).reduce((sum, row) => sum + Number(row.purAmountWithTax || 0), 0);
    },
    /**
     * 结算端勾选销售含税合计。
     * 调用方：底栏「勾选销货合计」
     */
    selectedSalesAmount() {
      return (this.selectedRows || []).reduce((sum, row) => sum + Number(row.salesAmountWithTax || 0), 0);
    },
    /**
     * 供应商门户销售方下拉：与后端隔离一致——仅受限账号按权限码裁剪，否则展示订单中全部销售方。
     * 调用方：搜索项「销售方」
     */
    supplierPortalSellerOptions() {
      const all = this.settlementSupplierOptions || [];
      // 调用 isRestrictedSupplierPortal：非受限不裁剪，与列表可见销售方一致
      if (!this.isRestrictedSupplierPortal) {
        return all;
      }
      // 调用 resolveSupplierPortalAllowedCodes：受限时按 WORKCODES / PLATFORMCODE 裁剪
      const allowed = this.resolveSupplierPortalAllowedCodes();
      if (!allowed.length) {
        return all;
      }
      const allowedSet = new Set(allowed);
      return all.filter((opt) => opt && allowedSet.has(String(opt.code)));
    },
    /**
     * 是否受限供应商门户：角色含 65 且不含 66（与后端 resolveSupplierPortalSupplierScope 一致）。
     * 调用方：supplierPortalSellerOptions
     */
    isRestrictedSupplierPortal() {
      const raw = sessionStorage.getItem('ROLEIDLIST');
      const parsed = raw ? JSON.parse(raw) : [];
      const ids = Array.isArray(parsed) ? parsed.map((r) => Number(r)) : [];
      return ids.includes(65) && !ids.includes(66);
    },
    /** 详情扩展行：供模板安全读取扩展字段 */
    detailExtSafe() {
      if (!this.detail || !this.detail.extOrder) return {};
      return this.detail.extOrder;
    },
    /** 详情采购合同：优先扩展表冗余字段，兼容旧数据回落 contract 表 */
    detailPurchaseContractSafe() {
      const ext = this.detailExtSafe;
      const contract = (this.detail && this.detail.purchaseContract) || {};
      return {
        contractNo: ext.contractNo || contract.contractNo,
        contractSignDate: ext.contractSignDate || contract.contractSignDate,
        contractFileUrl: ext.contractFileUrl || contract.contractFileUrl
      };
    },
    /** 详情页状态胶囊：合并扩展表状态供 pillClass 使用 */
    detailPillRow() {
      const e = this.detailExtSafe;
      return {
        salesInvoiceStatus: e.salesInvoiceStatus,
        invoiceStatus: e.invoiceStatus,
        paymentStatus: e.paymentStatus,
        returnMoneyStatus: e.returnMoneyStatus,
        contractStatus: e.contractStatus
      };
    },
    /**
     * 详情金额区「已支付」：直接取扩展表 cp_sale_purchase_order_ext.payment_amount。
     * 调用处：详情头部金额卡片。
     */
    detailSummaryPaidAmount() {
      const ext = this.detailExtSafe;
      if (!ext || (ext.paymentAmount == null && ext.payment_amount == null)) {
        return null;
      }
      const paid = ext.paymentAmount != null ? ext.paymentAmount : ext.payment_amount;
      const num = Number(paid);
      return Number.isNaN(num) ? null : num;
    },
    /**
     * 详情金额区「待支付」：采购含税金额 − 扩展表 payment_amount。
     * 调用处：详情头部金额卡片。
     */
    detailSummaryPendingPay() {
      const m = this.detail && this.detail.mainOrder;
      if (!m || m.purAmountWithTax === null || m.purAmountWithTax === undefined) return null;
      const paidTotal = this.detailSummaryPaidAmount;
      if (paidTotal === null) return null;
      // 调用 subtractCpAmount：采购含税金额 − 已支付，避免浮点误差
      const pending = subtractCpAmount(m.purAmountWithTax, paidTotal);
      return pending > 0 ? pending : 0;
    },
    /** 详情订单明细行数，供标题区展示 */
    detailItemListCount() {
      return ((this.detail && this.detail.itemList) || []).length;
    },
    /**
     * 详情订单明细表格高度：按 itemList 行数自适应，最多展开 20 行后再在表格内滚动。
     * 调用处：订单明细 Tab el-table :max-height
     */
    detailItemTableMaxHeight() {
      const n = this.detailItemListCount;
      if (n <= 0) return 200;
      const rowH = 42;
      const headerH = 42;
      const total = headerH + n * rowH;
      const cap = headerH + 20 * rowH;
      return Math.min(total, cap);
    },
    /** 导出按钮提示：全局全选 / 本页勾选 */
    exportHint() {
      if (this.selectedRows && this.selectedRows.length > 0) return '(已勾选)';
      return '';
    },
    /**
     * 登记发票弹框副标题：已添加发票数 + 关联采购单号（与需求稿信息结构一致）。
     * 调用方：模板「发票登记」弹框标题区。
     */
    invoiceDialogSubtitle() {
      const cnt = (this.invoiceForm.invoiceList || []).length;
      const nos = [...new Set((this.invoiceForm.itemList || []).map((i) => i.purchaseNo).filter(Boolean))];
      let part = '';
      if (nos.length <= 3) {
        part = nos.join('、');
      } else if (nos.length > 3) {
        part = `${nos.slice(0, 3).join('、')}…`;
      }
      return `已添加 ${cnt} 张发票 | 关联采购单 ${part || '—'}`;
    },
    /**
     * 右侧发票列表价税合计（仅统计可提交行：valid 不为 false）。
     * 调用方：发票信息区底部小计。
     */
    invoiceBillSummary() {
      const list = (this.invoiceForm.invoiceList || []).filter((r) => r && r.valid !== false);
      // 调用 sumCpAmounts / subtractCpAmount：发票列表价税合计
      const amountWithoutTax = sumCpAmounts(list.map((row) => row.amountWithoutTax));
      const amountWithTax = sumCpAmounts(list.map((row) => row.amountWithTax));
      const taxAmount = sumCpAmounts(list.map((row) => subtractCpAmount(row.amountWithTax, row.amountWithoutTax)));
      return { amountWithoutTax, taxAmount, amountWithTax };
    },
    /**
     * 登记发票弹框汇总金额（采购明细区；含税单价×数量 → 含税/(1+r) → 税额）。
     * 不含抵扣扣减（界面已移除抵扣金额，提交时 deductAmount 固定为 0）。
     */
    invoiceSummary() {
      const items = this.invoiceForm.itemList || [];
      const partsList = items.map((row) => this.computeInvoiceLineAmountParts(row));
      // 调用 sumCpAmounts：采购明细区价税小计
      const grossAmountWithTax = sumCpAmounts(partsList.map((p) => p.amountWithTax));
      const grossTaxAmount = sumCpAmounts(partsList.map((p) => p.taxAmount));
      const grossAmountWithoutTax = sumCpAmounts(partsList.map((p) => p.amountWithoutTax));
      return {
        grossAmountWithoutTax,
        grossTaxAmount,
        grossAmountWithTax,
        amountWithTax: grossAmountWithTax,
        taxAmount: grossTaxAmount
      };
    },
  },
  created() {
    // 调用筛选缓存：按路由设置 keep-alive 组件名
    applyCpKeepAliveRouteName(this, this.$route.path);
  },
  mounted() {
    this.initCpEnterpriseOptions();
    /** 加载结算端筛选下拉选项（供应商/客户/审核人），再拉列表 */
    this.loadSettlementFilterOptions();
    // 调用筛选缓存恢复：切换菜单返回后还原条件
    this.restoreListFilterCache();
    this.loadPage();
  },
  beforeRouteUpdate(to, from, next) {
    // 调用筛选缓存：结算端/供应商门户订单页签互切时分别存取
    this.saveListFilterCache(from.path);
    applyCpKeepAliveRouteName(this, to.path);
    this.restoreListFilterCache();
    this.loadPage();
    next();
  },
  beforeRouteLeave(to, from, next) {
    // 调用筛选缓存：离开页面前写入 sessionStorage
    this.saveListFilterCache(from.path);
    next();
  },
  activated() {
    applyCpKeepAliveRouteName(this, this.$route.path);
  },
  deactivated() {
    // 调用筛选缓存：页签仍打开但被 keep-alive 挂起时保存
    this.saveListFilterCache();
  },
  methods: {
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    /**
     * 加载采购主体/销售组织下拉：与 invoiceAccount 等公司下拉的 ALLENTERPRISEINFOLIST 一致。
     */
    initCpEnterpriseOptions() {
      try {
        const raw = sessionStorage.getItem('ALLENTERPRISEINFOLIST');
        this.enterpriseInfoList = raw ? JSON.parse(raw) || [] : [];
      } catch (e) {
        this.enterpriseInfoList = [];
      }
    },
    /**
     * 公司下拉展示：编码-名称（列表筛选用）。
     * @param item 主数据公司行
     */
    formatEnterpriseLabel(item) {
      if (!item) return '';
      const c = item.companyCode || '';
      const n = item.companyName || '';
      if (c && n) return `${c}-${n}`;
      return c || n;
    },
    /**
     * 结算端筛选下拉展示：code-name。
     * @param opt 后端 SupplierSpOptionDTO 结构 { code, name }
     */
    formatCpFilterOptionLabel(opt) {
      if (!opt) return '';
      const c = opt.code != null ? String(opt.code) : '';
      const n = opt.name != null ? String(opt.name) : '';
      if (c && n) return `${c}-${n}`;
      return c || n;
    },
    /**
     * 供应商门户受限账号的销售方权限编码：优先 WORKCODES，空则回退 PLATFORMCODE。
     * 调用方：supplierPortalSellerOptions
     */
    resolveSupplierPortalAllowedCodes() {
      const raw = sessionStorage.getItem('WORKCODES');
      const parsed = raw ? JSON.parse(raw) : [];
      const codes = Array.isArray(parsed) ? parsed.filter(Boolean).map((c) => String(c).trim()) : [];
      if (codes.length) {
        return codes;
      }
      const platform = sessionStorage.getItem('PLATFORMCODE');
      return platform ? [String(platform).trim()] : [];
    },
    /**
     * 供应商门户筛选下拉展示：仅名称。
     * @param opt 后端 SupplierSpOptionDTO 结构 { code, name }
     */
    formatCpFilterOptionName(opt) {
      if (!opt) return '';
      const n = opt.name != null ? String(opt.name) : '';
      const c = opt.code != null ? String(opt.code) : '';
      return n || c;
    },
    /**
     * 拉取结算端筛选项（多选下拉数据源），接口失败则保持空数组。
     */
    async loadSettlementFilterOptions() {
      const res = await this.$api.cpSettlementSalePurchaseOrderFilterOptions().catch(() => null);
      if (res && res.code === 200 && res.result) {
        this.settlementSupplierOptions = res.result.supplierOptions || [];
        this.settlementCustomerOptions = res.result.customerOptions || [];
        this.settlementAuditUserOptions = res.result.auditUserOptions || [];
      }
    },
    /**
     * 结算/供应商列表行是否已勾选（全局全选时本页行均视为选中）。
     * @param row 表格行
     */

    /**
     * 表头全局全选切换：勾选表示按当前查询条件导出全部；取消则清空勾选态。
     * @param checked 是否全局全选
     */

    /**
     * 将采购主体编码、销售组织选中项转后端查询字段（按 code 精确匹配）。
     * @param payload 查询体
     */
    fillSettlementEnterpriseFilters(payload) {
      if (this.queryForm.paymentPayerCode) {
        payload.paymentPayerCode = this.queryForm.paymentPayerCode;
      }
      if (this.queryForm.salesOrgLevel1Code) {
        // 调用一级销售组织筛选字段：按组织编码传 salesOrgCode 到后端精确过滤。
        payload.salesOrgCode = this.queryForm.salesOrgLevel1Code;
      }
      if (this.queryForm.salesOrgLevel2Code) {
        // 调用二级销售组织筛选字段：按组织编码传 secondSalesOrgCode 到后端精确过滤。
        payload.secondSalesOrgCode = this.queryForm.salesOrgLevel2Code;
      }
    },
    /**
     * 打开生成合同模版弹窗：仅支持勾选未登记合同的采购单。
     */
    openGenerateContractDialog() {
      if (!this.selectedRows || this.selectedRows.length < 1) {
        this.$message.warning('请先勾选订单');
        return;
      }
      const hasContract = this.selectedRows.some((row) => row.contractNo);
      if (hasContract) {
        this.$message.warning('仅支持勾选未登记合同的订单');
        return;
      }
      this.generateContractForm = { contractSignDate: '' };
      this.generateContractVisible = true;
    },
    /**
     * 提交生成合同模版：走异步任务导出，结果在任务管理下载。
     */
    async submitGenerateContractTemplate() {
      if (!this.generateContractForm.contractSignDate) {
        this.$message.warning('请选择签署日期');
        return;
      }
      const bmsBizOrderNos = this.selectedRows.map((row) => row.bmsBizOrderNo).filter(Boolean);
      if (!bmsBizOrderNos.length) {
        this.$message.warning('勾选行缺少业务单号');
        return;
      }
      this.generateContractLoading = true;
      // 调用合同模版异步生成接口，按采购单一单一合同生成 zip。
      const res = await this.$api.cpSettlementGenerateContractTemplate({
        bmsBizOrderNos,
        contractSignDate: this.generateContractForm.contractSignDate
      }).catch(() => null);
      this.generateContractLoading = false;
      if (res && res.code === 200) {
        this.generateContractVisible = false;
        this.$message.success('合同模版生成中，请前往任务管理-导出下载');
      }
    },
    /**
     * 批量上传合同：获取本次勾选采购单号集合。
     * 调用方：onBatchContractFileChange、validateBatchUploadContractOneToOne
     */
    getBatchUploadSelectedPurchaseNoSet() {
      const set = new Set();
      (this.selectedRows || []).forEach((row) => {
        const po = String(row.purchaseNo || '').trim();
        if (po) {
          set.add(po);
        }
      });
      return set;
    },
    /**
     * 校验批量上传合同与勾选订单一对一（数量相等且采购单号一一对应）。
     * 调用方：submitBatchUploadContract
     * @returns {string} 错误提示，空串表示通过
     */
    validateBatchUploadContractOneToOne() {
      const selectedCount = (this.selectedRows && this.selectedRows.length) || 0;
      const rows = this.batchUploadContractRows || [];
      if (rows.length !== selectedCount) {
        return `已勾选${selectedCount}个订单，请上传${selectedCount}份合同（当前${rows.length}份）`;
      }
      const selectedSet = this.getBatchUploadSelectedPurchaseNoSet();
      if (selectedSet.size !== selectedCount) {
        return '勾选订单缺少采购单号，无法批量上传';
      }
      const uploadedNos = [];
      for (const row of rows) {
        const po = String(row.purchaseNo || '').trim();
        if (!po) {
          return `文件「${row.fileName || ''}」未识别采购单号`;
        }
        if (!selectedSet.has(po)) {
          return `采购单${po}不在本次勾选范围内`;
        }
        uploadedNos.push(po);
      }
      for (const po of selectedSet) {
        const cnt = uploadedNos.filter((p) => p === po).length;
        if (cnt === 0) {
          return `采购单${po}缺少对应合同文件`;
        }
        if (cnt > 1) {
          return `采购单${po}只能对应一份合同`;
        }
      }
      return '';
    },
    /**
     * 关闭批量上传合同弹框时重置上传状态与表格数据。
     * 调用方：el-dialog @closed
     */
    resetBatchUploadContractDialog() {
      this.batchUploadContractRows = [];
      this.batchUploadContractLoading = false;
      const uploadRef = this.$refs.batchUploadContractUpload;
      if (uploadRef && uploadRef.clearFiles) {
        uploadRef.clearFiles();
      }
    },
    /**
     * 打开批量上传合同弹窗：需先勾选订单（单行/多行解析规则不同）；已登记合同允许覆盖上传。
     */
    openBatchUploadContractDialog() {
      if (!this.selectedRows || this.selectedRows.length < 1) {
        this.$message.warning('请先勾选订单');
        return;
      }
      // 调用 resetBatchUploadContractDialog：清空上次上传残留
      this.resetBatchUploadContractDialog();
      // 递增 key 重建 el-upload，避免 limit 内部计数残留
      this.batchUploadContractUploadKey += 1;
      this.batchUploadContractVisible = true;
    },
    /**
     * 合同编号体归一：字母大写，流水前「-」按原样保留（有则保留，无则不补）。
     * 调用方：normalizeBatchContractNo、parseBatchUploadContractFromFileName
     */
    normalizeBatchContractSeqFormat(contractNo) {
      if (!contractNo) {
        return '';
      }
      const trimmed = String(contractNo).trim();
      const match = trimmed.match(CP_CONTRACT_NO_NORMALIZE_REG);
      if (!match) {
        return trimmed;
      }
      const letters = match[1].toUpperCase();
      const datePart = match[2];
      const seqWithHyphen = match[3];
      const seqNoHyphen = match[4];
      if (seqWithHyphen) {
        return `${letters}-QX${datePart}-${seqWithHyphen}`;
      }
      if (seqNoHyphen) {
        return `${letters}-QX${datePart}${seqNoHyphen}`;
      }
      return `${letters}-QX${datePart}`;
    },
    /**
     * 从合同编号解析签署日期 yyyy-MM-dd。
     * 调用方：parseBatchUploadContractFromFileName、onBatchContractNoInput
     */
    parseBatchContractSignDateFromNo(contractNo) {
      const match = String(contractNo || '').match(/QX(\d{4})(\d{2})(\d{2})/i);
      if (!match) {
        return '';
      }
      return `${match[1]}-${match[2]}-${match[3]}`;
    },
    /**
     * 从文件名解析采购单号与合同编号（单行/多行规则不同）。
     * 调用方：onBatchContractFileChange
     */
    parseBatchUploadContractFromFileName(nameNoExt, purchaseNo, isMulti) {
      let raw = String(nameNoExt || '').trim();
      const po = String(purchaseNo || '').trim();
      if (isMulti) {
        const splitIdx = raw.indexOf('-');
        if (splitIdx < 1) {
          return { purchaseNo: '', contractNo: '' };
        }
        return {
          purchaseNo: raw.substring(0, splitIdx).trim(),
          contractNo: raw.substring(splitIdx + 1).trim()
        };
      }
      if (po) {
        if (raw.startsWith(`${po}-`)) {
          raw = raw.substring(po.length + 1).trim();
        } else if (raw.startsWith(`${po} `)) {
          raw = raw.substring(po.length + 1).trim();
        } else if (raw.startsWith(po)) {
          const rest = raw.substring(po.length).trim();
          if (/^[-\s]/.test(rest) || /^[A-Za-z]/.test(rest)) {
            raw = rest.replace(/^[-\s]+/, '');
          }
        }
      }
      const contractMatch = raw.match(CP_CONTRACT_NO_CORE_REG);
      if (contractMatch) {
        raw = contractMatch[0];
      }
      return { purchaseNo: po, contractNo: raw };
    },
    /**
     * 批量上传合同时规范化合同编号：去掉「供应商名+合同-」前缀，归一字母-QX日期+流水格式。
     * 调用方：onBatchContractFileChange 解析文件名后调用。
     */
    normalizeBatchContractNo(rawContractNo) {
      if (!rawContractNo) {
        return '';
      }
      const trimmed = String(rawContractNo).trim();
      const prefixIdx = trimmed.indexOf('合同-');
      let contractNo = prefixIdx >= 0 ? trimmed.substring(prefixIdx + 3).trim() : trimmed;
      // 调用 normalizeBatchContractSeqFormat：字母大写，保留流水前原有「-」
      contractNo = this.normalizeBatchContractSeqFormat(contractNo);
      return contractNo;
    },
    /**
     * 批量上传弹框合同编号编辑：联动解析签署日期。
     * 调用方：合同编号输入框 @input
     */
    onBatchContractNoInput(row) {
      if (!row) {
        return;
      }
      row.contractNo = this.normalizeBatchContractNo(row.contractNo);
      // 调用 parseBatchContractSignDateFromNo：从 QX 段回填签署日期
      row.contractSignDate = this.parseBatchContractSignDateFromNo(row.contractNo);
    },
    /**
     * 供应商门户附件上传：复用 /api/uploadFileToOss，落盘 dev/bms/{businessType} 并返回 OSS 域名完整链接。
     * @param {File} rawFile 原始文件
     * @param {string} businessType OSS 子目录（相对 dev/bms/，如 cp/purchaseContract）
     * @returns {Promise<string|null>} OSS 完整 URL
     */
    async uploadCpSupplierFileToOss(rawFile, businessType) {
      if (!rawFile || !businessType) {
        return null;
      }
      const formData = new FormData();
      formData.append('file', rawFile);
      formData.append('businessType', businessType);
      // 调用 uploadFileToOss：拼接 aliOssSpace + businessType 上传并返回 OSS 域名链接。
      const uploadRes = await this.$api
        .uploadFileToOss(formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .catch(() => null);
      if (uploadRes && uploadRes.code === 200 && uploadRes.result) {
        return uploadRes.result;
      }
      return null;
    },
    /**
     * 逐文件上传与校验：解析文件名中的采购单号与合同编码，调用后端校验接口。
     */
    async onBatchContractFileChange(file) {
      const rawFile = file && file.raw;
      if (!rawFile) return;
      // 仅处理新选中的文件，忽略 el-upload 内部状态变更重复触发
      if (file.status && file.status !== 'ready') {
        return;
      }
      const selectedCount = this.batchUploadContractLimit;
      if (selectedCount < 1) {
        this.$message.warning('请先勾选订单');
        return;
      }
      // 调用 batchUploadContractLimit：勾选几个单就允许上传几份合同
      if (this.batchUploadContractRows.length >= selectedCount) {
        this.$message.warning(`已勾选${selectedCount}个订单，最多上传${selectedCount}份合同`);
        return;
      }
      const isMulti = this.selectedRows && this.selectedRows.length > 1;
      const selectedPurchaseNo = this.selectedRows && this.selectedRows.length === 1
        ? (this.selectedRows[0].purchaseNo || '')
        : '';
      const row = {
        fileName: rawFile.name,
        purchaseNo: '',
        contractNo: '',
        contractSignDate: '',
        contractFileUrl: '',
        bmsBizOrderNo: '',
        valid: false,
        message: '上传中...'
      };
      this.batchUploadContractRows.push(row);
      const nameNoExt = rawFile.name.replace(/\.[^/.]+$/, '');
      // 调用 parseBatchUploadContractFromFileName：单行/多行文件名解析采购单号与合同编号
      const parsed = this.parseBatchUploadContractFromFileName(nameNoExt, selectedPurchaseNo, isMulti);
      row.purchaseNo = parsed.purchaseNo;
      row.contractNo = parsed.contractNo;
      if (isMulti) {
        if (!row.purchaseNo || !row.contractNo) {
          row.message = '文件名格式错误，应为：采购单号-合同编号';
          return;
        }
      } else {
        if (!row.contractNo) {
          row.message = '未能识别合同编号';
          return;
        }
        if (!row.purchaseNo && this.selectedRows && this.selectedRows.length >= 1) {
          row.purchaseNo = this.selectedRows[0].purchaseNo || '';
        }
        if (!row.purchaseNo) {
          row.message = '未找到采购单号';
          return;
        }
      }
      // 调用 getBatchUploadSelectedPurchaseNoSet：采购单号须在勾选范围内且不可重复
      const selectedPurchaseSet = this.getBatchUploadSelectedPurchaseNoSet();
      const purchaseNoTrimmed = String(row.purchaseNo || '').trim();
      if (!selectedPurchaseSet.has(purchaseNoTrimmed)) {
        row.message = '采购单号不在本次勾选范围内';
        return;
      }
      const duplicated = this.batchUploadContractRows.some(
        (item) => item !== row && String(item.purchaseNo || '').trim() === purchaseNoTrimmed
      );
      if (duplicated) {
        row.message = '该采购单已上传合同，请勿重复';
        return;
      }
      // 调用 normalizeBatchContractNo：去掉「供应商名+合同-」前缀并归一流水格式
      row.contractNo = this.normalizeBatchContractNo(row.contractNo);
      if (!row.contractNo) {
        row.message = '合同编号不能为空';
        return;
      }
      // 调用 parseBatchContractSignDateFromNo：从合同编号识别签署日期
      row.contractSignDate = this.parseBatchContractSignDateFromNo(row.contractNo);
      // 调用 uploadCpSupplierFileToOss：批量合同上传至 dev/bms/cp/purchaseContract。
      const contractFileUrl = await this.uploadCpSupplierFileToOss(rawFile, 'cp/purchaseContract');
      if (!contractFileUrl) {
        row.message = '文件上传失败';
        return;
      }
      row.contractFileUrl = contractFileUrl;
      // 调用合同上传校验接口，校验采购单与合同状态。
      const checkRes = await this.$api.cpSettlementCheckUploadContract({
        purchaseNo: row.purchaseNo,
        contractNo: row.contractNo,
        contractFileUrl: row.contractFileUrl
      }).catch(() => null);
      if (checkRes && checkRes.code === 200 && checkRes.result) {
        row.valid = !!checkRes.result.valid;
        row.message = checkRes.result.message || (row.valid ? '校验通过' : '校验失败');
        row.bmsBizOrderNo = checkRes.result.bmsBizOrderNo || '';
        return;
      }
      row.message = (checkRes && checkRes.message) || '校验失败';
    },
    /**
     * 提交批量上传合同：勾选订单与上传文件须一对一，且全部校验通过。
     */
    async submitBatchUploadContract() {
      // 调用 validateBatchUploadContractOneToOne：数量与采购单号一一对应
      const oneToOneMsg = this.validateBatchUploadContractOneToOne();
      if (oneToOneMsg) {
        this.$message.warning(oneToOneMsg);
        return;
      }
      const submitRows = this.batchUploadContractRows || [];
      const invalidRow = submitRows.find((row) => !row.valid);
      if (invalidRow) {
        this.$message.warning(`请修正校验未通过的合同：${invalidRow.fileName}`);
        return;
      }
      const missingFieldRow = submitRows.find((row) => !row.contractNo || !row.contractSignDate);
      if (missingFieldRow) {
        this.$message.warning('请填写合同编号和签署日期');
        return;
      }
      this.batchUploadContractLoading = true;
      // 提交前按最终合同编号重新校验，避免编辑后仍用旧校验结果
      for (const row of submitRows) {
        const checkRes = await this.$api.cpSettlementCheckUploadContract({
          purchaseNo: row.purchaseNo,
          contractNo: row.contractNo,
          contractFileUrl: row.contractFileUrl
        }).catch(() => null);
        if (!checkRes || checkRes.code !== 200 || !checkRes.result || !checkRes.result.valid) {
          this.batchUploadContractLoading = false;
          row.valid = false;
          row.message = (checkRes && checkRes.result && checkRes.result.message) || (checkRes && checkRes.message) || '校验失败';
          this.$message.warning(`合同校验失败：${row.fileName}`);
          return;
        }
        row.bmsBizOrderNo = checkRes.result.bmsBizOrderNo || row.bmsBizOrderNo;
      }
      const payload = {
        contractList: submitRows.map((row) => ({
          bmsBizOrderNo: row.bmsBizOrderNo,
          contractNo: row.contractNo,
          contractSignDate: row.contractSignDate,
          contractFileUrl: row.contractFileUrl
        }))
      };
      // 调用批量登记合同接口，落扩展表和合同表。
      const res = await this.$api.cpSettlementBatchRegisterContract(payload).catch(() => null);
      this.batchUploadContractLoading = false;
      if (res && res.code === 200) {
        this.$message.success('提交成功');
        this.batchUploadContractVisible = false;
        // 调用 resetBatchUploadContractDialog：提交成功后清空上传状态
        this.resetBatchUploadContractDialog();
        this.loadPage();
      }
    },
    /**
     * 打开销售合同上传弹窗：需先勾选至少一个采购单。
     * 调用处：结算端「销售合同上传」按钮
     */
    openSalesContractUploadDialog() {
      if (this.supplierMode) {
        return;
      }
      if (!this.selectedRows || this.selectedRows.length < 1) {
        this.$message.warning('请先勾选订单');
        return;
      }
      const purchaseNoList = this.selectedRows.map((row) => row.purchaseNo).filter(Boolean);
      if (!purchaseNoList.length) {
        this.$message.warning('勾选行缺少采购单号');
        return;
      }
      // 调用 resetSalesContractUploadDialog：清空上次上传残留
      this.resetSalesContractUploadDialog();
      this.salesContractUploadForm.purchaseNoList = purchaseNoList;
      this.salesContractUploadKey += 1;
      this.salesContractUploadVisible = true;
    },
    /**
     * 重置销售合同上传弹框表单。
     * 调用方：openSalesContractUploadDialog、弹框 @close、提交成功后
     */
    resetSalesContractUploadDialog() {
      this.salesContractUploadLoading = false;
      this.salesContractUploadForm = {
        purchaseNoList: this.salesContractUploadForm.purchaseNoList || [],
        fileName: '',
        salesContractNo: '',
        salesContractSignDate: '',
        salesContractFileUrl: ''
      };
    },
    /**
     * 清除已选销售合同附件，重建上传区以便重新选择。
     * 调用处：销售合同上传弹框文件卡片「删除」
     */
    clearSalesContractUploadFile() {
      this.salesContractUploadForm.fileName = '';
      this.salesContractUploadForm.salesContractNo = '';
      this.salesContractUploadForm.salesContractSignDate = '';
      this.salesContractUploadForm.salesContractFileUrl = '';
      this.salesContractUploadKey += 1;
    },
    /**
     * 从销售合同文件名提取合同编码（去扩展名）。
     * 调用方：onSalesContractFileChange
     */
    extractSalesContractNoFromFileName(fileName) {
      if (!fileName) {
        return '';
      }
      return String(fileName).replace(/\.[^/.]+$/, '').trim();
    },
    /**
     * 从销售合同编码中提取签订日期 yyyy-MM-dd（首个合法 8 位 yyyyMMdd）。
     * 兼容 HFXN-20260422-M05、BZKR20260611-3、SZQX-XMXZY-20260328、QXLG-JSWL2025121201、QXJT-YLTH20260807-F01、2026062301。
     * 调用方：onSalesContractFileChange
     */
    parseSalesContractSignDateFromNo(contractNo) {
      const text = String(contractNo || '');
      const re = /(\d{8})/g;
      let match;
      while ((match = re.exec(text)) !== null) {
        const y = Number(match[1].slice(0, 4));
        const m = Number(match[1].slice(4, 6));
        const d = Number(match[1].slice(6, 8));
        if (y >= 2000 && y <= 2100 && m >= 1 && m <= 12 && d >= 1 && d <= 31) {
          const mm = String(m).padStart(2, '0');
          const dd = String(d).padStart(2, '0');
          return `${y}-${mm}-${dd}`;
        }
      }
      return '';
    },
    /**
     * 销售合同文件变更：上传 OSS，并从文件名解析合同编码与日期。
     * 校验/上传失败时重建 el-upload，避免 limit=1 占住后无法再选文件。
     * 调用处：销售合同上传弹框 el-upload @on-change
     */
    async onSalesContractFileChange(file) {
      const rawFile = file && file.raw;
      if (!rawFile) {
        return;
      }
      if (file.status && file.status !== 'ready') {
        return;
      }
      if (rawFile.size > 20 * 1024 * 1024) {
        this.$message.warning('单个文件不超过 20MB');
        // 调用 remountSalesContractUpload：失败后允许重新选择
        this.remountSalesContractUpload();
        return;
      }
      // 调用 extractSalesContractNoFromFileName：文件名去扩展名作为合同编码
      const salesContractNo = this.extractSalesContractNoFromFileName(rawFile.name);
      // 调用 parseSalesContractSignDateFromNo：从合同编码提取签订日期
      const salesContractSignDate = this.parseSalesContractSignDateFromNo(salesContractNo);
      if (!salesContractNo) {
        this.$message.warning('未能识别合同编码');
        // 调用 remountSalesContractUpload：失败后允许重新选择
        this.remountSalesContractUpload();
        return;
      }
      if (!salesContractSignDate) {
        this.$message.warning('未能从合同编码解析签订日期，请检查文件名');
        // 调用 remountSalesContractUpload：失败后允许重新选择
        this.remountSalesContractUpload();
        return;
      }
      // 调用 uploadCpSupplierFileToOss：销售合同上传至 cp/salesContract
      const fileUrl = await this.uploadCpSupplierFileToOss(rawFile, 'cp/salesContract');
      if (!fileUrl) {
        this.$message.error('文件上传失败');
        // 调用 remountSalesContractUpload：失败后允许重新选择
        this.remountSalesContractUpload();
        return;
      }
      this.salesContractUploadForm.fileName = rawFile.name;
      this.salesContractUploadForm.salesContractNo = salesContractNo;
      this.salesContractUploadForm.salesContractSignDate = salesContractSignDate;
      this.salesContractUploadForm.salesContractFileUrl = fileUrl;
    },
    /**
     * 重建销售合同 el-upload，清空组件内部文件计数，便于再次选择。
     * 调用方：onSalesContractFileChange 校验/上传失败分支
     */
    remountSalesContractUpload() {
      this.salesContractUploadKey += 1;
    },
    /**
     * 提交销售合同上传：多采购单回写同一份合同信息。
     * 调用处：销售合同上传弹框「确认上传」
     */
    async submitSalesContractUpload() {
      if (!this.salesContractUploadForm.salesContractFileUrl) {
        this.$message.warning('请先上传合同文件');
        return;
      }
      if (!this.salesContractUploadForm.salesContractNo || !this.salesContractUploadForm.salesContractSignDate) {
        this.$message.warning('合同编码或签订日期缺失');
        return;
      }
      this.salesContractUploadLoading = true;
      const payload = {
        purchaseNoList: this.salesContractUploadForm.purchaseNoList,
        salesContractNo: this.salesContractUploadForm.salesContractNo,
        salesContractSignDate: this.salesContractUploadForm.salesContractSignDate,
        salesContractFileUrl: this.salesContractUploadForm.salesContractFileUrl
      };
      // 调用结算端销售合同上传接口
      const res = await this.$api.cpSettlementUploadSalesContract(payload).catch(() => null);
      this.salesContractUploadLoading = false;
      if (res && res.code === 200) {
        this.$message.success('上传成功');
        this.salesContractUploadVisible = false;
        this.loadPage();
        return;
      }
      this.$message.error((res && res.message) || '上传失败');
    },
    /**
     * 打开客户签收单上传弹窗：需先勾选至少一个采购单。
     * 调用处：结算端「客户签收单上传」按钮
     */
    openCustomerSignUploadDialog() {
      if (this.supplierMode) {
        return;
      }
      if (!this.selectedRows || this.selectedRows.length < 1) {
        this.$message.warning('请先勾选订单');
        return;
      }
      const purchaseNoList = this.selectedRows.map((row) => row.purchaseNo).filter(Boolean);
      if (!purchaseNoList.length) {
        this.$message.warning('勾选行缺少采购单号');
        return;
      }
      // 调用 resetCustomerSignUploadDialog：清空上次上传残留
      this.resetCustomerSignUploadDialog();
      this.customerSignUploadForm.purchaseNoList = purchaseNoList;
      this.customerSignUploadKey += 1;
      this.customerSignUploadVisible = true;
    },
    /**
     * 重置客户签收单上传弹框表单。
     * 调用方：openCustomerSignUploadDialog、弹框 @close、提交成功后
     */
    resetCustomerSignUploadDialog() {
      this.customerSignUploadLoading = false;
      this.customerSignUploadForm = {
        purchaseNoList: this.customerSignUploadForm.purchaseNoList || [],
        fileName: '',
        customerSignFileUrl: ''
      };
    },
    /**
     * 移除已选客户签收单附件，重建上传区以便重新选择。
     * 调用处：客户签收单上传弹框文件卡片「移除」
     */
    clearCustomerSignUploadFile() {
      this.customerSignUploadForm.fileName = '';
      this.customerSignUploadForm.customerSignFileUrl = '';
      this.customerSignUploadKey += 1;
    },
    /**
     * 客户签收单文件变更：上传 OSS 并缓存链接。
     * 调用处：客户签收单上传弹框 el-upload @on-change
     */
    async onCustomerSignFileChange(file) {
      const rawFile = file && file.raw;
      if (!rawFile) {
        return;
      }
      if (file.status && file.status !== 'ready') {
        return;
      }
      if (rawFile.size > 20 * 1024 * 1024) {
        this.$message.warning('单个文件不超过 20MB');
        this.customerSignUploadKey += 1;
        return;
      }
      // 调用 uploadCpSupplierFileToOss：客户签收单上传至 cp/customerSignOrder
      const fileUrl = await this.uploadCpSupplierFileToOss(rawFile, 'cp/customerSignOrder');
      if (!fileUrl) {
        this.$message.error('文件上传失败');
        this.customerSignUploadKey += 1;
        return;
      }
      this.customerSignUploadForm.fileName = rawFile.name;
      this.customerSignUploadForm.customerSignFileUrl = fileUrl;
    },
    /**
     * 提交客户签收单上传：多采购单回写同一签收单链接。
     * 调用处：客户签收单上传弹框「确认上传」
     */
    async submitCustomerSignUpload() {
      if (!this.customerSignUploadForm.customerSignFileUrl) {
        this.$message.warning('请先上传签收单文件');
        return;
      }
      this.customerSignUploadLoading = true;
      const payload = {
        purchaseNoList: this.customerSignUploadForm.purchaseNoList,
        customerSignFileUrl: this.customerSignUploadForm.customerSignFileUrl
      };
      // 调用结算端客户签收单上传接口
      const res = await this.$api.cpSettlementUploadCustomerSign(payload).catch(() => null);
      this.customerSignUploadLoading = false;
      if (res && res.code === 200) {
        this.$message.success('上传成功');
        this.customerSignUploadVisible = false;
        this.loadPage();
        return;
      }
      this.$message.error((res && res.message) || '上传失败');
    },
    /**
     * 打开客户回款维护弹窗：校验仅结算端可用且勾选同一销售订单号。
     */
    openCustomerPaymentDialog() {
      if (this.supplierMode) {
        return;
      }
      if (!this.selectedRows || this.selectedRows.length < 1) {
        this.$message.warning('请先勾选订单');
        return;
      }
      const salesOrderNo = this.selectedRows[0].salesOrderNo;
      if (!salesOrderNo) {
        this.$message.warning('所选订单缺少销售订单号');
        return;
      }
      const sameSalesOrder = this.selectedRows.every((row) => row.salesOrderNo === salesOrderNo);
      if (!sameSalesOrder) {
        this.$message.warning('仅支持勾选同一销售订单号的记录');
        return;
      }
      const sumSalesAmount = this.selectedRows.reduce((sum, row) => {
        const current = Number(row.salesAmountWithTax || 0);
        return sum + (Number.isNaN(current) ? 0 : current);
      }, 0);
      this.customerPaymentForm = {
        salesOrderNo,
        customerName: this.selectedRows[0].customerName || '',
        salesAmountWithTax: Number(sumSalesAmount.toFixed(2)),
        returnMoneyStatus: null /* 回款状态由回款金额与销售金额推导，见 submitCustomerPayment */
      };
      this.customerPaymentAmountInput = '';
      this.customerPaymentVisible = true;
    },
    /**
     * 打开合同登记弹窗：供应商门户下仅允许单选一行。
     */
    openContractDialog() {
      const row = this.selectedRows && this.selectedRows.length === 1 ? this.selectedRows[0] : null;
      if (!row) {
        this.$message.warning('请勾选一行订单');
        return;
      }
      this.contractForm = { bmsBizOrderNo: row.bmsBizOrderNo, contractNo: row.contractNo || '' };
      this.contractVisible = true;
    },
    /**
     * 打开签收登记弹窗：支持批量勾选；已签收订单允许重新上传覆盖 ext 并新增签收记录。
     */
    openSignDialog() {
      if (!this.selectedRows || this.selectedRows.length < 1) {
        this.$message.warning('请先勾选订单');
        return;
      }
      const purchaseNoList = this.selectedRows.map((row) => row.purchaseNo).filter(Boolean);
      if (!purchaseNoList.length) {
        this.$message.warning('勾选行缺少采购单号');
        return;
      }
      this.signForm = { qxSignStatus: 1, purchaseNoList, signFileList: [] };
      this.signVisible = true;
    },
    /**
     * 确认签收文件上传：文件名匹配已勾选采购单号后逐个上传。
     */
    async onSignFileChange(file) {
      const rawFile = file && file.raw;
      if (!rawFile) return;
      const fileName = rawFile.name || '';
      const isMulti = this.signForm.purchaseNoList.length > 1;
      let purchaseNo = '';
      // 多行勾选：从文件名提取采购单号校验；单行勾选：自动绑定当前勾选的采购单号，不校验文件名
      if (isMulti) {
        purchaseNo = fileName.replace(/\.[^/.]+$/, '');
      } else {
        purchaseNo = this.signForm.purchaseNoList[0] || '';
      }
      const row = {
        purchaseNo,
        signFileName: fileName,
        signFileUrl: '',
        valid: false,
        message: '校验中'
      };
      if (!purchaseNo || !this.signForm.purchaseNoList.includes(purchaseNo)) {
        row.message = isMulti ? '文件名与勾选采购单不匹配' : '未找到对应采购单';
        this.signForm.signFileList.push(row);
        return;
      }
      const hasExists = this.signForm.signFileList.some((item) => item.purchaseNo === purchaseNo && item.valid);
      if (hasExists) {
        row.message = '该采购单已上传签收单';
        this.signForm.signFileList.push(row);
        return;
      }
      // 调用 uploadCpSupplierFileToOss：确认签收上传至 dev/bms/cp/qxSignOrder。
      const signFileUrl = await this.uploadCpSupplierFileToOss(rawFile, 'cp/qxSignOrder');
      if (!signFileUrl) {
        row.message = '上传失败';
        this.signForm.signFileList.push(row);
        return;
      }
      row.signFileUrl = signFileUrl;
      row.valid = true;
      row.message = '已匹配';
      this.signForm.signFileList.push(row);
    },
    /**
     * 删除签收弹窗中已添加的单条文件记录（错传或未匹配等，删后可重新上传）。
     * 调用方：确认签收弹窗签收文件表「删除」按钮。
     * @param index 行下标
     */
    removeSignFileRow(index) {
      const list = this.signForm.signFileList || [];
      if (index < 0 || index >= list.length) return;
      list.splice(index, 1);
    },
    /**
     * 删除批量上传合同弹窗中已添加的单条文件记录。
     */
    removeBatchContractRow(index) {
      const list = this.batchUploadContractRows || [];
      if (index < 0 || index >= list.length) return;
      list.splice(index, 1);
    },
    /**
     * 打开发票登记弹窗：勾选校验通过后调预览接口再展示（购/销方与列表付款主体、供应商一致）。
     */
    async openInvoiceDialog() {
      /* 新开登记前清空头行税号，避免沿用上一次的 facilitator/platform 缓存 */
      this.invoiceRegisterPartyTaxBuyer = '';
      this.invoiceRegisterPartyTaxSeller = '';
      if (!this.selectedRows || this.selectedRows.length < 1) {
        this.$message.warning('请先勾选订单');
        return;
      }
      // 调用 getInvoiceRegisterBuyerPartyKey / getInvoiceRegisterSellerPartyKey：与列表「采购方/销售方」同一主数据
      const fullyRows = this.selectedRows.filter((row) => Number(row.invoiceStatus) === 2);
      if (fullyRows.length) {
        const nos = fullyRows.map((row) => row.purchaseNo).filter(Boolean).join('、');
        this.$message.warning(`以下采购单已完全开票，无法登记：${nos}`);
        return;
      }
      const notAllowRows = this.selectedRows.filter((row) => !(Number(row.invoiceStatus) === 0 || Number(row.invoiceStatus) === 1));
      if (notAllowRows.length) {
        this.$message.warning('仅待开票、部分开票状态的订单支持登记发票');
        return;
      }
      const firstRow = this.selectedRows[0];
      const firstBuyerKey = this.getInvoiceRegisterBuyerPartyKey(firstRow);
      const firstSellerKey = this.getInvoiceRegisterSellerPartyKey(firstRow);
      const partyMismatch = this.selectedRows.find(
        (row) => this.getInvoiceRegisterBuyerPartyKey(row) !== firstBuyerKey || this.getInvoiceRegisterSellerPartyKey(row) !== firstSellerKey
      );
      if (partyMismatch) {
        this.$message.warning('仅支持同一采购方（付款主体）、同一销售方的订单批量登记，请调整勾选');
        return;
      }
      const purchaseNoList = this.selectedRows.map((row) => row.purchaseNo).filter(Boolean);
      const previewPayload = { purchaseNos: purchaseNoList };
      // 调用预览接口加载左侧采购单明细（含待开数量）。
      const previewRes = await this.$api.cpSupplierSalePurchaseOrderRegisterInvoicePreview(previewPayload).catch(() => null);
      if (!previewRes || previewRes.code !== 200 || !previewRes.result) {
        return;
      }
      const preview = previewRes.result;
      const fallbackBuyerName = (firstRow && firstRow.paymentPayerName) || (firstRow && firstRow.customerName) || '';
      this.invoiceForm = {
        purchaseNoList,
        paymentPayerCode: (firstRow && firstRow.paymentPayerCode) || '',
        buyerName: preview.buyerName || fallbackBuyerName,
        supplierCode: (firstRow && firstRow.supplierCode) || '',
        sellerName: preview.sellerName || (firstRow && firstRow.supplierName) || '',
        deductAmount: 0,
        itemList: (preview.itemList || []).map((item) => this.mapRegisterInvoicePreviewItem(item)),
        invoiceList: []
      };
      this.invoiceVisible = true;
      // 调用 refreshInvoiceRegisterPartyTaxNos：头行展示购/销方税号（异步填充）
      this.refreshInvoiceRegisterPartyTaxNos();
    },
    /**
     * 按 facilitator_code 分页查 facilitator 取纳税人识别号（登记发票抽屉头「购买方税号」，复用 queryFacilitatorPage）。
     * 调用处：refreshInvoiceRegisterPartyTaxNos
     * @param {string} facilitatorCode 付款主体编码
     */
    async fetchInvoiceRegisterBuyerTaxNumber(facilitatorCode) {
      const code = facilitatorCode != null ? String(facilitatorCode).trim() : '';
      if (!code) return '';
      const res = await this.$api.queryFacilitatorPage(
        { facilitatorCode: code, pageNo: 1, pageSize: 1 },
        { isHideLoading: true }
      ).catch(() => null);
      if (!res || res.code !== 200 || !res.result || !Array.isArray(res.result.list) || !res.result.list.length) {
        return '';
      }
      const n = res.result.list[0] && res.result.list[0].taxpayerNumber;
      return n != null && String(n).trim() !== '' ? String(n).trim() : '';
    },
    /**
     * 按 platform_code 分页查 platform 取纳税人识别号（登记发票抽屉头「销售方税号」，supplierCode 实为平台供应商编码）。
     * 调用处：refreshInvoiceRegisterPartyTaxNos
     * @param {string} platformCode 供应商编码
     */
    async fetchInvoiceRegisterSellerTaxNumber(platformCode) {
      const code = platformCode != null ? String(platformCode).trim() : '';
      if (!code) return '';
      const res = await this.$api.PlatformQueryListPage(
        { platformCode: code, pageNo: 1, pageSize: 1 },
        { isHideLoading: true }
      ).catch(() => null);
      if (!res || res.code !== 200 || !res.result || !Array.isArray(res.result.list) || !res.result.list.length) {
        return '';
      }
      const n = res.result.list[0] && res.result.list[0].taxpayerNumber;
      return n != null && String(n).trim() !== '' ? String(n).trim() : '';
    },
    /**
     * 登记发票抽屉打开后并行拉取购买方（facilitator）与销售方（platform）税号并写满头行。
     * 调用处：openInvoiceDialog（预览成功后）
     */
    async refreshInvoiceRegisterPartyTaxNos() {
      const payerCode = this.invoiceForm && this.invoiceForm.paymentPayerCode;
      const supplierCode = this.invoiceForm && this.invoiceForm.supplierCode;
      const [buyerTax, sellerTax] = await Promise.all([
        this.fetchInvoiceRegisterBuyerTaxNumber(payerCode),
        this.fetchInvoiceRegisterSellerTaxNumber(supplierCode)
      ]);
      this.invoiceRegisterPartyTaxBuyer = buyerTax || '';
      this.invoiceRegisterPartyTaxSeller = sellerTax || '';
    },
    /**
     * 票面文件上传变化处理：上传文件并写入右侧识别列表（当前仅票面识别占位）。
     */
    async onInvoiceFileChange(file) {
      const rawFile = file && file.raw;
      if (!rawFile) return;
      const row = {
        invoiceType: 2,
        invoiceNo: '',
        invoiceCode: '',
        invoiceDate: '',
        buyerName: this.invoiceForm.buyerName,
        buyerTaxNo: '',
        sellerName: this.invoiceForm.sellerName,
        sellerTaxNo: '',
        amountWithoutTax: 0,
        taxAmount: 0,
        amountWithTax: 0,
        imageUrl: '',
        ocrChangedFlag: 1,
        valid: false,
        message: '上传中'
      };
      const formData = new FormData();
      formData.append('file', rawFile);
      // 调用通用上传接口写入 OSS，票面识别字段由用户补录。
      const uploadRes = await this.$api.uploadFile(formData).catch(() => null);
      if (!uploadRes || uploadRes.code !== 200 || !uploadRes.result || !uploadRes.result.url) {
        row.message = '上传失败，可手工补全票面或删除本行';
        row.valid = true;
        this.invoiceForm.invoiceList.push(row);
        return;
      }
      row.imageUrl = uploadRes.result.url;
      // 调用发票OCR接口识别票面信息（只识别票面，不识别明细）。
      const ocrRes = await this.$api.buyInvoiceOcr({
        fileUrlList: [row.imageUrl],
        onlyOcrFirst: 1
      }).catch(() => null);
      if (ocrRes && ocrRes.code === 200 && ocrRes.result && ocrRes.result.length > 0) {
        const invoiceInfo = (ocrRes.result[0] && ocrRes.result[0].invoiceInfo) || {};
        row.invoiceNo = invoiceInfo.invoiceNumber || '';
        row.invoiceCode = invoiceInfo.invoiceCode || invoiceInfo.invoiceNumber || '';
        row.invoiceDate = this.normalizeOcrDate(invoiceInfo.invoiceDate);
        row.buyerName = invoiceInfo.purchaserName || this.invoiceForm.buyerName || '';
        row.buyerTaxNo = invoiceInfo.purchaserTaxNumber || '';
        row.sellerName = invoiceInfo.sellerName || this.invoiceForm.sellerName || '';
        row.sellerTaxNo = invoiceInfo.sellerTaxNumber || '';
        row.amountWithoutTax = toCpAmountNumber(invoiceInfo.invoiceAmountPreTax || 0);
        row.amountWithTax = toCpAmountNumber(invoiceInfo.totalAmount || 0);
        // 调用 subtractCpAmount：OCR 票面税额 = 含税 − 不含税
        row.taxAmount = subtractCpAmount(row.amountWithTax, row.amountWithoutTax);
        row.invoiceType = invoiceInfo.invoiceClassify === '2' ? 2 : 1;
        row.ocrChangedFlag = 0;
        row._ocrSnapshot = {
          invoiceNo: row.invoiceNo,
          invoiceCode: row.invoiceCode,
          amountWithTax: row.amountWithTax,
          taxAmount: row.taxAmount,
          buyerName: row.buyerName,
          buyerTaxNo: row.buyerTaxNo,
          sellerTaxNo: row.sellerTaxNo
        };
        row.message = '识别成功';
      } else {
        row.message = '识别失败，请手工录入票面';
        row.ocrChangedFlag = 1;
      }
      row.valid = true;
      this.invoiceForm.invoiceList.push(row);
    },
    /**
     * OCR日期格式统一为 yyyy-MM-dd
     */
    normalizeOcrDate(rawDate) {
      if (!rawDate) return '';
      const text = String(rawDate).replace('年', '-').replace('月', '-').replace('日', '');
      const split = text.split('-');
      if (split.length !== 3) return text;
      return `${split[0]}-${String(split[1]).padStart(2, '0')}-${String(split[2]).padStart(2, '0')}`;
    },
    /**
     * 单行发票税额：价税合计 − 不含税（与 platformInvoiceRegister 税金列算法一致）。
     * 调用处：发票信息表「税额」列；onInvoiceAmountChange；onInvoiceFieldManualChange（与 OCR 快照比对）；submitInvoice 亦可据此提交。
     * @param {object} row 发票列表行
     */
    computeInvoiceBillRowTaxAmount(row) {
      // 调用 subtractCpAmount：价税合计 − 不含税
      return subtractCpAmount((row && row.amountWithTax) || 0, (row && row.amountWithoutTax) || 0);
    },
    /**
     * 不含税/含税变更后同步 row.taxAmount 并触发票面变更标记。
     * 调用处：发票信息表不含税、含税 el-input-number 的 @change。
     * @param {object} row 发票列表行
     */
    onInvoiceAmountChange(row) {
      if (row) {
        row.taxAmount = this.computeInvoiceBillRowTaxAmount(row);
      }
      this.onInvoiceFieldManualChange(row);
    },
    /**
     * 票面字段手工改动时，按OCR改动逻辑回写 ocrChangedFlag。
     */
    onInvoiceFieldManualChange(row) {
      if (!row) return;
      if (!row._ocrSnapshot) {
        row.ocrChangedFlag = 1;
        return;
      }
      const same = String(row.invoiceNo || '') === String(row._ocrSnapshot.invoiceNo || '')
        && String(row.invoiceCode || '') === String(row._ocrSnapshot.invoiceCode || '')
        // 调用 cpAmountEquals：票面金额与 OCR 快照精确比对
        && cpAmountEquals(row.amountWithTax, row._ocrSnapshot.amountWithTax)
        && cpAmountEquals(this.computeInvoiceBillRowTaxAmount(row), row._ocrSnapshot.taxAmount)
        && String(row.buyerName || '') === String(row._ocrSnapshot.buyerName || '')
        && String(row.buyerTaxNo || '') === String(row._ocrSnapshot.buyerTaxNo || '')
        && String(row.sellerTaxNo || '') === String(row._ocrSnapshot.sellerTaxNo || '');
      row.ocrChangedFlag = same ? 0 : 1;
    },
    /**
     * 按回款金额与销售金额推导回款状态（0 未回款 / 1 部分回款 / 2 已回款），阈值与原先 submitCustomerPayment 分支一致〔≥销售金额−1 元或票面舍入视为全额到账〕。
     * 调用处：submitCustomerPayment 提交前赋值 customerPaymentForm.returnMoneyStatus。
     * @param {number} amount 解析后的回款金额
     * @param {number} salesTotal 销售金额
     * @returns {0|1|2|null} null 表示金额超过销售金额
     */
    inferReturnMoneyStatusFromPaymentAmount(amount, salesTotal) {
      const eps = 1e-6;
      const amt = Number(amount);
      const st = Number(salesTotal) || 0;
      if (!Number.isFinite(amt)) return null;
      if (amt > st + eps) return null;
      if (amt <= 0 + eps) return 0;
      const nearPaid =
        amt >= st - 1 - eps ||
        (st > 0 && Math.abs(st - amt) <= 0.01 + eps);
      if (nearPaid) return 2;
      return 1;
    },
    /**
     * 客户回款弹框：将金额输入框解析为数字，空或非数字返回 NaN。
     * 调用处：submitCustomerPayment。
     */
    getCustomerPaymentParsedAmount() {
      const raw = (this.customerPaymentAmountInput || '').trim();
      if (raw === '') return NaN;
      const n = Number(raw);
      return Number.isFinite(n) ? n : NaN;
    },
    /**
     * 客户回款弹框：限制为金额数字输入（可选一个小数点，最多两位小数）。
     * 调用处：回款维护弹框带币种前缀 el-input @input。
     */
    onCustomerPaymentAmountFieldInput(val) {
      let s = val === null || val === undefined ? '' : String(val);
      s = s.replace(/[^\d.]/g, '');
      const firstDot = s.indexOf('.');
      if (firstDot >= 0) {
        s = s.slice(0, firstDot + 1) + s.slice(firstDot + 1).replace(/\./g, '');
      }
      const parts = s.split('.');
      if (parts.length > 1) {
        parts[1] = parts[1].slice(0, 2);
        s = `${parts[0]}.${parts[1]}`;
      }
      this.customerPaymentAmountInput = s;
    },
    /**
     * 组装分页请求体：结算端按墨刀筛选项映射 Dubbo 查询；供应商端沿用原字段。
     */
    /**
     * 解析单号批量关键词：支持英文/中文逗号、空格、分号等分隔。
     * @param raw 输入框原文
     * @returns 去重后的单号数组
     */
    splitOrderNoKeywords(raw) {
      return (raw || '')
        .trim()
        .split(/[\s,，;；]+/)
        .map((s) => s.trim())
        .filter(Boolean);
    },
    /**
     * 将「客户名称」按空格拆分为多选模糊条件，写入 payload.customerNames（不填则不传）。
     * @param payload 请求体
     */
    appendCustomerNameMultiToPayload(payload) {
      const parts = (this.queryForm.customerName || '')
        .trim()
        .split(/\s+/)
        .filter(Boolean);
      if (parts.length === 0) return;
      if (parts.length === 1) {
        payload.customerName = parts[0];
        return;
      }
      payload.customerNames = parts;
    },
    /**
     * 将采购含税金额区间写入 payload（purAmountWithTaxMin/Max，对应主表 pur_amount_with_tax）。
     * 调用方：buildPagePayload 结算端分支
     * @param payload 请求体
     */
    appendPurAmountRangeToPayload(payload) {
      const minRaw = this.queryForm.purAmountMin;
      const maxRaw = this.queryForm.purAmountMax;
      const minNum = minRaw !== '' && minRaw != null ? Number(minRaw) : null;
      const maxNum = maxRaw !== '' && maxRaw != null ? Number(maxRaw) : null;
      if (minNum != null && !Number.isNaN(minNum)) {
        payload.purAmountWithTaxMin = minNum;
      }
      if (maxNum != null && !Number.isNaN(maxNum)) {
        payload.purAmountWithTaxMax = maxNum;
      }
    },
    buildPagePayload() {
      const payload = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      };
      if (this.supplierMode) {
        // 调用点：供应商门户采购单号支持空格/逗号批量 IN 查询。
        const parts = this.splitOrderNoKeywords(this.queryForm.purchaseKeywords);
        if (parts.length > 0) payload.purchaseNos = parts;
        // 调用点：供应商门户销售单号支持空格/逗号批量 IN 查询。
        const salesOrderParts = this.splitOrderNoKeywords(this.queryForm.salesOrderNo);
        if (salesOrderParts.length > 0) payload.salesOrderNos = salesOrderParts;
        // 调用点：BMS 业务单号支持空格/逗号批量 IN 查询。
        const bmsParts = this.splitOrderNoKeywords(this.queryForm.bmsBizOrderNo);
        if (bmsParts.length === 1) {
          payload.bmsBizOrderNo = bmsParts[0];
        } else if (bmsParts.length > 1) {
          payload.bmsBizOrderNos = bmsParts;
        }
        // 调用客户名称下拉多选参数：按客户编码集合查询。
        if (this.queryForm.customerCodes && this.queryForm.customerCodes.length > 0) {
          payload.customerCodes = [...this.queryForm.customerCodes];
        }
        // 调用审核人下拉多选参数：按创建人 userId 集合查询。
        if (this.queryForm.auditUserIds && this.queryForm.auditUserIds.length > 0) {
          payload.auditUserIds = [...this.queryForm.auditUserIds];
        }
        payload.paymentPayerCode = this.queryForm.paymentPayerCode;
        // 调用付款状态多选：写入 paymentStatuses IN 条件。
        this.appendPaymentStatusesToPayload(payload);
        if (this.queryForm.contractStatus !== null && this.queryForm.contractStatus !== undefined) {
          payload.contractStatus = this.queryForm.contractStatus;
        }
        if (this.queryForm.invoiceStatus !== null && this.queryForm.invoiceStatus !== undefined) {
          payload.invoiceStatus = this.queryForm.invoiceStatus;
        }
        // 调用处：供应商门户销售方多选，后端与权限编码求交集后写入 forceSupplierCodeList
        if (this.queryForm.supplierCodes && this.queryForm.supplierCodes.length > 0) {
          payload.supplierCodes = [...this.queryForm.supplierCodes];
        }
      } else {
        if (this.queryForm.supplierCodes && this.queryForm.supplierCodes.length > 0) {
          payload.supplierCodes = [...this.queryForm.supplierCodes];
        }
        if (this.queryForm.customerCodes && this.queryForm.customerCodes.length > 0) {
          payload.customerCodes = [...this.queryForm.customerCodes];
        }
        if (this.queryForm.auditUserIds && this.queryForm.auditUserIds.length > 0) {
          payload.auditUserIds = [...this.queryForm.auditUserIds];
        }
        payload.customerCode = this.queryForm.customerCode;
        // 结算端：采购主体/销售组织下拉与公司主数据一致
        this.fillSettlementEnterpriseFilters(payload);
        // 调用付款状态多选：写入 paymentStatuses IN 条件。
        this.appendPaymentStatusesToPayload(payload);
        if (this.queryForm.invoiceStatus !== null && this.queryForm.invoiceStatus !== undefined) {
          payload.invoiceStatus = this.queryForm.invoiceStatus;
        }
        if (this.queryForm.salesInvoiceStatus !== null && this.queryForm.salesInvoiceStatus !== undefined) {
          payload.salesInvoiceStatus = this.queryForm.salesInvoiceStatus;
        }
        if (this.queryForm.returnMoneyStatus !== null && this.queryForm.returnMoneyStatus !== undefined) {
          payload.returnMoneyStatus = this.queryForm.returnMoneyStatus;
        }
        // 调用点：结算端采购含税金额区间写入查询体。
        this.appendPurAmountRangeToPayload(payload);
        // 调用点：结算端业务模式多选写入 businessModes IN 条件。
        this.appendBusinessModesToPayload(payload);
        // 调用点：结算列表按页签 valid_flag 筛选（全部不传；已生效=1；OMS处理中=0）。
        if (this.settlementValidFlagTab === 'effective') {
          payload.validFlag = 1;
        } else if (this.settlementValidFlagTab === 'oms') {
          payload.validFlag = 0;
        }
        // 调用点：结算端单号框按类型映射批量 IN 条件（空格/逗号分隔）。
        const parts = this.splitOrderNoKeywords(this.queryForm.purchaseKeywords);
        if (parts.length > 0) {
          if (this.queryForm.purchaseOrderKind === 'salesOrderNo') {
            payload.salesOrderNos = parts;
          } else if (this.queryForm.purchaseOrderKind === 'bmsBizOrderNo') {
            if (parts.length === 1) {
              payload.bmsBizOrderNo = parts[0];
            } else {
              payload.bmsBizOrderNos = parts;
            }
          } else {
            payload.purchaseNos = parts;
          }
        }
      }
      // 调用点：有单号精确筛选时不叠加日期（避免 purchase_order_date 为空导致查不到）。
      if (!this.hasCpOrderNoFilter(payload) && this.dateRange && this.dateRange.length === 2) {
        if (this.dateFieldType === 'purchaseOrderDate') {
          payload.purchaseOrderDateStart = this.dateRange[0];
          payload.purchaseOrderDateEnd = this.dateRange[1];
        } else if (this.dateFieldType === 'createTime') {
          payload.createTimeStart = this.dateRange[0];
          payload.createTimeEnd = this.dateRange[1];
        }
      }
      return payload;
    },
    /**
     * 请求体是否已带采购/销售/BMS 单号批量条件（用于决定是否叠加日期区间）。
     * @param payload 分页查询体
     */
    hasCpOrderNoFilter(payload) {
      if (!payload) return false;
      if (payload.purchaseNos && payload.purchaseNos.length > 0) return true;
      if (payload.salesOrderNos && payload.salesOrderNos.length > 0) return true;
      if (payload.bmsBizOrderNo) return true;
      if (payload.bmsBizOrderNos && payload.bmsBizOrderNos.length > 0) return true;
      return false;
    },
    /**
     * 点击查询/回车：回到第一页再拉列表，避免停留在高页码时单号筛选结果为空。
     */
    onSearchQuery() {
      this.pageNo = 1;
      this.loadPage();
    },
    /**
     * 结算端生效状态页签切换：映射 valid_flag 并刷新列表。
     */
    onSettlementValidFlagTabChange() {
      this.pageNo = 1;
      this.loadPage();
    },
    /**
     * 供应商页签切换：映射发票状态筛选（全部/待开票/已开票）。
     */
    onSupplierInvoiceTabChange() {
      if (this.supplierInvoiceTab === 'pending') {
        this.queryForm.invoiceStatus = 0;
      } else if (this.supplierInvoiceTab === 'invoiced') {
        this.queryForm.invoiceStatus = 2;
      } else {
        this.queryForm.invoiceStatus = null;
      }
      this.pageNo = 1;
      this.loadPage();
    },
    /** 加载订单分页列表：按门户类型调用对应 Dubbo 网关接口 */
    async loadPage() {
      this.loading = true;
      const payload = this.buildPagePayload();
      const fn = this.supplierMode ? this.$api.cpSupplierSalePurchaseOrderPage : this.$api.cpSettlementSalePurchaseOrderPage;
      const res = await fn(payload);
      this.loading = false;
      if (res.code === 200 && res.result) {
        this.tableData = res.result.list || [];
        this.totalCount = res.result.totalCount || 0;
        this.listTotalAmount = res.result.totalAmount || 0;
        this.listTotalAmount2 = res.result.totalAmount2 || 0;
        this.selectedRows = [];
      } else {
        this.tableData = [];
        this.totalCount = 0;
        this.listTotalAmount = 0;
        this.listTotalAmount2 = 0;
        this.selectedRows = [];
      }
    },
    /**
     * 组装列表筛选快照（供 sessionStorage 缓存）。
     * 调用处：saveListFilterCache。
     */
    buildListFilterSnapshot() {
      return {
        queryForm: { ...this.queryForm },
        dateRange: Array.isArray(this.dateRange) ? [...this.dateRange] : [],
        dateFieldType: this.dateFieldType,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        settlementValidFlagTab: this.settlementValidFlagTab,
        supplierInvoiceTab: this.supplierInvoiceTab
      };
    },
    /**
     * 保存当前路由下的筛选条件。
     * @param {string} [routePath] 路由 path，默认当前页
     */
    saveListFilterCache(routePath) {
      saveCpFilterCache(routePath || this.$route.path, this.buildListFilterSnapshot());
    },
    /**
     * 从 sessionStorage 恢复筛选条件。
     * @returns {boolean} 是否成功恢复
     */
    restoreListFilterCache() {
      const cached = loadCpFilterCache(this.$route.path);
      if (!cached) return false;
      if (cached.queryForm) {
        this.queryForm = Object.assign(createEmptyQueryForm(), cached.queryForm);
      }
      if (Array.isArray(cached.dateRange)) {
        this.dateRange = cached.dateRange;
      }
      if (cached.dateFieldType) {
        this.dateFieldType = cached.dateFieldType;
      }
      if (cached.pageNo != null) {
        this.pageNo = cached.pageNo;
      }
      if (cached.pageSize != null) {
        this.pageSize = cached.pageSize;
      }
      if (cached.settlementValidFlagTab) {
        this.settlementValidFlagTab = cached.settlementValidFlagTab;
      }
      if (cached.supplierInvoiceTab) {
        this.supplierInvoiceTab = cached.supplierInvoiceTab;
      }
      return true;
    },
    /** 重置查询条件并重新拉取列表 */
    resetQuery() {
      // 调用筛选缓存：重置时清除当前路由缓存
      clearCpFilterCache(this.$route.path);
      this.queryForm = createEmptyQueryForm();
      this.dateRange = [];
      this.dateFieldType = 'purchaseOrderDate';
      this.supplierInvoiceTab = 'all';
      this.settlementValidFlagTab = 'all';
      this.pageNo = 1;
      this.loadPage();
    },
    onSizeChange(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.loadPage();
    },
    onPageChange(val) {
      this.pageNo = val;
      this.loadPage();
    },
    /** 打开详情弹窗：调用详情接口加载主单/扩展/明细，并并行拉取操作日志 */
    async openDetail(row) {
      if (!row) return;
      this.detailRowIndex = this.tableData.findIndex((r) => r && r.bmsBizOrderNo === row.bmsBizOrderNo);
      const body = { bmsBizOrderNo: row.bmsBizOrderNo, purchaseNo: row.purchaseNo };
      const fn = this.supplierMode ? this.$api.cpSupplierSalePurchaseOrderDetail : this.$api.cpSettlementSalePurchaseOrderDetail;
      const res = await fn(body);
      if (res.code === 200) {
        this.detail = res.result;
        this.detailActiveTab = 'basic';
        this.detailVisible = true;
        // 打开新单据时重置操作日志分页并从第一页加载（total 仅在此清零，避免与上一单据条数混淆；翻页请求中勿清零 total）
        this.detailOperateLogBizNo = row.bmsBizOrderNo || '';
        this.detailOperateLogPageNo = 1;
        this.detailOperateLogTotal = 0;
        this.detailPaymentPurchaseNo = row.purchaseNo || '';
        this.detailPaymentRecords = createEmptyDetailPaymentRecords();
        // 调用操作日志加载方法：依赖 BMS 业务单号，主请求成功后再触发
        this.loadDetailOperateLogs(this.detailOperateLogBizNo);
        // 调用支付记录加载：支付记录 Tab 明细展示；头部已支付/待支付取扩展表 payment_amount
        this.loadDetailPaymentRecords(this.detailPaymentPurchaseNo);
      }
    },
    /**
     * 加载详情操作日志：按当前模式（结算端 / 供应商端）选择后端接口，refCode = bms_biz_order_no；返回分页结构 list/totalCount。
     * @param bmsBizOrderNo BMS 业务单号
     */
    async loadDetailOperateLogs(bmsBizOrderNo) {
      // 加载中勿将 total 置 0：否则 el-pagination 会误判总页数并触发 current-change(1)，把用户点的第 2 页打回第 1 页
      this.detailOperateLogs = [];
      if (!bmsBizOrderNo) return;
      this.detailOperateLogsLoading = true;
      const fn = this.supplierMode
        ? this.$api.cpSupplierSalePurchaseOrderOperateLog
        : this.$api.cpSettlementSalePurchaseOrderOperateLog;
      // 请求体携带 pageNo/pageSize，后端返回 Pager（list、totalCount 等）
      const res = await fn({
        bmsBizOrderNo,
        pageNo: this.detailOperateLogPageNo,
        pageSize: this.detailOperateLogPageSize
      }).catch(() => null);
      this.detailOperateLogsLoading = false;
      if (res && res.code === 200 && res.result) {
        const p = res.result;
        this.detailOperateLogs = Array.isArray(p.list) ? p.list : [];
        this.detailOperateLogTotal = p.totalCount != null ? Number(p.totalCount) : 0;
        // 与后端当前页对齐（超页时服务端可能落在最后一页）
        if (p.page != null && p.page > 0) {
          this.detailOperateLogPageNo = p.page;
        }
      }
    },
    /**
     * 详情 Tab 切换：进入支付记录时按采购单号加载汇总付款单与预付单核销。
     * @param tab el-tabs 当前页签
     */
    onDetailTabClick(tab) {
      if (!tab) {
        return;
      }
      if (tab.name === 'payment') {
        // 调用支付记录加载方法：按采购单号查询 cp_payment_order / cp_prepay_verify_detail
        this.loadDetailPaymentRecords(this.detailPaymentPurchaseNo);
      }
      if (tab.name === 'items') {
        // 调用 refreshDetailItemTableLayout：Tab 从隐藏切为可见时重算表格布局
        this.refreshDetailItemTableLayout();
      }
    },
    /**
     * 订单明细表格布局刷新：Tab 首次展示时 el-table 需 doLayout 才能正确渲染全部行。
     * 调用处：onDetailTabClick 切换至订单明细 Tab
     */
    refreshDetailItemTableLayout() {
      this.$nextTick(() => {
        const table = this.$refs.detailItemTable;
        if (table && typeof table.doLayout === 'function') {
          table.doLayout();
        }
      });
    },
    /**
     * 加载详情支付记录：结算端/供应商端共用，按 purchaseNo 匹配 cp_payment_detail.biz_no。
     * @param purchaseNo 采购单号
     */
    async loadDetailPaymentRecords(purchaseNo) {
      this.detailPaymentRecords = createEmptyDetailPaymentRecords();
      if (!purchaseNo) {
        return;
      }
      this.detailPaymentRecordsLoading = true;
      const fn = this.supplierMode
        ? this.$api.cpSupplierSalePurchaseOrderPaymentRecords
        : this.$api.cpSettlementSalePurchaseOrderPaymentRecords;
      const res = await fn({
        purchaseNo,
        bmsBizOrderNo: this.detailOperateLogBizNo
      }).catch(() => null);
      this.detailPaymentRecordsLoading = false;
      if (res && res.code === 200 && res.result) {
        const data = res.result;
        this.detailPaymentRecords = {
          paymentSummaryRows: Array.isArray(data.paymentSummaryRows) ? data.paymentSummaryRows : [],
          // 调用处：支付记录 Tab「采购单支付金额」小计展示
          paymentPayAmountTotal: data.paymentPayAmountTotal != null ? data.paymentPayAmountTotal : 0,
          prepayVerifyRows: Array.isArray(data.prepayVerifyRows) ? data.prepayVerifyRows : [],
          prepayVerifyAmountTotal: data.prepayVerifyAmountTotal != null ? data.prepayVerifyAmountTotal : 0
        };
      }
    },
    /**
     * 汇总付款单状态展示：优先使用后端 statusName，缺失时按 cp_payment_order.status 映射。
     */
    formatPaymentOrderStatus(code, statusName) {
      if (statusName) {
        return statusName;
      }
      if (code === null || code === undefined || code === '') {
        return '—';
      }
      const map = CP_PAYMENT_ORDER_STATUS_TEXT;
      if (map[code] != null) {
        return map[code];
      }
      const n = Number(code);
      if (!Number.isNaN(n) && map[n] != null) {
        return map[n];
      }
      return String(code);
    },
    /**
     * 详情操作日志：每页条数变更后回到第一页并重新请求。
     * @param val 每页条数
     */
    onDetailOperateLogSizeChange(val) {
      this.detailOperateLogPageSize = val;
      this.detailOperateLogPageNo = 1;
      this.loadDetailOperateLogs(this.detailOperateLogBizNo);
    },
    /**
     * 详情操作日志：页码变更后重新请求。
     * @param val 当前页码
     */
    onDetailOperateLogPageChange(val) {
      this.detailOperateLogPageNo = val;
      this.loadDetailOperateLogs(this.detailOperateLogBizNo);
    },
    /**
     * 操作类型展示：优先取后端 operateDesc 中文描述；缺失时按 OperateLogType 数字回退兜底。
     * @param row OperateLog 单行
     */
    operateLogTypeText(row) {
      if (!row) return '—';
      if (row.operateDesc) return row.operateDesc;
      const map = {
        40: '集采订单创建',
        41: '集采采购单SAP同步',
        44: '客户回款',
        45: '上传合同',
        46: '确认签收',
        47: '登记发票',
        48: '审核通过',
        49: '驳回',
        50: '生成凭证回调成功',
        51: '冲销凭证成功',
        52: '发票抵扣',
        53: '预付核销',
        55: '销售合同上传',
        56: '客户签收单上传'
      };
      return map[row.operateType] || (row.operateType == null ? '—' : String(row.operateType));
    },
    /**
     * 详情弹窗关闭：重置 Tab，避免下次打开停留在其它页签。
     */
    onDetailDialogClose() {
      this.detailActiveTab = 'basic';
      this.detailOperateLogs = [];
      this.detailOperateLogBizNo = '';
      this.detailOperateLogPageNo = 1;
      this.detailOperateLogTotal = 0;
      this.detailPaymentPurchaseNo = '';
      this.detailPaymentRecords = createEmptyDetailPaymentRecords();
    },
    /**
     * 详情「上一条」：在当前列表中加载前一条订单详情。
     */
    detailPrev() {
      if (this.detailRowIndex <= 0) return;
      const prev = this.tableData[this.detailRowIndex - 1];
      if (prev) this.openDetail(prev);
    },
    /**
     * 详情「下一条」：在当前列表中加载后一条订单详情。
     */
    detailNext() {
      if (this.detailRowIndex < 0 || this.detailRowIndex >= this.tableData.length - 1) return;
      const next = this.tableData[this.detailRowIndex + 1];
      if (next) this.openDetail(next);
    },
    /**
     * 详情字段展示：空值统一为「—」。
     * @param v 原始值
     */
    formatDetailDisplay(v) {
      if (v === null || v === undefined || v === '') return '—';
      return String(v);
    },
    /**
     * 详情日期展示：支持字符串或 Date。
     * @param v 日期值
     */
    formatDetailDate(v) {
      if (!v) return '—';
      if (typeof v === 'string') {
        return v.length >= 10 ? v.substring(0, 10) : v;
      }
      const d = new Date(v);
      if (Number.isNaN(d.getTime())) return '—';
      const y = d.getFullYear();
      const mo = d.getMonth() + 1;
      const day = d.getDate();
      const pad = (n) => (n < 10 ? `0${n}` : String(n));
      return `${y}-${pad(mo)}-${pad(day)}`;
    },
    /**
     * 详情金额区数字展示：后缀「元」。
     * @param v 金额
     */
    formatDetailMoneyNum(v) {
      if (v === null || v === undefined || v === '') return '—';
      return `${v}元`;
    },
    /**
     * 详情付款状态文案（与筛选项、扩展表 payment_status 一致）。
     * @param v 扩展表 payment_status
     */
    paymentStatusDetailText(v) {
      const opt = PAYMENT_STATUS_OPTIONS.find((o) => o.value === Number(v));
      return opt ? opt.label : '—';
    },
    /**
     * 列表筛选：付款状态多选写入查询体 paymentStatuses。
     * 调用处：buildPagePayload 供应商/结算分支。
     * @param payload 查询参数
     */
    appendPaymentStatusesToPayload(payload) {
      const list = Array.isArray(this.queryForm.paymentStatuses)
        ? this.queryForm.paymentStatuses.filter((v) => v !== null && v !== undefined && v !== '')
        : [];
      if (list.length > 0) {
        payload.paymentStatuses = [...list];
      }
    },
    /**
     * 将业务模式多选写入 payload（businessModes IN，对应主表 business_mode）。
     * 调用方：buildPagePayload 结算端分支
     * @param payload 请求体
     */
    appendBusinessModesToPayload(payload) {
      const list = Array.isArray(this.queryForm.businessModes)
        ? this.queryForm.businessModes.filter((v) => v != null && String(v).trim() !== '')
        : [];
      if (list.length > 0) {
        payload.businessModes = [...list];
      }
    },
    /**
     * 列表「业务模式」列展示：仅主表 business_mode（J001/J002/J003），空值展示占位符。
     * 调用方：结算端列表表格业务模式列
     * @param row 列表行
     */
    displayBusinessMode(row) {
      const mode = row && row.businessMode != null ? String(row.businessMode).trim() : '';
      if (!mode) return '—';
      const opt = BUSINESS_MODE_OPTIONS.find((o) => o.value === mode);
      return opt ? opt.label : mode;
    },
    /**
     * 详情客户回款状态文案。
     * @param v 扩展表 return_money_status
     */
    returnMoneyStatusDetailText(v) {
      if (v === 0 || v === '0') return '未回款';
      if (v === 1 || v === '1') return '部分回款';
      if (v === 2 || v === '2') return '已回款';
      return v == null || v === '' ? '—' : String(v);
    },
    /**
     * 打开订单台账导出弹窗：勾选行校验业务单号；默认选项为「主表+物料」与线上一致。
     */
    handleExport() {
      if (this.selectedRows && this.selectedRows.length > 0) {
        const nos = this.selectedRows.map((r) => r.bmsBizOrderNo).filter(Boolean);
        if (!nos.length) {
          this.$message.warning('勾选行缺少业务单号，无法导出');
          return;
        }
      }
      this.exportLedgerScope = 'mainAndItems';
      this.exportDialogVisible = true;
    },
    /**
     * 打开导入弹窗：清空已选文件态，展示两步式导入界面。
     * 调用方：顶部「导入」按钮
     */
    openImportDialog() {
      this.importFile = null;
      this.importDragOver = false;
      this.importDialogVisible = true;
    },
    /**
     * 关闭导入弹窗：复位文件态，避免下次打开还残留旧文件。
     * 调用方：弹窗 close 事件 / 取消按钮
     */
    closeImportDialog() {
      this.importDialogVisible = false;
      this.importFile = null;
      this.importDragOver = false;
      if (this.$refs.cpImportInput) {
        this.$refs.cpImportInput.value = '';
      }
    },
    /**
     * 拖放区点击：触发隐藏 input 文件选择。
     * 调用方：拖放区点击 / 回车
     */
    onImportDropClick() {
      if (this.$refs.cpImportInput) {
        this.$refs.cpImportInput.click();
      }
    },
    /**
     * 拖放区悬浮态切换：drag enter/over 设为 true，离开/放下设为 false。
     */
    onImportDragOver() {
      this.importDragOver = true;
    },
    onImportDragLeave() {
      this.importDragOver = false;
    },
    /**
     * 拖放释放：取首个文件做扩展名/大小校验后赋值给 importFile。
     */
    onImportDrop(event) {
      this.importDragOver = false;
      const files = event && event.dataTransfer && event.dataTransfer.files;
      if (!files || files.length === 0) return;
      this.applyImportFile(files[0]);
    },
    /**
     * input 选择文件回调：取首个文件做扩展名/大小校验后赋值给 importFile。
     */
    onImportFileSelect(event) {
      const files = event && event.target && event.target.files;
      if (!files || files.length === 0) return;
      this.applyImportFile(files[0]);
      event.target.value = '';
    },
    /**
     * 文件校验 + 赋值：扩展名 .xlsx/.xls；大小 <= 10MB。
     * 调用方：onImportDrop / onImportFileSelect
     */
    applyImportFile(file) {
      if (!file) return;
      const name = String(file.name || '').toLowerCase();
      if (!name.endsWith('.xlsx') && !name.endsWith('.xls')) {
        this.$message.error('仅支持 .xlsx / .xls 格式文件');
        return;
      }
      if (file.size > this.importMaxSize) {
        this.$message.error('文件大小超过 10MB，请压缩后再上传');
        return;
      }
      this.importFile = file;
    },
    /**
     * 移除已选文件：恢复拖放区。
     */
    removeImportFile() {
      this.importFile = null;
      if (this.$refs.cpImportInput) {
        this.$refs.cpImportInput.value = '';
      }
    },
    /**
     * 文件大小展示（KB / MB），不带小数位过多噪声。
     * @param size 字节
     */
    formatImportFileSize(size) {
      if (!size && size !== 0) return '';
      if (size < 1024) return `${size} B`;
      if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
      return `${(size / 1024 / 1024).toFixed(2)} MB`;
    },
    /**
     * 弹窗内「开始导入」：调用集采订单导入接口。
     * 后端 @ExcelImport 切面会异步执行控制器并立即返回（result 常为空）；异步处理结果需在任务管理-导入记录查看。
     * 若接口同步返回 submitted=false 且含 errorList，则弹明细；否则一律成功提示并关窗刷新。
     * 调用方：弹窗底部「开始导入」按钮
     */
    async confirmImport() {
      if (!this.importFile) {
        this.$message.warning('请先选择导入文件');
        return;
      }
      const formData = new FormData();
      formData.append('file', this.importFile);
      this.cpImportLoading = true;
      const res = await this.$api.cpSettlementSalePurchaseOrderImport(formData).catch(() => null);
      this.cpImportLoading = false;
      if (!res) {
        return;
      }
      const ok = res.code === 200 || res.success === true;
      const data = res.result || {};
      const errors = (data && data.errorList) || [];
      // 仅在后端同步返回校验失败明细时弹出错误明细；切面立即返回或无明细时走成功引导
      if (ok && data.submitted === false && errors.length > 0) {
        this.showCpImportErrors(data, res.message);
        return;
      }
      if (ok) {
        const importEmbedTip = sessionStorage.getItem('EMBED_MODE') === 'true'
          ? '导入任务已提交，请点击页面上方「任务管理」的「导入」查看处理结果'
          : '导入任务已提交，请稍后在右上角「任务管理」的「导入记录」中查看处理结果';
        this.$message.success(importEmbedTip);
        this.closeImportDialog();
        this.loadPage();
        return;
      }
      // 调用方：HTTP 非 200 或业务失败时沿用校验失败弹窗或兜底文案
      this.showCpImportErrors(data, res.message);
    },
    /**
     * 渲染校验失败行弹窗：使用 message-box 文本汇总，便于用户复制定位。
     */
    showCpImportErrors(data, fallbackMsg) {
      const list = (data && data.errorList) || [];
      const lines = list.slice(0, 50).map((e) => {
        const idx = e.serialNo != null ? `序号 ${e.serialNo}` : `第 ${e.rowNo} 行`;
        return `${idx}：${e.errorMsg}`;
      });
      const more = list.length > 50 ? `\n...还有 ${list.length - 50} 条未展示` : '';
      const content = lines.length > 0 ? lines.join('\n') + more : (fallbackMsg || '导入失败');
      this.$alert(content, '导入校验未通过', { type: 'error', customClass: 'cp-import-error-box' });
    },
    /**
     * 下载导入模板：使用 blob 流触发浏览器下载，按钮 loading 提示。
     * 调用方：弹窗第一步「下载模板」按钮
     */
    async downloadCpImportTemplate() {
      this.cpImportTemplateLoading = true;
      const res = await this.$api.cpSettlementSalePurchaseOrderImportTemplate().catch(() => null);
      this.cpImportTemplateLoading = false;
      if (!res) {
        return;
      }
      const blob = res instanceof Blob ? res : new Blob([res]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = '集采订单导入模板.xlsx';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    },
    /**
     * 弹窗「确认导出」：写入 includeOrderItemSheet 并调用集采订单异步导出接口。
     */
    async confirmOrderLedgerExport() {
      this.exportLoading = true;
      const payload = this.buildPagePayload();
      payload.includeOrderItemSheet = this.exportLedgerScope === 'mainAndItems';
      // 全局全选：不传 exportBmsBizOrderNos，由后端按当前筛选导出全部
      if (this.selectedRows && this.selectedRows.length > 0) {
        const nos = this.selectedRows.map((r) => r.bmsBizOrderNo).filter(Boolean);
        if (!nos.length) {
          this.exportLoading = false;
          this.$message.warning('勾选行缺少业务单号，无法导出');
          return;
        }
        payload.exportBmsBizOrderNos = nos;
      }
      const apiFn = this.supplierMode ? this.$api.cpSupplierSalePurchaseOrderExport : this.$api.cpSettlementSalePurchaseOrderExport;
      const res = await apiFn(payload).catch(() => null);
      this.exportLoading = false;
      this.exportDialogVisible = false;
      this.showCpExportResult(res);
    },
    /** 供应商物料明细导出（异步）：支持勾选多行合并导出 */
    async handleItemExport() {
      if (!this.supplierMode) return;

      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning('请勾选至少一行订单');
        return;
      }
      const nos = this.selectedRows.map((r) => r.bmsBizOrderNo).filter(Boolean);
      if (!nos.length) {
        this.$message.warning('勾选行缺少业务单号，无法导出');
        return;
      }
      this.itemExportLoading = true;
      const body = { exportBmsBizOrderNos: nos };
      const res = await this.$api.cpSupplierSalePurchaseOrderItemsExport(body).catch(() => null);
      this.itemExportLoading = false;
      this.showCpExportResult(res);
    },
    /**
     * 展示集采异步导出结果：接口为任务中心异步模式，仅提示不触发浏览器下载。
     */
    showCpExportResult(res) {
      if (res && res.code === 200) {
        const embedTip = sessionStorage.getItem('EMBED_MODE') === 'true'
          ? '导出任务已提交，请点击页面上方「任务管理」下载'
          : '导出任务已提交,请在任务管理中下载导出文件';
        this.$message.success(embedTip);
        return;
      }
      if (typeof res === 'string') {
        const embedTip = sessionStorage.getItem('EMBED_MODE') === 'true'
          ? '导出任务已提交，请点击页面上方「任务管理」下载'
          : '导出任务已提交,请在任务管理中下载导出文件';
        this.$message.success(embedTip);
      }
    },
    /**
     * 列表日期展示：统一格式化为 yyyy-MM-dd HH:mm:ss。
     * @param v 日期值
     */
    formatDateTimeDisplay(v) {
      if (!v) return '—';
      if (typeof v === 'string') {
        const raw = v.replace('T', ' ');
        if (raw.length >= 19) return raw.substring(0, 19);
        if (raw.length === 10) return `${raw} 00:00:00`;
        return raw;
      }
      const d = new Date(v);
      if (Number.isNaN(d.getTime())) return '—';
      const y = d.getFullYear();
      const mo = d.getMonth() + 1;
      const day = d.getDate();
      const h = d.getHours();
      const mi = d.getMinutes();
      const s = d.getSeconds();
      const pad = (n) => (n < 10 ? `0${n}` : String(n));
      return `${y}-${pad(mo)}-${pad(day)} ${pad(h)}:${pad(mi)}:${pad(s)}`;
    },
    /** 列表金额列展示 */
    fmtAmount(row, column, cellValue) {
      if (cellValue === null || cellValue === undefined || cellValue === '') return '—';
      return cellValue;
    },
    /** 进项状态中文（与 invoice_status 枚举对齐后可改为字典接口） */
    invoiceStatusText(v) {
      if (v === 0 || v === '0') return '未开票';
      if (v === 1 || v === '1') return '部分开票';
      if (v === 2 || v === '2') return '完全开票';
      return v == null || v === '' ? '—' : String(v);
    },
    /** 合同状态中文 */
    contractStatusText(v) {
      if (v === 0 || v === '0') return '待发起';
      if (v === 1 || v === '1') return '签署中';
      if (v === 2 || v === '2') return '已签署';
      return v == null || v === '' ? '—' : String(v);
    },
    /**
     * 发票弹窗购销抬头展示（code-name），与列表 formatCodeName 同源。
     * 调用方：发票登记弹窗模板
     */
    formatPartyHead(code, name) {
      return formatCodeName(code, name);
    },
    /**
     * 发票登记前置校验：采购方（付款主体 code+name）唯一键，与列表「采购方」列口径一致。
     * 调用方：openInvoiceDialog
     */
    getInvoiceRegisterBuyerPartyKey(row) {
      if (!row) return '';
      const c = row.paymentPayerCode == null ? '' : String(row.paymentPayerCode).trim();
      const n = row.paymentPayerName == null ? '' : String(row.paymentPayerName).trim();
      return `${c}\u0001${n}`;
    },
    /**
     * 发票登记前置校验：销售方（供应商 code+name）唯一键。
     * 调用方：openInvoiceDialog
     */
    getInvoiceRegisterSellerPartyKey(row) {
      if (!row) return '';
      const c = row.supplierCode == null ? '' : String(row.supplierCode).trim();
      const n = row.supplierName == null ? '' : String(row.supplierName).trim();
      return `${c}\u0001${n}`;
    },
    /** 付款主体展示：code-name（仅一项有值时退化为单值）。调用方：列表「付款主体」列 */
    displaySettleCompany(row) {
      const c = row && row.paymentPayerCode;
      const n = row && row.paymentPayerName;
      return formatCodeName(c, n);
    },
    /** 供应商展示：code-name。调用方：列表「供应商」列 */
    displaySupplier(row) {
      const c = row && row.supplierCode;
      const n = row && row.supplierName;
      return formatCodeName(c, n);
    },
    /** 客户名称展示：code-name。调用方：列表「客户名称」列 */
    displayCustomer(row) {
      const c = row && row.customerCode;
      const n = row && row.customerName;
      return formatCodeName(c, n);
    },
    /**
     * 一级销售组织：取主表 `sales_org_code/name`（即客户销售组织，模型层即为一级），列表「一级销售组织」列调用。
     * @param row 列表行
     */
    displaySalesOrgPrimary(row) {
      return formatCodeName(row && row.salesOrgCode, row && row.salesOrgName);
    },
    /**
     * 二级销售组织：取主表 `second_sales_org_code/name`（业务模式派生：J001 空 / J002 3600 / J003 1100），列表「二级销售组织」列调用。
     * @param row 列表行
     */
    displaySalesOrgSecondary(row) {
      return formatCodeName(row && row.secondSalesOrgCode, row && row.secondSalesOrgName);
    },
    /**
     * 展示采购合同编号：优先合同表，其次扩展表 contract_no。
     * 调用方：列表/详情「合同编号」列。
     */
    displayPurchaseContractNo(contractOrRow, extFallback) {
      const primary = contractOrRow && (contractOrRow.contractNo || contractOrRow.contract_no);
      if (primary) {
        return String(primary).trim();
      }
      const ext = extFallback || contractOrRow;
      const extNo = ext && (ext.contractNo || ext.contract_no);
      return extNo ? String(extNo).trim() : '';
    },
    /**
     * 列表点击采购合同编号：弹窗轮播预览合同附件。
     * 调用方：供应商门户列表「合同编号」列。
     */
    openPurchaseContractFile(row) {
      if (!row || !row.contractFileUrl) {
        return;
      }
      // 调用 openFilePreview：支持逗号分隔多附件轮播切换。
      this.openFilePreview(row.contractFileUrl);
    },
    /**
     * 将逗号分隔的附件 URL 拆成数组（过滤空项）。
     * 调用方：openFilePreview。
     */
    parseFileUrlList(url) {
      if (!url) {
        return [];
      }
      return String(url).split(',').map((item) => item.trim()).filter(Boolean);
    },
    /**
     * 弹窗轮播预览附件（支持逗号分隔多文件，仅展示文件内容）。
     * 调用方：列表/详情「采购合同」「签收单」「合同编号」等查看按钮。
     */
    openFilePreview(url) {
      const list = this.parseFileUrlList(url);
      if (!list.length) {
        return;
      }
      this.filePreviewList = [];
      // 调用 previewImage：先清空再异步赋值以触发 watch 打开弹窗。
      setTimeout(() => {
        this.filePreviewList = list;
      }, 1);
    },
    /**
     * 采购单列小状态条样式（按扩展字段粗粒度高亮，后续可对齐主数据字典）
     * @param row 列表行
     * @param key 销项/回款/进项/付款/签
     */
    pillClass(row, key) {
      const on = (() => {
        if (key === 'salesOut') return row.salesInvoiceStatus != null && Number(row.salesInvoiceStatus) !== 0;
        if (key === 'return') return row.returnMoneyStatus != null && Number(row.returnMoneyStatus) !== 0;
        if (key === 'input') return row.invoiceStatus != null && Number(row.invoiceStatus) !== 0;
        if (key === 'payReq') return row.paymentStatus != null && Number(row.paymentStatus) !== 0;
        if (key === 'sign') return row.contractStatus != null && Number(row.contractStatus) !== 0;
        return false;
      })();
      return on ? 'cp-pill cp-pill--on' : 'cp-pill cp-pill--off';
    },
    /**
     * 提交回款维护 cpSettlementSalePurchaseOrder：回款状态由 inferReturnMoneyStatusFromPaymentAmount 推导，再调用结算接口。
     */
    async submitCustomerPayment() {
      const parsed = this.getCustomerPaymentParsedAmount();
      const rawTrim = (this.customerPaymentAmountInput || '').trim();
      const salesTotal = Number(this.customerPaymentForm.salesAmountWithTax || 0);
      if (rawTrim === '') {
        this.$message.warning('请输入回款金额');
        return;
      }
      if (Number.isNaN(parsed)) {
        this.$message.warning('请输入回款金额');
        return;
      }
      if (parsed < 0) {
        this.$message.warning('回款金额不能为负数');
        return;
      }
      if (parsed > salesTotal + 1e-6) {
        this.$message.warning('回款金额不能超过销售金额');
        return;
      }
      const status = this.inferReturnMoneyStatusFromPaymentAmount(parsed, salesTotal);
      if (status === null) {
        this.$message.warning('回款金额不能超过销售金额');
        return;
      }
      this.customerPaymentForm.returnMoneyStatus = status;
      const amount = status === 0 ? 0 : parsed;
      if (status === 1) {
        if (amount <= 0) {
          this.$message.warning('部分回款金额需大于0');
          return;
        }
        if (amount > salesTotal + 1e-6) {
          this.$message.warning('部分回款金额不能大于销售金额');
          return;
        }
      }
      if (status === 2) {
        // 已回款：允许与销售金额相差不超过 1 元（略小于销售金额也可视为全额到账）
        if (amount > salesTotal + 1e-6) {
          this.$message.warning('已回款时回款金额不能大于销售金额');
          return;
        }
        if (amount < salesTotal - 1 - 1e-6) {
          this.$message.warning('已回款时回款金额不得低于「销售金额 − 1 元」');
          return;
        }
      }
      this.customerPaymentLoading = true;
      // 调用新回款维护接口，按销售订单号回写关联采购单扩展字段。
      const res = await this.$api.cpSettlementSalePurchaseOrderCustomerPayment({
        ...this.customerPaymentForm,
        customerPaymentAmount: amount
      }).catch(() => null);
      this.customerPaymentLoading = false;
      if (res && res.code === 200) {
        this.$message.success('保存成功');
        this.customerPaymentVisible = false;
        this.loadPage();
      }
    },
    /** 客户回款弹框金额格式化 */
    formatPaymentMoney(amount) {
      // 调用 formatCpAmount：客户回款弹框金额展示
      return `¥${formatCpAmount(amount)}`;
    },
    /**
     * 提交登记合同：调用供应商门户登记合同接口并刷新列表。
     */
    async submitContract() {
      this.contractLoading = true;
      // 调用供应商登记合同接口回写合同状态。
      const res = await this.$api.cpSupplierSalePurchaseOrderRegisterContract(this.contractForm).catch(() => null);
      this.contractLoading = false;
      if (res && res.code === 200) {
        this.$message.success('保存成功');
        this.contractVisible = false;
        this.loadPage();
      }
    },
    /**
     * 提交登记签收：调用供应商门户登记签收接口并刷新列表。
     */
    async submitSign() {
      const validRows = this.signForm.signFileList.filter((item) => item.valid);
      if (validRows.length < 1) {
        this.$message.warning('请先上传签收单');
        return;
      }
      const missing = this.signForm.purchaseNoList.filter((purchaseNo) => !validRows.some((row) => row.purchaseNo === purchaseNo));
      if (missing.length > 0) {
        this.$message.warning(`还有采购单未上传签收单：${missing.join(',')}`);
        return;
      }
      this.signLoading = true;
      const payload = {
        qxSignStatus: this.signForm.qxSignStatus,
        signFileList: validRows.map((row) => ({
          purchaseNo: row.purchaseNo,
          signFileUrl: row.signFileUrl,
          signFileName: row.signFileName
        }))
      };
      // 调用供应商确认签收接口回写齐心签收状态并写入签收表。
      const res = await this.$api.cpSupplierSalePurchaseOrderRegisterSign(payload).catch(() => null);
      this.signLoading = false;
      if (res && res.code === 200) {
        this.$message.success('保存成功');
        this.signVisible = false;
        this.loadPage();
      }
    },
    /**
     * 提交登记发票：按组提交多单多票数据，后端完成校验与状态回写。
     */
    async submitInvoice() {
      const submitItems = (this.invoiceForm.itemList || []).filter(
        // 调用 cpQuantityPositive：过滤有效开票明细
        (item) => cpQuantityPositive(item.registerQuantity)
      );
      if (submitItems.length < 1) {
        this.$message.warning('请至少录入一条开票明细');
        return;
      }
      const invalidQtyItem = submitItems.find(
        // 调用 cpQuantityGt：校验开票数量不超过待开数量
        (item) => cpQuantityGt(item.registerQuantity, item.pendingQuantity)
      );
      if (invalidQtyItem) {
        this.$message.warning(`开票数量不能大于待开数量：${invalidQtyItem.purchaseNo}-${invalidQtyItem.itemNo}`);
        return;
      }
      const invoiceList = (this.invoiceForm.invoiceList || []).filter((item) => item && item.valid !== false);
      if (invoiceList.length < 1) {
        this.$message.warning('请先上传发票文件或点击「手动添加」录入票面');
        return;
      }
      const missingInvoice = invoiceList.find((item) => !item.invoiceNo || !item.invoiceCode);
      if (missingInvoice) {
        this.$message.warning('请完整填写发票号码和发票代码');
        return;
      }
      this.invoiceLoading = true;
      const payload = {
        deductAmount: 0,
        itemList: submitItems.map((item) => ({
          bmsBizOrderNo: item.bmsBizOrderNo,
          purchaseNo: item.purchaseNo,
          itemNo: item.itemNo,
          // 调用 truncateCpQuantity：提交前数量截断
          registerQuantity: truncateCpQuantity(item.registerQuantity)
        })),
        invoiceList: invoiceList.map((item) => ({
          invoiceType: item.invoiceType || 2,
          invoiceNo: item.invoiceNo,
          invoiceCode: item.invoiceCode,
          invoiceDate: item.invoiceDate,
          buyerName: item.buyerName,
          buyerTaxNo: item.buyerTaxNo,
          sellerName: item.sellerName,
          sellerTaxNo: item.sellerTaxNo,
          // 调用 toCpAmountNumber / subtractCpAmount：提交票面金额
          amountWithoutTax: toCpAmountNumber(item.amountWithoutTax),
          taxAmount: subtractCpAmount(item.amountWithTax, item.amountWithoutTax),
          amountWithTax: toCpAmountNumber(item.amountWithTax),
          imageUrl: item.imageUrl,
          ocrChangedFlag: Number(item.ocrChangedFlag || 0)
        }))
      };
      // 调用批量登记发票接口执行主链路（明细登记、票面校验、状态回写）。
      const res = await this.$api.cpSupplierSalePurchaseOrderRegisterInvoiceBatch(payload).catch(() => null);
      this.invoiceLoading = false;
      if (res && res.code === 200) {
        this.$message.success('登记成功');
        this.invoiceVisible = false;
        this.loadPage();
      }
    },
    /**
     * 将 pur_tax_rate 统一为小数（0.13）；大于 1 时按百分数（13）处理。
     * 调用方：computeInvoiceLineAmountParts、formatTaxRateDisplay
     * @param taxRate 税率
     */
    normalizeCpTaxRateDecimal(taxRate) {
      // 调用 cpDecimal.normalizeCpTaxRateDecimal：税率归一
      return normalizeCpTaxRateDecimal(taxRate);
    },
    /**
     * 预览行映射：默认待开数量全开，保留后端倒挤三金额供全开时使用。
     * 调用方：openInvoiceRegisterDialog
     * @param item 预览接口 itemList 元素
     */
    mapRegisterInvoicePreviewItem(item) {
      // 调用 truncateCpQuantity：预览行数量截断，避免浮点误差
      const pending = truncateCpQuantity((item && item.pendingQuantity) || 0);
      return {
        ...item,
        totalQuantity: truncateCpQuantity(item && item.totalQuantity),
        openedQuantity: truncateCpQuantity(item && item.openedQuantity),
        pendingQuantity: pending,
        registerQuantity: pending,
        lastSliceAmountWithoutTax: item.lastSliceAmountWithoutTax,
        lastSliceAmountWithTax: item.lastSliceAmountWithTax,
        lastSliceTaxAmount: item.lastSliceTaxAmount
      };
    },
    /**
     * 是否使用后端最后一笔倒挤金额（本次数量=待开数量且后端已返回倒挤字段）。
     * 调用方：computeInvoiceLineAmountParts
     * @param row 预览行
     */
    shouldUseLastSliceAmounts(row) {
      if (!row) return false;
      const qty = truncateCpQuantity(row.registerQuantity);
      const pending = truncateCpQuantity(row.pendingQuantity);
      // 调用 cpQuantityEquals：判断本次是否全开待开数量
      if (qty <= 0 || pending <= 0 || !cpQuantityEquals(qty, pending)) {
        return false;
      }
      return row.lastSliceAmountWithoutTax != null
        && row.lastSliceAmountWithTax != null
        && row.lastSliceTaxAmount != null;
    },
    /**
     * 单行本次开票价税拆分：全开待开用后端倒挤，否则含税单价×数量（与 CpInvoiceRegisterTaxHelper 一致）。
     * 调用方：采购明细表列、invoiceSummary 计算属性。
     * @param row 预览行
     */
    computeInvoiceLineAmountParts(row) {
      if (this.shouldUseLastSliceAmounts(row)) {
        return {
          // 调用 toCpAmountNumber：后端倒挤金额归一
          amountWithoutTax: toCpAmountNumber(row.lastSliceAmountWithoutTax),
          taxAmount: toCpAmountNumber(row.lastSliceTaxAmount),
          amountWithTax: toCpAmountNumber(row.lastSliceAmountWithTax)
        };
      }
      // 调用 calcInvoiceLineAmountPartsFromTaxUnit：部分开票按含税单价×数量拆分
      return this.calcInvoiceLineAmountPartsFromTaxUnit(row);
    },
    /**
     * 部分开票价税拆分：含税=数量×含税单价；未税=含税/(1+r)；税额=含税−未税。
     * 调用方：computeInvoiceLineAmountParts
     * @param row 预览行
     */
    calcInvoiceLineAmountPartsFromTaxUnit(row) {
      // 调用 calcCpInvoiceLineAmountPartsFromTaxUnit：Decimal 价税拆分
      return calcCpInvoiceLineAmountPartsFromTaxUnit(
        (row && row.registerQuantity) || 0,
        (row && row.unitPriceWithTax) || 0,
        row && row.taxRate
      );
    },
    /**
     * 本次开票数量变更：全开待开时展示倒挤金额，部分开票时按单价×数量重算。
     * 调用方：模板 el-input-number @change
     * @param row 预览行
     */
    onInvoiceRegisterQuantityChange(row) {
      if (!row) return;
      // 调用 truncateCpQuantity：与后端 CpInvoiceRegisterQuantityHelper 一致，截断不四舍五入
      row.registerQuantity = truncateCpQuantity(row.registerQuantity);
      this.invoiceForm = { ...this.invoiceForm };
    },
    /**
     * 模板别名：表格列展示用。
     * @param row 预览行
     */
    invoiceLineAmountParts(row) {
      return this.computeInvoiceLineAmountParts(row);
    },
    /**
     * 税率列展示为百分数（库表小数 0.13 → 展示 13）。
     * 调用方：采购明细表「税率(%)」列。
     * @param taxRate 税率
     */
    formatTaxRateDisplay(taxRate) {
      if (taxRate === null || taxRate === undefined || taxRate === '') return '—';
      const rateDecimal = normalizeCpTaxRateDecimal(taxRate);
      if (rateDecimal <= 0) return '0';
      // 调用 toCpAmountNumber：税率百分数展示
      return String(toCpAmountNumber(rateDecimal * 100));
    },
    /**
     * 右侧发票表：新增一行空白票面，便于不上传文件时手工录入。
     * 调用方：模板「+ 手动添加」按钮。
     */
    addManualInvoiceRow() {
      this.invoiceForm.invoiceList.push({
        invoiceType: 2,
        invoiceNo: '',
        invoiceCode: '',
        invoiceDate: '',
        buyerName: this.invoiceForm.buyerName,
        buyerTaxNo: '',
        sellerName: this.invoiceForm.sellerName,
        sellerTaxNo: '',
        amountWithoutTax: 0,
        taxAmount: 0,
        amountWithTax: 0,
        imageUrl: '',
        ocrChangedFlag: 1,
        valid: true,
        message: '手工录入',
        _manual: true
      });
    },
    /**
     * 删除右侧发票行。
     * 调用方：模板发票表「删」按钮。
     * @param index 行下标
     */
    removeInvoiceRow(index) {
      if (index < 0 || index >= (this.invoiceForm.invoiceList || []).length) return;
      this.invoiceForm.invoiceList.splice(index, 1);
    },
    /**
     * 数量截断至最多 3 位小数（向零截断，不四舍五入），与后端 CpInvoiceRegisterQuantityHelper 一致。
     * 调用方：登记发票预览/提交、invoice_status 相关展示与校验
     */
    truncateCpQuantity(val) {
      // 调用 cpDecimal.truncateCpQuantity：模板 :max 绑定等
      return truncateCpQuantity(val);
    },
    /**
     * 数量展示：最多 3 位小数，去掉尾部无意义的 0。
     * 调用方：登记发票采购明细表数量列
     */
    formatQuantity(v) {
      // 调用 formatCpQuantity：采购明细数量列展示
      return formatCpQuantity(v);
    },
    /**
     * 金额格式化
     */
    formatAmount(v) {
      // 调用 formatCpAmount：金额列与小计展示
      return formatCpAmount(v);
    }
  }
};
</script>

<style scoped>
.section-title {
  font-weight: 600;
  margin-bottom: 8px;
}
.pagination-wrapper {
  margin-top: 12px;
}
.cp-settlement-form {
  margin-bottom: 8px;
}
/* 结算查询：与进项台账 form-inline-list 一致，每行 4 列；组合项铺满列宽，减少留白 */
.cp-settlement-filter-row {
  display: contents;
}
.cp-settlement-filter-form.form-inline-list {
  padding: 8px 12px 4px;
}
.cp-settlement-filter-form >>> .el-form-item__label {
  white-space: nowrap;
  color: #303133;
  font-size: 14px;
  font-weight: 400;
  line-height: 32px;
  padding-right: 6px;
  box-sizing: border-box;
}
.cp-settlement-filter-form.form-inline-list >>> .el-form-item {
  width: calc(25% - 6px);
  margin-right: 6px;
  margin-bottom: 4px;
}
.cp-settlement-filter-form >>> .el-form-item .el-input,
.cp-settlement-filter-form >>> .el-form-item .el-select,
.cp-settlement-filter-form >>> .el-form-item .el-date-editor {
  width: 100%;
}
/* 组合项左侧类型下拉不走 100% 全宽（Vue2.5 须用 >>>，:deep 不生效） */
.cp-settlement-filter-form >>> .cp-settlement-inline .cp-settlement-kind-select.el-select,
.cp-settlement-filter-form >>> .cp-settlement-inline .cp-settlement-date-type-select.el-select {
  width: 100px !important;
  flex: 0 0 100px !important;
  min-width: 100px !important;
  max-width: 100px !important;
}
.cp-settlement-filter-form >>> .cp-settlement-inline .cp-settlement-kind-select .el-input,
.cp-settlement-filter-form >>> .cp-settlement-inline .cp-settlement-date-type-select .el-input {
  width: 100px !important;
}
.cp-settlement-inline {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
}
/* 无标签组合项：取消左侧 20px 缩进，与同行带标签项左对齐 */
.cp-settlement-filter-form >>> .cp-settlement-item-no-label.el-form-item .el-form-item__content {
  margin-left: 0 !important;
  width: 100% !important;
  max-width: none;
}
.cp-settlement-filter-form >>> .cp-settlement-inline .cp-settlement-date-type-select .el-input__inner,
.cp-settlement-filter-form >>> .cp-settlement-inline .cp-settlement-kind-select .el-input__inner {
  color: #303133;
  font-size: 14px;
  padding-left: 4px;
  padding-right: 20px;
  text-overflow: ellipsis;
  overflow: hidden;
}
/* 组合项主输入（单号、日期范围）：占满剩余宽度 */
.cp-settlement-filter-form >>> .cp-settlement-inline > .el-input,
.cp-settlement-filter-form >>> .cp-settlement-inline > .el-date-editor,
.cp-settlement-filter-form >>> .cp-settlement-inline > .cp-settlement-keyword-input {
  flex: 1 1 auto;
  min-width: 0;
  width: auto !important;
}
.cp-settlement-filter-form >>> .cp-settlement-inline > .cp-settlement-keyword-input .el-input,
.cp-settlement-filter-form >>> .cp-settlement-inline > .el-date-editor {
  width: 100% !important;
}
.cp-settlement-filter-form .cp-settlement-inline.cp-settlement-amount-range > .el-input {
  flex: 1 1 0;
  min-width: 0;
  width: 0;
}
.cp-settlement-amount-range .el-input {
  flex: 1 1 auto;
  min-width: 0;
}
/* 供应商门户查询仍走 form-inline-list，行容器不参与布局以保持与历史一致 */
.cp-settlement-form.form-inline-list .cp-settlement-row {
  display: contents;
}
/* 日期组合项占两列，留给类型下拉 + 区间足够宽度 */
.cp-settlement-form.form-inline-list >>> .cp-form-item--date-combo {
  width: calc(50% - 10px);
}
.cp-settlement-form.form-inline-list >>> .cp-form-item--no-label .el-form-item__content {
  margin-left: 120px !important;
}
.cp-field-fill {
  width: 100%;
}
.cp-row-checkbox {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.cp-row-idx {
  font-size: 14px;
  color: #303133;
  text-align: center;
}
.cp-header-sel-only {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.cp-inline {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}
.cp-flex-1 {
  flex: 1;
}
.cp-settlement-amount-range {
  min-width: 0;
}
.cp-settlement-amount-sep {
  flex-shrink: 0;
  color: #909399;
}
.cp-settlement-actions {
  margin-bottom: 12px;
}

.cp-po-cell {
  line-height: 20px;
}
/* 上行：销、采同一行，不换行 */
.cp-po-tags-line {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  line-height: 20px;
  height: 20px;
  overflow: hidden;
}
.cp-po-id-block {
  display: inline-flex;
  align-items: center;
  flex-shrink: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* 销 / 采: 前缀：主题蓝 */
.cp-po-id-prefix {
  color: #409eff;
  font-size: 14px;
  font-weight: 700;
  margin-right: 2px;
}
/* 单号数字：加大字号、加粗突出 */
.cp-po-id-num {
  color: #303133;
  font-size: 14px;
  font-weight: 700;
}
/* 名称类列：最多两行展示，固定行高；超出省略，列上 show-overflow-tooltip 悬停看全 */
.table-list >>> .cp-col-name {
  vertical-align: top;
}
.table-list >>> .cp-col-name .cell {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  white-space: normal;
  word-break: break-word;
  line-height: 20px;
  max-height: 40px;
}
/* 供应商门户：采购方/销售方完整展示（不截断、自动换行） */
.table-list >>> .cp-col-party-full {
  vertical-align: top;
}
.table-list >>> .cp-col-party-full .cell {
  white-space: normal;
  word-break: break-word;
  line-height: 20px;
  overflow: visible;
  max-height: none;
}
/* 下行：状态标签一行，与上行合计两行高度 */
.cp-po-pills {
  margin-top: 4px;
  height: 20px;
  line-height: 20px;
  overflow: hidden;
  white-space: nowrap;
}
.cp-pill {
  display: inline-block;
  font-size: 12px;
  padding: 0 7px;
  border-radius: 3px;
  margin-right: 6px;
  line-height: 20px;
}
/* 已点亮：蓝底白字 */
.cp-pill--on {
  color: #ffffff;
  background: #409eff;
}
/* 未点亮：浅灰底、深灰字 */
.cp-pill--off {
  color: #606266;
  background: #ebeef5;
}
.cp-muted {
  color: #c0c4cc;
}
.cp-export-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.cp-export-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 16px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.cp-export-card.is-active {
  border-color: #6c5ce7;
  box-shadow: 0 0 0 1px rgba(108, 92, 231, 0.25);
}
.cp-export-radio {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  margin-top: 2px;
  border: 2px solid #c0c4cc;
  border-radius: 50%;
  box-sizing: border-box;
}
.cp-export-radio.is-checked {
  border-color: #6c5ce7;
  background: radial-gradient(circle, #6c5ce7 0%, #6c5ce7 45%, #fff 46%, #fff 100%);
}
.cp-export-title {
  font-weight: 600;
  font-size: 14px;
  color: #303133;
  margin-bottom: 4px;
}
.cp-export-desc {
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}
.cp-export-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.cp-export-confirm {
  flex: 1;
  max-width: 56%;
  margin-left: 12px;
  background: #6c5ce7;
  border-color: #6c5ce7;
}
.cp-export-confirm:hover,
.cp-export-confirm:focus {
  background: #5b4cdb;
  border-color: #5b4cdb;
}

/* 集采订单详情弹窗（结算/供应商共用，与墨刀布局对齐） */
.cp-detail-dialog-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-right: 36px;
  box-sizing: border-box;
}
.cp-detail-dialog-title-text {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
}
.cp-detail-dialog-title-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.cp-detail-body {
  margin-top: -6px;
}
.cp-detail-order-no {
  font-size: 18px;
  font-weight: 500;
  color: #333;
  line-height: 1.3;
}
.cp-detail-pills {
  margin-top: 8px;
}
.cp-detail-meta-line {
  margin-top: 10px;
  font-size: 14px;
  color: #303133;
}
.cp-detail-meta-line span {
  margin-right: 28px;
}
.cp-detail-metrics {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  margin: 16px 0 8px;
  padding: 14px 10px;
  background: #fafafa;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}
.cp-detail-metric {
  flex: 1;
  text-align: center;
  padding: 0 6px;
}
.cp-detail-metric-num {
  font-size: 18px;
  font-weight: 500;
  color: #333;
  line-height: 1.3;
}
.cp-detail-metric-label {
  margin-top: 6px;
  font-size: 12px;
  color: #303133;
  line-height: 1.4;
}
/* 详情区块标题：与集采进项台账/采购单台账 bill-table-head 一致 */
.bill-table-head {
  line-height: 30px;
  font-size: 16px;
  font-weight: 400;
  color: #333;
  padding-left: 10px;
  position: relative;
  margin: 4px 0 10px;
}
.bill-table-head::before {
  content: '';
  display: block;
  width: 4px;
  height: 16px;
  background: #005bf5;
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -8px;
}
.cp-ledger-bill-head-spaced {
  margin-top: 20px;
}
.cp-detail-payment-panel {
  min-height: 120px;
}
.cp-detail-payment-summary-line {
  margin: 8px 0 0;
  font-size: 14px;
  color: #303133;
}
.cp-detail-payment-table >>> .el-table__header th,
.cp-detail-list-table >>> .el-table__header th,
.cp-detail-tabs >>> .el-table thead th.el-table__cell {
  background-color: #c8daf7 !important;
  color: #333 !important;
  border-color: #d9e3f2 !important;
  font-weight: 500;
}
.cp-detail-payment-table >>> .el-table__header th .cell,
.cp-detail-list-table >>> .el-table__header th .cell,
.cp-detail-tabs >>> .el-table thead th.el-table__cell .cell {
  color: #333;
  font-weight: 500;
}
.cp-detail-payment-table >>> .el-table__body td,
.cp-detail-list-table >>> .el-table__body td,
.cp-detail-tabs >>> .el-table__body td.el-table__cell {
  color: #333;
  border-color: #eee;
}
.cp-detail-payment-table >>> .el-table--striped .el-table__body tr.el-table__row--striped td,
.cp-detail-list-table >>> .el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #fafafa;
}
.bill-table-head + .cp-detail-grid,
.bill-table-head + .cp-detail-payment-summary-line + .el-table,
.bill-table-head + .el-table {
  margin-top: 15px;
}
.cp-detail-grid {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 12px;
}
.cp-dg-label {
  width: 12.5%;
  background: #c8daf7;
  border: 1px solid #d9e3f2;
  padding: 8px 10px;
  color: #333;
  vertical-align: middle;
  word-break: break-all;
  font-weight: 500;
}
.cp-dg-val {
  width: 12.5%;
  border: 1px solid #d9e3f2;
  padding: 8px 10px;
  color: #333;
  vertical-align: middle;
  word-break: break-all;
  background: #fff;
}
.cp-detail-empty {
  padding: 48px 16px;
  text-align: center;
  color: #909399;
  font-size: 13px;
}
.cp-detail-tabs {
  margin-top: 4px;
}
.cp-detail-tabs >>> .el-tabs__item {
  color: #606266;
}
.cp-detail-tabs >>> .el-tabs__item.is-active {
  color: #fff;
}

.cp-customer-payment-dialog >>> .el-dialog__header {
  padding: 14px 20px 12px;
  border-bottom: 1px solid #ebeef5;
}
.cp-customer-payment-dialog >>> .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}
.cp-customer-payment-dialog >>> .el-dialog__body {
  padding: 16px 20px 8px;
}
.cp-customer-payment-dialog >>> .el-dialog__footer {
  padding: 12px 20px 16px;
}

.cp-customer-payment-head {
  display: flex;
  gap: 16px;
  padding-bottom: 16px;
  margin-bottom: 4px;
  border-bottom: 1px solid #ebeef5;
}
.cp-customer-payment-field {
  flex: 1;
  min-width: 0;
}
.cp-customer-payment-label {
  display: block;
  margin-bottom: 6px;
  font-size: 12px;
  color: #909399;
}
.cp-customer-payment-value {
  display: block;
  font-size: 16px;
  line-height: 1.4;
  color: #303133;
  font-weight: 600;
  word-break: break-all;
}
.cp-customer-payment-money {
  color: #409eff;
  font-weight: 600;
}
.cp-customer-payment-amount-wrap {
  margin-top: 18px;
  padding-bottom: 4px;
}
.cp-customer-payment-required-star {
  margin-left: 2px;
  color: #f56c6c;
  font-weight: 600;
}
.cp-customer-payment-amount-title {
  margin-bottom: 10px;
  color: #303133;
  font-size: 14px;
  font-weight: 600;
}
.cp-customer-payment-currency {
  display: inline-block;
  min-width: 14px;
  text-align: center;
  font-weight: 600;
  color: #606266;
}
.cp-customer-payment-amount-input {
  width: 100%;
}
.cp-customer-payment-amount-input >>> .el-input__inner:focus {
  border-color: #409eff;
}
.cp-customer-payment-amount-input >>> .el-input-group__prepend {
  padding: 0 12px;
  background-color: #f5f7fa;
  color: #606266;
  border-color: #dcdfe6;
  font-weight: 600;
}
.cp-customer-payment-amount-hint {
  margin-top: 10px;
  font-size: 12px;
  line-height: 1.5;
  color: #909399;
}
.cp-upload-ok {
  color: #67c23a;
}
.cp-upload-error {
  color: #f56c6c;
}
.cp-sign-summary {
  padding: 12px;
  border: 1px solid #c2e7b0;
  background: #f0f9eb;
  border-radius: 6px;
}
.cp-sign-summary-main {
  font-size: 18px;
  font-weight: 600;
  color: #2b8150;
}
.cp-sign-summary-sub {
  margin-top: 4px;
  font-size: 13px;
  color: #5e6d82;
}
.cp-register-invoice-stack {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}
.cp-register-invoice-section {
  width: 100%;
  min-width: 0;
}
.cp-register-invoice-section--bill {
  margin-top: 4px;
}
.cp-register-invoice-dialog-title-wrap {
  padding-right: 36px;
}
.cp-register-invoice-dialog-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  line-height: 1.3;
}
.cp-register-invoice-dialog-sub {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
  font-weight: normal;
}
.cp-register-invoice-tip {
  margin: 0 0 12px;
}
.cp-register-invoice-tip >>> .el-alert__title {
  font-weight: normal;
  line-height: 1.5;
}
.cp-register-invoice-section-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 6px;
}
.cp-register-invoice-right-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.cp-register-invoice-add-manual {
  padding: 0;
  font-weight: 500;
}
.cp-register-invoice-del {
  color: #f56c6c;
  padding: 0;
}
.cp-register-invoice-head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  color: #606266;
  font-size: 13px;
}
.cp-register-invoice-head.cp-register-invoice-head--party-line {
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: baseline;
  column-gap: 20px;
  row-gap: 6px;
}
.cp-register-invoice-head--party-line .cp-register-invoice-head-seg {
  flex: 0 0 auto;
  text-align: left;
}
</style>

<style>
/* 批量上传合同弹框 append-to-body，需全局样式保证表格列宽 */
.cp-batch-upload-contract-dialog .el-dialog__body {
  padding: 16px 20px 12px;
}
/* 结算端销售合同/客户签收单统一上传弹框（append-to-body） */
.cp-unified-upload-dialog .el-dialog__body {
  padding: 12px 20px 8px;
}
.cp-unified-upload-dialog .cp-unified-upload-title-wrap {
  padding-right: 28px;
}
.cp-unified-upload-dialog .cp-unified-upload-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  line-height: 1.3;
}
.cp-unified-upload-dialog .cp-unified-upload-sub {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
  font-weight: normal;
}
.cp-unified-upload-dialog .cp-unified-upload-section {
  margin-bottom: 16px;
}
.cp-unified-upload-dialog .cp-unified-upload-section-label {
  font-size: 13px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 4px;
}
.cp-unified-upload-dialog .cp-unified-upload-section-hint {
  font-size: 12px;
  color: #909399;
  margin-bottom: 8px;
}
.cp-unified-upload-dialog .cp-unified-upload-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 10px 12px;
  background: #f5f7fa;
  border-radius: 4px;
  max-height: 120px;
  overflow-y: auto;
}
.cp-unified-upload-dialog .cp-unified-upload-tag {
  margin: 0;
}
.cp-unified-upload-dialog .el-upload {
  width: 100%;
}
.cp-unified-upload-dialog .el-upload-dragger {
  width: 100%;
}
.cp-unified-upload-dialog .cp-unified-upload-file-card {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: #f5f7fa;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}
.cp-unified-upload-dialog .cp-unified-upload-file-icon {
  font-size: 22px;
  color: #409eff;
  flex-shrink: 0;
}
.cp-unified-upload-dialog .cp-unified-upload-file-info {
  flex: 1;
  min-width: 0;
}
.cp-unified-upload-dialog .cp-unified-upload-file-name {
  font-size: 13px;
  color: #303133;
  word-break: break-all;
  line-height: 1.4;
}
.cp-unified-upload-dialog .cp-unified-upload-file-meta {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}
.cp-unified-upload-dialog .cp-unified-upload-file-sep {
  margin: 0 6px;
  color: #dcdfe6;
}
.cp-unified-upload-dialog .cp-unified-upload-file-remove {
  font-size: 14px;
  color: #909399;
  cursor: pointer;
  flex-shrink: 0;
  padding: 4px;
}
.cp-unified-upload-dialog .cp-unified-upload-file-remove:hover {
  color: #f56c6c;
}
.cp-batch-upload-contract-dialog .cp-batch-upload-contract-table {
  width: 100%;
}
.cp-batch-upload-contract-dialog .cp-batch-upload-contract-table .el-input,
.cp-batch-upload-contract-dialog .cp-batch-upload-contract-table .el-date-editor.el-input {
  width: 100%;
}
/* append-to-body 时抽屉外壳不在 scoped 根下，样式对齐 cp-ledger-invoice-detail-drawer（集采进项/采购单台账） */
.cp-order-detail-drawer .el-drawer__header {
  margin-bottom: 0;
  padding: 16px 20px;
  border-bottom: 1px solid #e4e7ed;
  color: #303133;
  font-size: 16px;
  font-weight: 500;
}
.cp-order-detail-drawer .el-drawer__body {
  padding: 20px;
  box-sizing: border-box;
  overflow-y: auto;
  color: #303133;
  background: #fff;
}
.cp-order-detail-drawer .cp-detail-dialog-title-text {
  color: #303133;
  font-weight: 500;
}
.cp-order-detail-drawer .cp-detail-order-no {
  color: #333;
}
.cp-order-detail-drawer .cp-detail-meta-line,
.cp-order-detail-drawer .cp-detail-payment-summary-line {
  color: #303133;
}
.cp-order-detail-drawer .cp-detail-metric-num,
.cp-order-detail-drawer .cp-detail-metric-label {
  color: #333;
}
.cp-order-detail-drawer .cp-dg-label {
  background-color: #c8daf7;
  color: #333;
  border-color: #d9e3f2;
}
.cp-order-detail-drawer .cp-dg-val {
  color: #333;
  background: #fff;
  border-color: #d9e3f2;
}
.cp-order-detail-drawer .bill-table-head {
  color: #333;
}
/* 详情 Tab：card 样式与集采进项台账一致 */
.cp-order-detail-drawer .cp-ledger-content-tabs.el-tabs--card > .el-tabs__header {
  margin-bottom: 14px !important;
  border-bottom: 1px solid #005bf5 !important;
}
.cp-order-detail-drawer .cp-ledger-content-tabs.el-tabs--card > .el-tabs__header .el-tabs__nav {
  display: inline-flex;
  align-items: flex-end;
  border: none !important;
}
.cp-order-detail-drawer .cp-ledger-content-tabs.el-tabs--card > .el-tabs__header .el-tabs__item {
  min-width: 112px;
  height: 36px;
  line-height: 36px;
  padding: 0 22px;
  border: none;
  background-color: transparent;
  color: #606266;
  font-weight: 400;
  text-align: center;
}
.cp-order-detail-drawer .cp-ledger-content-tabs.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background-color: #005bf5;
  color: #fff;
  font-weight: 500;
  border-radius: 4px 4px 0 0;
}
/* 详情列表表头/表体：与全局 table-list、集采进项台账一致 */
.cp-order-detail-drawer .table-list.el-table thead th.el-table__cell {
  background-color: #c8daf7 !important;
  color: #333 !important;
  border-color: #d9e3f2 !important;
  font-weight: 500;
}
.cp-order-detail-drawer .table-list.el-table thead th.el-table__cell .cell {
  color: #333;
  font-weight: 500;
}
.cp-order-detail-drawer .table-list.el-table td.el-table__cell {
  color: #333;
  border-color: #eee;
}
.cp-order-detail-drawer .table-list.el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
  background: #fafafa;
}
.cp-order-detail-drawer .bill-table-head + .cp-detail-payment-summary-line + .el-table,
.cp-order-detail-drawer .bill-table-head + .el-table {
  margin-top: 15px;
}

/* 发票登记抽屉：宽度与 paymentSummaryLedger 的 PaymentDetailDrawer 一致（calc(100vw-210px)），布局同源 */
.cp-register-invoice-drawer.el-drawer {
  display: flex;
  flex-direction: column;
}
.cp-register-invoice-drawer .el-drawer__header {
  margin-bottom: 0;
  padding: 14px 20px 10px;
  border-bottom: 1px solid #ebeef5;
}
.cp-register-invoice-drawer.el-drawer .el-drawer__body {
  flex: 1;
  min-height: 0;
  padding: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
.cp-register-invoice-drawer-body {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: #fff;
  padding: 0;
  box-sizing: border-box;
}
.cp-register-invoice-drawer-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 16px 16px 12px;
}
.cp-register-invoice-drawer-footer {
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #fff;
  border-top: 1px solid #ebeef5;
  padding: 8px 12px;
  z-index: 5;
}
/* 登记发票抽屉表格：与 #content .table-list、platformInvoiceRegister 登记弹框一致（表头加粗、表体纯黑、字号与主列表一致） */
.cp-register-invoice-drawer .table-list.el-table {
  width: 100% !important;
  font-size: 14px;
  color: #333;
}
.cp-register-invoice-drawer .table-list.el-table .cell {
  line-height: 22px;
}
.cp-register-invoice-drawer .table-list.el-table thead th.el-table__cell {
  background-color: #c8daf7 !important;
  color: #333 !important;
  border-color: #d9e3f2 !important;
  font-weight: 700;
  font-size: 14px;
}
.cp-register-invoice-drawer .table-list.el-table thead th.el-table__cell .cell {
  color: #333;
  font-weight: 700;
  font-size: 14px;
}
.cp-register-invoice-drawer .table-list.el-table td.el-table__cell {
  color: #333;
  border-color: #eee;
  font-size: 14px;
}
.cp-register-invoice-drawer .table-list.el-table td.el-table__cell .cell {
  color: #333;
  font-size: 14px;
}
.cp-register-invoice-drawer .table-list.el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
  background: #fafafa;
}
.cp-register-invoice-drawer .table-list.el-table .el-input__inner,
.cp-register-invoice-drawer .table-list.el-table .el-input-number .el-input__inner,
.cp-register-invoice-drawer .table-list.el-table .el-date-editor .el-input__inner {
  color: #333;
  font-size: 14px;
}
.cp-register-invoice-drawer .table-list.el-table .el-input-number {
  width: 100%;
}
/* 表格外合计行：左对齐，与 platformInvoiceRegister 金额汇总区块习惯一致 */
.cp-register-invoice-drawer .cp-register-invoice-subtotal-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 12px 28px;
  margin-top: 10px;
  font-size: 14px;
  color: #606266;
}
.cp-register-invoice-drawer .cp-register-invoice-subtotal-row b {
  color: #303133;
  font-weight: 600;
}
/* 条形上传区：全宽与表格对齐 */
.cp-register-invoice-drawer .cp-register-invoice-upload-strip {
  width: 100%;
  margin: 0 0 12px;
  box-sizing: border-box;
}
.cp-register-invoice-drawer .cp-register-invoice-upload-strip .el-upload {
  display: block;
  width: 100%;
}
.cp-register-invoice-drawer .cp-register-invoice-upload-strip .el-upload-dragger {
  width: 100%;
  min-height: 58px;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px;
  border-radius: 4px;
  background: #f5f9fc;
  border: 1px dashed #b3c6d9;
}
.cp-register-invoice-drawer .cp-register-invoice-upload-strip .el-upload-dragger .el-icon-upload {
  margin: 0;
  font-size: 28px;
  line-height: 1;
  color: #409eff;
}
.cp-register-invoice-drawer .cp-register-invoice-upload-strip-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  width: 100%;
}
.cp-register-invoice-drawer .cp-register-invoice-upload-strip-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.cp-register-invoice-drawer .cp-register-invoice-upload-strip-text {
  font-size: 13px;
  color: #606266;
}
.cp-register-invoice-drawer .cp-register-invoice-upload-strip-sub {
  font-size: 12px;
  color: #909399;
  text-align: center;
  line-height: 1.4;
}

/* 集采订单导入弹窗：图标统一深蓝色调 */
.cp-import-dialog {
  --cp-import-icon-deep: #0d4a8c;
  --cp-import-icon-mid: #2a6bb5;
  --cp-import-icon-muted: #7a9ab8;
}
.cp-import-dialog .el-dialog__header {
  padding: 16px 20px 12px;
  border-bottom: 1px solid #ebeef5;
}
.cp-import-dialog .el-dialog__body {
  padding: 16px 20px;
}
.cp-import-dialog .el-dialog__footer {
  padding: 10px 20px 18px;
}
.cp-import-title {
  display: flex;
  align-items: center;
  gap: 12px;
}
.cp-import-title-icon {
  font-size: 22px;
  color: var(--cp-import-icon-deep);
  flex-shrink: 0;
}
.cp-import-title-main {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  line-height: 1.4;
}
.cp-import-title-sub {
  font-size: 12px;
  color: #909399;
  margin-top: 2px;
}
.cp-import-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.cp-import-step-title {
  font-size: 13px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
}
.cp-import-template-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  background: #f0f7ff;
  border: 1px solid #d4e8ff;
  border-radius: 6px;
}
.cp-import-template-info {
  display: flex;
  align-items: center;
  gap: 8px;
}
.cp-import-template-icon {
  font-size: 18px;
  color: var(--cp-import-icon-deep);
}
.cp-import-template-name {
  font-size: 13px;
  color: #303133;
}
.cp-import-drop {
  border: 1px dashed #c0c4cc;
  border-radius: 6px;
  padding: 28px 16px;
  text-align: center;
  background: #fafafa;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
  outline: none;
}
.cp-import-drop:hover,
.cp-import-drop.is-drag {
  border-color: var(--cp-import-icon-mid);
  background: #e8f1fa;
}
.cp-import-drop-icon {
  font-size: 36px;
  color: var(--cp-import-icon-muted);
}
.cp-import-drop:hover .cp-import-drop-icon,
.cp-import-drop.is-drag .cp-import-drop-icon {
  color: var(--cp-import-icon-deep);
}
.cp-import-drop-main {
  margin-top: 8px;
  font-size: 13px;
  color: #606266;
}
.cp-import-drop-sub {
  margin-top: 6px;
  font-size: 12px;
  color: #909399;
}
.cp-import-input-hidden {
  display: none;
}
.cp-import-file {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  background: #f5f7fa;
  border: 1px solid #ebeef5;
  border-radius: 6px;
}
.cp-import-file-icon {
  font-size: 18px;
  color: var(--cp-import-icon-deep);
}
.cp-import-file-name {
  flex: 1;
  font-size: 13px;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cp-import-file-size {
  font-size: 12px;
  color: #909399;
}
.cp-import-file-remove {
  font-size: 14px;
  color: #909399;
  cursor: pointer;
  padding: 2px;
}
.cp-import-file-remove:hover {
  color: #f56c6c;
}
.cp-import-tips {
  background: #fffbe6;
  border: 1px solid #faecb1;
  border-radius: 6px;
  padding: 10px 12px;
}
.cp-import-tips-title {
  font-size: 12px;
  color: #e6a23c;
  font-weight: 600;
  margin-bottom: 4px;
}
.cp-import-tips-title .el-icon-info {
  color: var(--cp-import-icon-deep);
}
.cp-import-tips-list {
  margin: 0;
  padding-left: 22px;
  font-size: 12px;
  color: #806020;
  line-height: 1.7;
}
.cp-import-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
}
</style>
